/**
 * opora-actionbar.js — unified tool action bar for Edge tools.
 *
 * SOW: mountSow() → floating dock (Copy / Save / Download PDF).
 * Edge AI docs: mountDock() on opora:tool-rendered — same dock chrome,
 * adapters per tool (PDF only when exports includes pdf).
 * Legacy mount() kept for flag+allowlist fallback.
 *
 * Delegates Save to window.OporaSave / guest staging.
 */
(function (w, d) {
  'use strict';

  function flagOn() { return !!(w.OPORA_FLAGS && w.OPORA_FLAGS.actionbar_v1); }

  /** Download filename stamp — prefers sitewide OporaFileStamp (always unique). */
  function fileStamp(d) {
    if (typeof w.OporaFileStamp === 'function') return w.OporaFileStamp(d);
    d = d instanceof Date ? d : new Date();
    function pad(n, width) {
      var s = String(n);
      while (s.length < (width || 2)) s = '0' + s;
      return s;
    }
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) +
      '_' + pad(d.getHours()) + pad(d.getMinutes()) + pad(d.getSeconds()) +
      '-' + pad(d.getMilliseconds(), 3);
  }

  /* Document-style Edge AI tools — floating dock quality bar (not SOW wizard logic) */
  var EDGE_DOCK_SLUGS = {
    'scope-of-work-generator': true,
    'bid-drafter': true,
    'rfp-decoder': true,
    'margin-sentinel': true,
    'compliance-agent': true,
    'hire-right': true,
    'handbook-drafter': true,
    'customer-recovery': true,
    'lost-bid-autopsy': true,
    'review-response': true,
    'walkthrough-voice': true
  };
  /* Tools where Download PDF is honest (real jsPDF file download) — not chatty Ask outputs */
  var EDGE_PDF_SLUGS = {
    'scope-of-work-generator': true,
    'bid-drafter': true,
    'rfp-decoder': true,
    'margin-sentinel': true,
    'compliance-agent': true,
    'hire-right': true,
    'handbook-drafter': true,
    'customer-recovery': true,
    'lost-bid-autopsy': true,
    'review-response': true,
    'walkthrough-voice': true
  };
  var PILOT_SLUGS = EDGE_DOCK_SLUGS;
  function isPilotSlug(slug) { return !!PILOT_SLUGS[slug]; }
  function isEdgeDockSlug(slug) { return !!EDGE_DOCK_SLUGS[slug]; }
  function toolAllowsPdf(slug, meta) {
    if (EDGE_PDF_SLUGS[slug]) return true;
    if (meta && meta.exports && meta.exports.indexOf && meta.exports.indexOf('pdf') !== -1) return true;
    return false;
  }

  /* ── tool inventory (fetched, with embedded fallback so timing never blocks) ── */
  var FALLBACK_TOOLS = {
    'scope-of-work-generator': {
      name: 'Scope of Work Generator', kind: 'scope_of_work',
      handoffs: [{ to: 'bid-drafter', label: 'Add to Bid Drafter', carry: ['square_footage', 'state', 'vertical'] }]
    },
    'margin-sentinel': { name: 'Margin Sentinel', kind: 'margin_analysis', handoffs: [
      { to: 'bid-drafter', label: 'Re-bid in Bid Drafter', carry: ['square_footage', 'state', 'vertical'] },
      { to: 'lost-bid-autopsy', label: 'Analyze a lost bid', carry: ['state', 'vertical'] }
    ] }
  };
  var TOOLS = FALLBACK_TOOLS;
  try {
    var cfgUrl = (w.OPORA_ACTIONBAR_TOOLS_URL) || null;
    var assetBase = (function () {
      var s = d.querySelector('script[src*="opora-actionbar.js"]');
      if (s && s.src) return s.src.replace(/opora-actionbar\.js.*$/, '');
      return '';
    })();
    if (!cfgUrl && assetBase) cfgUrl = assetBase + 'opora-actionbar-tools.json';
    if (cfgUrl) {
      fetch(cfgUrl, { credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { if (j && j.tools) TOOLS = Object.assign({}, FALLBACK_TOOLS, j.tools); })
        .catch(function () {});
    }
  } catch (e) {}

  function toolMeta(slug) { return TOOLS[slug] || { name: titleCase(slug), kind: 'document', handoffs: [] }; }

  function titleCase(s) {
    return String(s || '').replace(/[-_]/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function isSignedIn() { return !!(w.Clerk && w.Clerk.user); }

  /* ── Cross-tool guest lead email (PDF / email gates) ──
     Remember once → skip re-asking on SOW and any other tool that checks this. */
  var LEAD_EMAIL_LS = 'opora_lead_email';
  var LEAD_EMAIL_COOKIE = 'opora_lead_email';
  var LEAD_EMAIL_LEGACY = ['opora_sow_lead_email'];
  var LEAD_EMAIL_MAX_AGE = 365 * 24 * 60 * 60; /* 1 year */

  function _normalizeLeadEmail(email) {
    var e = String(email || '').trim().toLowerCase();
    if (!e || e.indexOf('@') === -1 || e.indexOf('.') === -1) return '';
    return e;
  }

  function _readCookie(name) {
    try {
      var match = d.cookie.match(
        new RegExp('(?:^|; )' + name.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1') + '=([^;]*)')
      );
      return match ? decodeURIComponent(match[1]) : '';
    } catch (e) { return ''; }
  }

  function _writeLeadEmailCookie(email) {
    try {
      var parts = [
        LEAD_EMAIL_COOKIE + '=' + encodeURIComponent(email),
        'path=/',
        'max-age=' + LEAD_EMAIL_MAX_AGE,
        'SameSite=Lax'
      ];
      if (w.location && w.location.protocol === 'https:') parts.push('Secure');
      var host = (w.location && w.location.hostname) || '';
      if (host === 'oporasupply.com' || host.slice(-16) === '.oporasupply.com') {
        parts.push('domain=.oporasupply.com');
      }
      d.cookie = parts.join('; ');
    } catch (eC) {}
  }

  function getLeadEmail() {
    var raw = '';
    try { raw = localStorage.getItem(LEAD_EMAIL_LS) || ''; } catch (e0) {}
    if (!raw) {
      for (var i = 0; i < LEAD_EMAIL_LEGACY.length; i++) {
        try {
          raw = localStorage.getItem(LEAD_EMAIL_LEGACY[i]) || '';
          if (raw) break;
        } catch (e1) {}
      }
    }
    if (!raw) raw = _readCookie(LEAD_EMAIL_COOKIE) || '';
    var email = _normalizeLeadEmail(raw);
    if (email && raw !== email) {
      /* migrate/normalize into the shared key */
      try { localStorage.setItem(LEAD_EMAIL_LS, email); } catch (e2) {}
      _writeLeadEmailCookie(email);
    }
    return email;
  }

  function rememberLeadEmail(email) {
    var normalized = _normalizeLeadEmail(email);
    if (!normalized) return '';
    try { localStorage.setItem(LEAD_EMAIL_LS, normalized); } catch (eL) {}
    try { localStorage.setItem('opora_sow_lead_email', normalized); } catch (eL2) {}
    _writeLeadEmailCookie(normalized);
    return normalized;
  }

  w.OporaLeadEmail = {
    get: getLeadEmail,
    remember: rememberLeadEmail,
    normalize: _normalizeLeadEmail
  };

  /* ── tiny toast ── */
  function toast(msg, type) {
    var t = d.createElement('div');
    t.setAttribute('role', 'status');
    t.setAttribute('aria-live', 'polite');
    t.textContent = msg;
    Object.assign(t.style, {
      position: 'fixed', bottom: '24px', right: '24px', zIndex: '9999',
      padding: '12px 20px', borderRadius: '10px', fontSize: '14px',
      fontFamily: 'Inter, sans-serif', maxWidth: '340px',
      background: type === 'error' ? '#C0392B' : '#01696f',
      color: '#fff', boxShadow: '0 4px 16px rgba(0,0,0,.18)',
      transition: 'opacity .3s', opacity: '1'
    });
    d.body.appendChild(t);
    setTimeout(function () {
      t.style.opacity = '0';
      setTimeout(function () { t.parentNode && t.parentNode.removeChild(t); }, 350);
    }, 3200);
  }

  /* ── state extraction from the rendered tool ── */
  function collectInputs() {
    var out = {};
    var nodes = d.querySelectorAll('[id^="opf_"]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var key = el.id.slice(4);
      if (!key || key.indexOf('__') !== -1) continue;
      if (el.type === 'checkbox' || el.type === 'radio') { if (el.checked) out[key] = el.value; }
      else if (el.value != null && el.value !== '') out[key] = el.value;
    }
    return out;
  }

  /* ── HTML → Markdown serializer ──────────────────────────────────────────
     Lets EVERY tool save a world-class deliverable: when a tool doesn't stash
     raw markdown, we reconstruct it from the rendered output (headings, tables,
     lists, bold/links) instead of flattening to plain text. */
  function _inlineMd(node) {
    var s = '';
    for (var i = 0; i < node.childNodes.length; i++) {
      var n = node.childNodes[i];
      if (n.nodeType === 3) { s += n.nodeValue.replace(/\s+/g, ' '); }
      else if (n.nodeType === 1) {
        var tag = n.nodeName.toLowerCase();
        if (tag === 'br') s += '\n';
        else if (tag === 'strong' || tag === 'b') s += '**' + _inlineMd(n).trim() + '**';
        else if (tag === 'em' || tag === 'i') s += '*' + _inlineMd(n).trim() + '*';
        else if (tag === 'code') s += '`' + n.textContent + '`';
        else if (tag === 'a') s += '[' + _inlineMd(n).trim() + '](' + (n.getAttribute('href') || '') + ')';
        else s += _inlineMd(n);
      }
    }
    return s;
  }
  function _listMd(node, ordered) {
    var items = [], idx = 1;
    for (var i = 0; i < node.children.length; i++) {
      if (node.children[i].nodeName.toLowerCase() === 'li') {
        var pre = ordered ? ((idx++) + '. ') : '- ';
        items.push(pre + _inlineMd(node.children[i]).replace(/\n+/g, ' ').trim());
      }
    }
    return items.join('\n');
  }
  function _factsMd(root) {
    var lines = [];
    var facts = root.querySelectorAll ? root.querySelectorAll('.ot-fact, dt') : [];
    if (root.classList && root.classList.contains('ot-fact')) {
      var dt0 = root.querySelector('dt');
      var dd0 = root.querySelector('dd');
      if (dt0 || dd0) {
        lines.push('- **' + _inlineMd(dt0 || { childNodes: [] }).trim() + ':** ' + _inlineMd(dd0 || { childNodes: [] }).trim());
      }
      return lines.join('\n');
    }
    if (root.nodeName && root.nodeName.toLowerCase() === 'dl') {
      var kids = root.children;
      for (var i = 0; i < kids.length; i++) {
        var kid = kids[i];
        if (kid.classList && kid.classList.contains('ot-fact')) {
          var dt = kid.querySelector('dt');
          var dd = kid.querySelector('dd');
          lines.push('- **' + _inlineMd(dt || { childNodes: [] }).trim() + ':** ' + _inlineMd(dd || { childNodes: [] }).trim());
        } else if (kid.nodeName.toLowerCase() === 'dt') {
          var label = _inlineMd(kid).trim();
          var val = '';
          var next = kids[i + 1];
          if (next && next.nodeName.toLowerCase() === 'dd') { val = _inlineMd(next).trim(); i++; }
          lines.push('- **' + label + ':** ' + val);
        }
      }
      return lines.join('\n');
    }
    for (var f = 0; f < facts.length; f++) {
      var el = facts[f];
      if (el.nodeName.toLowerCase() === 'dt') continue;
      if (el.classList && el.classList.contains('ot-fact')) {
        var d1 = el.querySelector('dt');
        var d2 = el.querySelector('dd');
        lines.push('- **' + _inlineMd(d1 || { childNodes: [] }).trim() + ':** ' + _inlineMd(d2 || { childNodes: [] }).trim());
      }
    }
    return lines.join('\n');
  }
  function _tableMd(table) {
    var rows = [], head = [];
    var ths = table.querySelectorAll('thead th');
    for (var i = 0; i < ths.length; i++) head.push(_inlineMd(ths[i]).replace(/\|/g, '\\|').trim());
    if (!head.length) { var ftr = table.querySelector('tr'); if (ftr) { for (var j = 0; j < ftr.children.length; j++) head.push(_inlineMd(ftr.children[j]).trim()); } }
    if (!head.length) return '';
    rows.push('| ' + head.join(' | ') + ' |');
    rows.push('| ' + head.map(function () { return '---'; }).join(' | ') + ' |');
    var trs = table.querySelectorAll('tbody tr');
    for (var r = 0; r < trs.length; r++) {
      var cells = [], tds = trs[r].children;
      for (var c = 0; c < tds.length; c++) cells.push(_inlineMd(tds[c]).replace(/\|/g, '\\|').replace(/\n+/g, ' ').trim());
      rows.push('| ' + cells.join(' | ') + ' |');
    }
    return rows.join('\n');
  }
  function htmlToMd(root) {
    var blocks = [];
    for (var i = 0; i < root.childNodes.length; i++) {
      var n = root.childNodes[i];
      if (n.nodeType === 3) { var tt = n.nodeValue.trim(); if (tt) blocks.push(tt); continue; }
      if (n.nodeType !== 1) continue;
      var tag = n.nodeName.toLowerCase();
      if (/^h[1-6]$/.test(tag)) { var lvl = Math.min(parseInt(tag.charAt(1), 10), 4); var ht = _inlineMd(n).trim(); if (ht) blocks.push(new Array(lvl + 1).join('#') + ' ' + ht); }
      else if (tag === 'table') { blocks.push(_tableMd(n)); }
      else if (tag === 'ul') { blocks.push(_listMd(n, false)); }
      else if (tag === 'ol') { blocks.push(_listMd(n, true)); }
      else if (tag === 'dl') { var facts = _factsMd(n); if (facts) blocks.push(facts); }
      else if (tag === 'hr') { blocks.push('---'); }
      else if (tag === 'blockquote') { blocks.push(_inlineMd(n).trim().split('\n').map(function (l) { return '> ' + l; }).join('\n')); }
      else if (n.classList && n.classList.contains('ot-wp-hero')) {
        var score = n.querySelector('.ot-wp-score');
        var reason = n.querySelector('.ot-wp-reasoning');
        var label = n.querySelector('.ot-wp-label');
        var hero = '## ' + ((score && score.textContent) || '').trim() + '% ' + ((label && label.textContent) || 'Win probability').trim();
        blocks.push(hero);
        if (reason && reason.textContent.trim()) blocks.push(reason.textContent.trim());
      }
      else if (n.classList && n.classList.contains('ot-fact')) {
        var fm = _factsMd(n); if (fm) blocks.push(fm);
      }
      else if (tag === 'p' || tag === 'div' || tag === 'section') {
        var tbl = n.querySelector && n.querySelector('table');
        var dl = n.querySelector && n.querySelector('dl.ot-facts, dl');
        if (tbl) {
          var titleEl = n.querySelector('h1,h2,h3,h4,.ot-card-title');
          if (titleEl) blocks.push('### ' + _inlineMd(titleEl).trim());
          blocks.push(_tableMd(tbl));
        } else if (dl) {
          var titleEl2 = n.querySelector('h1,h2,h3,h4,.ot-card-title');
          if (titleEl2) blocks.push('### ' + _inlineMd(titleEl2).trim());
          var fm2 = _factsMd(dl); if (fm2) blocks.push(fm2);
          var extra = n.querySelector('p, ul, ol');
          if (extra && !dl.contains(extra)) {
            if (extra.nodeName.toLowerCase() === 'ul') blocks.push(_listMd(extra, false));
            else if (extra.nodeName.toLowerCase() === 'ol') blocks.push(_listMd(extra, true));
            else { var px = _inlineMd(extra).trim(); if (px) blocks.push(px); }
          }
        } else {
          var hasBlock = n.querySelector && n.querySelector('h1,h2,h3,h4,h5,h6,ul,ol,table,blockquote,hr,dl,.ot-wp-hero,.ot-fact');
          if (hasBlock) { var inner = htmlToMd(n); if (inner) blocks.push(inner); }
          else { var p = _inlineMd(n).replace(/[ \t]+\n/g, '\n').replace(/\n/g, '  \n').trim(); if (p) blocks.push(p); }
        }
      }
      else { var x = _inlineMd(n).trim(); if (x) blocks.push(x); }
    }
    return blocks.join('\n\n').replace(/\n{3,}/g, '\n\n').trim();
  }

  function _mdVal(v) {
    if (v == null || v === '') return '';
    if (typeof v === 'object') {
      if (v.summary) return String(v.summary);
      try { return JSON.stringify(v); } catch (e) { return ''; }
    }
    return String(v);
  }
  function _mdFactLines(pairs) {
    var out = [];
    for (var i = 0; i < pairs.length; i++) {
      var label = pairs[i][0], val = _mdVal(pairs[i][1]);
      if (!val) continue;
      out.push('- **' + label + ':** ' + val);
    }
    return out;
  }
  function rfpDecoderToMarkdown(data) {
    if (!data || typeof data !== 'object') return '';
    var lines = [];
    var wp = data.win_probability || {};
    var gng = data.go_no_go || {};
    if (wp.score != null || wp.reasoning) {
      lines.push('## ' + (wp.score != null ? wp.score : '—') + '% Win probability');
      if (wp.reasoning) lines.push(wp.reasoning);
      if (gng.recommendation) lines.push('**Go / no-go:** ' + gng.recommendation + (gng.rationale ? ' — ' + gng.rationale : ''));
      if (gng.blockers && gng.blockers.length) lines.push('**Contingent on:** ' + gng.blockers.join('; '));
      lines.push('');
    }
    var m = data.solicitation_meta || {};
    var snap = _mdFactLines([
      ['Solicitation #', m.solicitation_number],
      ['Agency', [m.agency, m.sub_agency].filter(Boolean).join(' — ')],
      ['NAICS / size standard', [m.naics, m.size_standard].filter(Boolean).join(' · ')],
      ['Set-aside', m.set_aside],
      ['Contract type', m.contract_type || data.contract_type],
      ['Place of performance', m.place_of_performance],
      ['Period of performance', m.period_of_performance],
      ['Estimated value / ceiling', m.estimated_value],
      ['Bid type', m.bid_type],
      ['Response deadline', m.response_deadline]
    ]);
    if (snap.length) { lines.push('### Solicitation snapshot'); lines = lines.concat(snap); lines.push(''); }
    if (data.compliance_alerts && data.compliance_alerts.length) {
      lines.push('### Compliance alerts');
      data.compliance_alerts.forEach(function (a) {
        if (a && typeof a === 'object') lines.push('- **' + (a.rule || a.title || 'Alert') + ':** ' + (a.description || ''));
        else lines.push('- ' + a);
      });
      lines.push('');
    }
    if (data.scope_summary) { lines.push('### Scope summary'); lines.push(data.scope_summary); lines.push(''); }
    var ps = data.priceable_scope || {};
    var psLines = _mdFactLines([
      ['Total cleanable sq ft', ps.sqft_total != null ? (Number(ps.sqft_total).toLocaleString() + ' sq ft') : ''],
      ['Service hours', ps.service_hours],
      ['After-hours work', ps.after_hours_detail || (ps.after_hours === true ? 'Yes' : ps.after_hours === false ? 'No' : '')],
      ['Surge support ceiling', typeof ps.surge_support === 'object' ? (ps.surge_support && ps.surge_support.summary) : ps.surge_support],
      ['Headcount estimate', ps.headcount_estimate_fte != null ? (ps.headcount_estimate_fte + ' FTE') : ''],
      ['Wage determination', ps.wage_determination],
      ['H&W fringe rate', ps.fringe_rate],
      ['Consumables (paper/soap)', ps.consumables_furnished_by],
      ['Equipment', ps.equipment_furnished_by],
      ['Floor care', ps.floor_care],
      ['Window cleaning', ps.window_cleaning],
      ['Pest control', ps.pest_control],
      ['Trash haul-off', ps.trash_haul_off],
      ['Snow / grounds', ps.snow_grounds]
    ]);
    if (psLines.length) { lines.push('### Priceable scope'); lines = lines.concat(psLines); lines.push(''); }
    if (ps.special_requirements && ps.special_requirements.length) {
      lines.push('**Special requirements**');
      ps.special_requirements.forEach(function (r) { lines.push('- ' + r); });
      lines.push('');
    }
    var wd = data.wage_determination || {};
    if (wd.number) {
      lines.push('### Federal wage floor');
      lines = lines.concat(_mdFactLines([
        ['Wage determination', 'WD ' + wd.number + (wd.revision != null ? (' Rev ' + wd.revision) : '')],
        ['State', wd.state],
        ['Fringe', wd.fringe]
      ]));
      if (wd.rates && wd.rates.length) {
        lines.push('');
        lines.push('| Occupation | Rate |');
        lines.push('| --- | --- |');
        wd.rates.forEach(function (r) {
          lines.push('| ' + (r.title || r.occupation || 'Rate') + ' | ' + (r.rate != null ? ('$' + r.rate) : (r.amount || '—')) + ' |');
        });
      }
      lines.push('');
    }
    if (data.red_flags && data.red_flags.length) {
      lines.push('### Red flags');
      data.red_flags.forEach(function (f) {
        lines.push('- **' + (f.severity || 'flag') + ':** ' + (f.issue || '') + (f.recommendation ? (' — ' + f.recommendation) : ''));
      });
      lines.push('');
    }
    if (wp.key_strengths && wp.key_strengths.length) {
      lines.push('### Strengths');
      wp.key_strengths.forEach(function (s) { lines.push('- ' + s); });
      lines.push('');
    }
    if (wp.key_gaps && wp.key_gaps.length) {
      lines.push('### Gaps to address');
      wp.key_gaps.forEach(function (g) { lines.push('- ' + g); });
      lines.push('');
    }
    if (data.clarifying_questions && data.clarifying_questions.length) {
      lines.push('### Questions to ask before bidding');
      data.clarifying_questions.forEach(function (q, idx) { lines.push((idx + 1) + '. ' + q); });
      lines.push('');
    }
    if (data.summary_markdown) { lines.push(data.summary_markdown); lines.push(''); }
    return lines.join('\n').replace(/\n{3,}/g, '\n\n').trim();
  }

  function marginSentinelToMarkdown(data) {
    if (!data || typeof data !== 'object') return '';
    var lines = [];
    var verdictMeta = {
      underbid: 'Underbid',
      overbid: 'Above Market',
      market: 'Market Rate',
      distorted: 'Scope Distortion',
      insufficient_data: 'Insufficient Data',
      service_initializing: 'Data Loading…'
    };
    var verdict = verdictMeta[data.verdict] || data.verdict || 'Margin Check';
    lines.push(verdict);
    lines.push('');

    /* Strip inline citation dumps — attribution lives in the single-line footer */
    function stripUrls(s) {
      return String(s == null ? '' : s)
        .replace(/\[[^\]]*?https?:\/\/[^\]]*?\]/gi, '')
        .replace(/\(https?:\/\/[^)]*\)/gi, '')
        .replace(/https?:\/\/[^\s)\]]+/gi, '')
        .replace(/\[([^\]\n]+)\]/g, '$1')
        .replace(/\s{2,}/g, ' ')
        .replace(/\s+([.,;:])/g, '$1')
        .replace(/[\s·\-–—]+$/g, '')
        .trim();
    }

    var bls = data.bls_wage_benchmark || {};
    var lc = data.labor_cost_implied || {};
    var issa = data.issa_production_band || { low: 2500, high: 3500 };
    function fmtRate(n, d) {
      if (n == null || isNaN(Number(n))) return '—';
      return '$' + Number(n).toFixed(d == null ? 4 : d);
    }
    function fmtPctLocal(n) {
      if (n == null || isNaN(Number(n))) return '—';
      var v = Number(n);
      return (v > 0 ? '+' : '') + v.toFixed(1) + '%';
    }
    var marginVal = data.gross_margin_pct != null ? (Number(data.gross_margin_pct).toFixed(1) + '%') : '—';
    var wageVal = lc.hourly_rate != null ? (fmtRate(lc.hourly_rate, 2) + '/hr') : '—';
    var wageSub = bls.hourly_median != null
      ? ('BLS ' + fmtRate(bls.hourly_median, 2) + '/hr · ' + fmtPctLocal(data.labor_rate_delta_from_bls_pct))
      : '';
    var prodVal = data.production_sqft_per_hr != null
      ? (Number(data.production_sqft_per_hr).toLocaleString() + ' sf/hr')
      : '—';
    var prodSub = 'ISSA ' + Number(issa.low).toLocaleString() + '-' + Number(issa.high).toLocaleString();
    var sqftVal = fmtRate(data.bid_per_sqft_monthly != null ? data.bid_per_sqft_monthly : data.bid_per_sqft, 4);
    var sqftSub = data.bid_per_sqft != null ? (fmtRate(data.bid_per_sqft, 4) + '/visit') : '';

    /* 4-up metric table: header / values / subtext — drawn as a real PDF table */
    lines.push('| GROSS MARGIN | WAGE VS BLS | PRODUCTION | $/SQ FT / MONTH |');
    lines.push('| --- | --- | --- | --- |');
    lines.push('| ' + marginVal + ' | ' + wageVal + ' | ' + prodVal + ' | ' + sqftVal + ' |');
    lines.push('|  | ' + wageSub + ' | ' + prodSub + ' | ' + sqftSub + ' |');
    lines.push('');

    if (data.wage_alerts && data.wage_alerts.length) {
      lines.push('Wage alerts');
      data.wage_alerts.forEach(function (wa) {
        lines.push('- ' + ((wa.level || 'alert').toUpperCase()) + ': ' + (wa.message || ''));
      });
      lines.push('');
    }

    if (data.alerts && data.alerts.length) {
      lines.push('Analysis');
      data.alerts.forEach(function (a) {
        var clean = stripUrls(a);
        if (clean) { lines.push(clean); lines.push(''); }
      });
    }

    var mb = data.metro_benchmark_per_sqft;
    if (mb) {
      lines.push('Industry Benchmark ($/sq ft per visit)');
      lines.push('Low ' + fmtRate(mb.low, 4) + '  ·  High ' + fmtRate(mb.high, 4) +
        (mb.median != null ? ('  ·  Median ' + fmtRate(mb.median, 4)) : ''));
      if (mb.source) {
        lines.push('Source: ' + stripUrls(mb.source));
      }
      lines.push('');
    }

    var rs = data.renegotiation_script;
    if (rs) {
      lines.push('Renegotiation Script');
      lines.push('');
      if (typeof rs === 'string') {
        lines.push(stripUrls(rs));
        lines.push('');
      } else {
        if (rs.opening_line) {
          lines.push('OPENING LINE');
          lines.push('"' + stripUrls(rs.opening_line) + '"');
          lines.push('');
        }
        if (rs.data_points && rs.data_points.length) {
          lines.push('USE THESE DATA POINTS');
          rs.data_points.forEach(function (dp) { lines.push('• ' + stripUrls(dp)); });
          lines.push('');
        }
        if (rs.objection_handlers && rs.objection_handlers.length) {
          lines.push('OBJECTION HANDLERS');
          rs.objection_handlers.forEach(function (oh) {
            lines.push('Objection: ' + stripUrls(oh.objection || ''));
            lines.push('Response: ' + stripUrls(oh.response || ''));
            lines.push('');
          });
        }
        if (rs.target_rate_ask) {
          lines.push('Target rate ask: ' + stripUrls(rs.target_rate_ask));
          lines.push('');
        }
      }
    }

    /* Discreet single-line attribution — no raw URL dumps */
    var stateCode = String(bls.state || '').trim().toUpperCase().replace(/[^A-Z]/g, '').slice(0, 2);
    lines.push('Data Sources: U.S. BLS OEWS SOC 37-2011' + (stateCode ? (' (' + stateCode + ')') : '') +
      '  ·  ISSA 447 / 612 Production Benchmarks  ·  BSCAI Industry Standards');

    return lines.join('\n').replace(/\n{3,}/g, '\n\n').trim();
  }

  /**
   * Lost Bid Autopsy — 3-module executive memo (matches on-screen .ot-lba-memo).
   * Hero scores + root cause · Financial & SOW · Rewrites & competitor tactics.
   * Omits Dual-CTA chrome and the old 8-card dump.
   */
  function lostBidAutopsyToMarkdown(data) {
    if (!data || typeof data !== 'object') return '';
    var lines = [];
    var o = data.win_probability_original != null ? Number(data.win_probability_original) : 0;
    var r = data.win_probability_revised != null ? Number(data.win_probability_revised) : 0;
    var pf = data.primary_failure || {};
    var pm = data.pricing_math || {};
    var sb = data.sow_boundary || {};
    var ca = data.competitor_analysis || null;

    lines.push('## ' + o + '% → ' + r + '% win odds');
    if (pf.category) lines.push('**Root cause:** ' + pf.category);
    var heroSum = pf.description || data.analysis || '';
    if (heroSum) lines.push(String(heroSum).trim());
    if (data.win_probability_basis) lines.push('_' + String(data.win_probability_basis).trim() + '_');
    lines.push('');

    lines.push('### Financial & SOW audit');
    lines.push('**Pricing scaffold**');
    lines.push('| Metric | Value |');
    lines.push('| --- | --- |');
    if (pm.effective_rate != null && !isNaN(Number(pm.effective_rate))) {
      lines.push('| Effective rate | $' + Number(pm.effective_rate).toFixed(2) + '/hr |');
    } else if (pm.loaded_crew_note) {
      lines.push('| Effective rate | ' + pm.loaded_crew_note + ' |');
    }
    if (pm.burden_band === 'cash_unburdened' || /cash\s*\/?\s*unburdened|NON-COMPLIANT\s*\(\s*Cash/i.test(String(pm.burden_label || pm.burden_audit || ''))) {
      lines.push('| Statutory load | ' + (pm.burden_label || 'NON-COMPLIANT · Cash / Unburdened') + ' |');
    } else if (pm.burden_band === 'ic_1099_misclass' || /1099|misclassification/i.test(String(pm.burden_label || pm.burden_audit || ''))) {
      lines.push('| Statutory load | ' + (pm.burden_label || 'NON-COMPLIANT · 1099 Worker Misclassification') + ' |');
    } else if (pm.burden_stated_pct != null) {
      lines.push('| Statutory load | ' + pm.burden_stated_pct + '%' + (pm.burden_band === 'compliant' ? ' · Compliant' : '') + ' |');
    } else if (pm.burden_label) {
      lines.push('| Statutory load | ' + pm.burden_label + ' |');
    }
    if (pm.production_sqft_hr != null) {
      lines.push('| Production rate | ' + Number(pm.production_sqft_hr).toLocaleString() + ' sq ft/hr |');
    } else if (pm.production_note) {
      lines.push('| Production rate | ' + pm.production_note + ' |');
    }
    var delta = (Number(r) - Number(o));
    if (!isNaN(delta)) lines.push('| Win odds delta | ' + (delta > 0 ? '+' : '') + delta + '% |');
    if (pm.verdict) lines.push('');
    if (pm.verdict) lines.push('**Verdict:** ' + pm.verdict);
    lines.push('');
    lines.push('**SOW boundary**');
    var baseItems = (sb.included_in_base && sb.included_in_base.length)
      ? sb.included_in_base
      : (sb.routine_scope ? [sb.routine_scope] : []);
    var billItems = (sb.separated_billback && sb.separated_billback.length)
      ? sb.separated_billback
      : (sb.periodic_carveouts || []);
    billItems = (billItems || []).filter(function (x) {
      var t = String(x || '');
      return t.length > 0 && t.length <= 180 && !/routine base janitorial covers only/i.test(t);
    });
    lines.push('*Included in base*');
    if (baseItems.length) baseItems.slice(0, 5).forEach(function (x) { lines.push('- ' + x); });
    else lines.push('- Nightly / daily routine janitorial');
    lines.push('*Separated as bill-back / excluded*');
    if (billItems.length) billItems.slice(0, 5).forEach(function (x) { lines.push('- ' + x); });
    else lines.push('- Periodic / restorative work billed per occurrence');
    lines.push('');

    lines.push('### Rewritten contract schedules');
    if (data.rewrites && data.rewrites.length) {
      data.rewrites.slice(0, 3).forEach(function (rw) {
        lines.push('**' + (rw.section || 'Rewrite') + '**');
        if (rw.suggested) lines.push(String(rw.suggested).trim());
        else if (rw.original) lines.push('(Was: ' + String(rw.original).trim() + ')');
        if (rw.reasoning) lines.push('_' + String(rw.reasoning).trim() + '_');
        lines.push('');
      });
    } else {
      lines.push('Carve periodic / restorative work to separate bill-back lines.');
      lines.push('');
    }
    if (ca && ca.company_name) {
      lines.push('**Competitor counter-play — ' + ca.company_name + '**');
      if (ca.likely_pricing_strategy) lines.push(ca.likely_pricing_strategy);
      var diffs = (ca.how_to_differentiate && ca.how_to_differentiate.length)
        ? ca.how_to_differentiate
        : (ca.likely_strengths || []);
      diffs.slice(0, 4).forEach(function (x) { lines.push('- ' + x); });
      lines.push('');
    }

    return lines.join('\n').replace(/\n{3,}/g, '\n\n').trim();
  }

  function hireMoneyBand(lo, hi, dec) {
    function one(n) {
      if (n == null || isNaN(Number(n))) return null;
      var x = Number(n);
      var d = dec != null ? dec : (Math.abs(x - Math.round(x)) < 1e-6 ? 0 : 2);
      return '$' + x.toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d });
    }
    var a = one(lo), b = one(hi);
    if (a && b) return a + ' – ' + b;
    return a || b || '—';
  }

  function hireRightMeta(data) {
    data = data || {};
    function field(id) {
      var el = d.getElementById(id);
      return el && el.value != null ? String(el.value).trim() : '';
    }
    var company = data.brand_name || data.company ||
      (data.business_profile && data.business_profile.brand_name) ||
      field('opf_brand') || field('opf_brand_name') || 'Hiring company';
    var role = data.role_title || data.role || field('opf_role') || 'Cleaning role';
    var state = String(data.state || (data.business_profile && data.business_profile.state) ||
      field('opf_state') || '').trim().toUpperCase();
    var metro = String(data.metro || data.city || field('opf_city') || '').trim();
    var cite = (data.compensation_analysis && data.compensation_analysis.bls_citation) || '';
    if (!metro && cite) {
      var mm = String(cite).match(
        /(?:MSA|metro|area|for)\s*[:\-]?\s*([A-Za-z][A-Za-z .\-\/]+(?:,\s*[A-Z]{2})?)/i
      );
      if (!mm) mm = String(cite).match(/([A-Za-z][A-Za-z .\-]+\/[A-Za-z .\-]+(?:,\s*[A-Z]{2})?)/);
      if (mm) metro = mm[1].replace(/\s*(BLS|OEWS|May).*$/i, '').trim();
    }
    return { company: company, role: role, state: state, metro: metro };
  }

  function resolveHireRightData(detail) {
    detail = detail || {};
    var data = detail.data;
    if (data && typeof data === 'object' && (
      data.job_description_markdown || data.compensation_analysis ||
      (data.interview_questions && data.interview_questions.length) ||
      data.onboarding_plan_markdown
    )) {
      return data;
    }
    try {
      var el = (detail.outputEl) || d.getElementById('opResult') || d.getElementById('opDocBody');
      if (el && el._hireData && typeof el._hireData === 'object') return el._hireData;
      if (el && el._oporaHireData && typeof el._oporaHireData === 'object') return el._oporaHireData;
      var doc = d.getElementById('opDocBody');
      if (doc && doc._hireData && typeof doc._hireData === 'object') return doc._hireData;
    } catch (eR) {}
    return data && typeof data === 'object' ? data : null;
  }

  /**
   * Hire Right — full hiring package markdown (all modules, not active tab only).
   */
  function hireRightToMarkdown(data) {
    if (!data || typeof data !== 'object') return '';
    var meta = hireRightMeta(data);
    var ca = data.compensation_analysis || {};
    var cr = data.classification_recommendation || {};
    var lines = [];
    lines.push('# Hiring & Compensation Brief: ' + meta.role);
    lines.push('Prepared for ' + meta.company + (meta.metro ? (' · ' + meta.metro) : '') + (meta.state ? (', ' + meta.state) : ''));
    lines.push('');
    lines.push('## Compensation & statutory stack');
    lines.push('- **Base:** ' + hireMoneyBand(ca.range_low, ca.range_high, 0) + '/hr');
    if (ca.loaded_low != null || ca.loaded_high != null) {
      lines.push('- **Loaded' + (meta.state ? (' (' + meta.state + ')') : '') + ':** ' +
        hireMoneyBand(ca.loaded_low, ca.loaded_high, 0) + '/hr' +
        (ca.burden_pct != null ? (' (+' + ca.burden_pct + '% statutory)') : ''));
    }
    if (ca.ot_low != null || ca.ot_high != null) {
      lines.push('- **FLSA OT (1.5×):** ' + hireMoneyBand(ca.ot_low, ca.ot_high, 2) + '/hr');
    }
    if (ca.loaded_breakdown) lines.push('- **Stack:** ' + ca.loaded_breakdown);
    if (ca.reasoning) { lines.push(''); lines.push(ca.reasoning); }
    if (ca.bls_citation) lines.push('_' + ca.bls_citation + '_');
    lines.push('');
    if (cr.w2_or_1099 || cr.reasoning || cr.state_specific_risks) {
      lines.push('## Worker classification');
      if (cr.w2_or_1099) lines.push('**' + cr.w2_or_1099 + '**');
      if (cr.reasoning) lines.push(cr.reasoning);
      if (cr.state_specific_risks) lines.push('**State risk:** ' + cr.state_specific_risks);
      lines.push('');
    }
    if (data.job_description_markdown) {
      lines.push('## Job description');
      lines.push(String(data.job_description_markdown).trim());
      lines.push('');
    }
    var qs = Array.isArray(data.interview_questions) ? data.interview_questions : [];
    if (qs.length) {
      lines.push('## Vetting & interview guide');
      qs.slice(0, 8).forEach(function (q, i) {
        lines.push((i + 1) + '. **' + (q.question || 'Question') + '**');
        if (q.why_we_ask) lines.push('   - Why we ask: ' + q.why_we_ask);
        if (q.what_to_listen_for) lines.push('   - Listen for: ' + q.what_to_listen_for);
      });
      lines.push('');
    }
    if (data.onboarding_plan_markdown) {
      lines.push('## 30 / 60 / 90 day milestones');
      lines.push(String(data.onboarding_plan_markdown).trim());
      lines.push('');
    }
    var flags = Array.isArray(data.red_flags_to_avoid) ? data.red_flags_to_avoid : [];
    if (flags.length) {
      lines.push('## Disqualification triggers');
      flags.forEach(function (f) { lines.push('- ' + f); });
      lines.push('');
    }
    return lines.join('\n').replace(/\n{3,}/g, '\n\n').trim();
  }

  // Clone the rendered output and strip UI chrome that must never land in a saved doc / PDF
  function serializeOutput(node) {
    if (!node) return '';
    var clone = node.cloneNode(true);
    var chrome = clone.querySelectorAll([
      '.opora-ab',
      '.opora-thread-rail',
      '.opora-d4-save-bar',
      '.ot-save-bar',
      '.ot-toolbar',
      '.opora-export-btn',
      '.calc-d4-export-row',
      '.ot-export-bar',
      '.ot-wire-rail',
      '.opora-edge-wc-band',
      '.d4-sow-wc-band',
      '.opora-trust-note',
      '.ot-ask-handoff-slot',
      '.ot-bd-estimator',
      '[data-bd-estimator]',
      '.ot-price-card',
      '.bd-pdf-cover',
      '.bd-internal-barrier',
      '[data-pdf-exclude]',
      '.calc-d4-so-what',
      '.calc-d4-trust',
      '.calc-d4-primary-handoff',
      '.calc-d4-secondary-ask',
      '.calc-d4-primary-secondary',
      '.ot-ask-handoff-btn',
      '.ot-ask-handoff-slot',
      '[data-ask-handoff-target]',
      '.bd-edit-hint',
      '.ot-handoffs',
      'script',
      'style',
      'button',
      'a.calc-d4-primary-cta'
    ].join(','));
    for (var i = 0; i < chrome.length; i++) { if (chrome[i].parentNode) chrome[i].parentNode.removeChild(chrome[i]); }
    var md = '';
    try { md = htmlToMd(clone); } catch (e) {}
    return md;
  }

  function looksLikeBidUiChrome(text) {
    var t = String(text || '');
    return /MARKET RANGE\s*\(BLS-ANCHORED\)/i.test(t) ||
      /SUGGESTED RANGE/i.test(t) ||
      /PREVAILING WAGE/i.test(t) ||
      /Ask Opora about this/i.test(t);
  }

  function proposalOnlyFromDom() {
    var docBody = d.getElementById('opDocBody');
    if (!docBody) return '';
    var mdNode = docBody.querySelector('.ot-markdown-output');
    if (mdNode) {
      var fromMd = (mdNode.innerText || mdNode.textContent || '').trim();
      if (fromMd) return fromMd;
    }
    /* Never serialize #opResult / estimator / Dual-CTA — only the proposal subtree */
    var inner = docBody.querySelector('.ot-output-inner') || docBody;
    var clone = inner.cloneNode(true);
    var chrome = clone.querySelectorAll(
      '[data-bd-estimator], .ot-bd-estimator, .ot-price-card, .bd-pdf-cover, ' +
      '.bd-internal-barrier, [data-pdf-exclude], .ot-ask-handoff-btn, ' +
      '.ot-ask-handoff-slot, [data-ask-handoff-target], .calc-d4-secondary-ask, ' +
      '.bd-edit-hint, button, .ot-wire-rail, .opora-ab'
    );
    for (var i = 0; i < chrome.length; i++) {
      if (chrome[i].parentNode) chrome[i].parentNode.removeChild(chrome[i]);
    }
    return (clone.innerText || clone.textContent || '').trim();
  }

  function bodyMarkdown(detail) {
    var slug = (detail && detail.slug) || '';
    if (slug === 'rfp-decoder' && detail.data) {
      var structured = rfpDecoderToMarkdown(detail.data);
      if (structured && structured.length > 80) return structured;
    }
    if (slug === 'margin-sentinel' && detail.data) {
      var msMd = marginSentinelToMarkdown(detail.data);
      if (msMd && msMd.length > 40) return msMd;
    }
    if (slug === 'lost-bid-autopsy' && detail.data) {
      var lbaMd = lostBidAutopsyToMarkdown(detail.data);
      if (lbaMd && lbaMd.length > 40) return lbaMd;
    }
    if (slug === 'hire-right') {
      var hireData = resolveHireRightData(detail);
      if (hireData) {
        var hrMd = hireRightToMarkdown(hireData);
        if (hrMd && hrMd.length > 40) return hrMd;
      }
    }

    /* Bid Drafter: proposal markdown ONLY — never estimator cards or Ask CTAs */
    if (slug === 'bid-drafter') {
      if (detail && detail.data && detail.data.proposal_markdown) {
        var apiMd = String(detail.data.proposal_markdown).trim();
        if (apiMd.length > 40 && !looksLikeBidUiChrome(apiMd)) return apiMd;
      }
      var docBodyBd = d.getElementById('opDocBody');
      if (docBodyBd && docBodyBd.dataset) {
        var stash = docBodyBd.dataset.proposalMd || docBodyBd.dataset.rawText || '';
        if (stash && !looksLikeBidUiChrome(stash)) return stash;
      }
      var domOnly = proposalOnlyFromDom();
      if (domOnly) return domOnly;
    }

    /* Prefer proposal body only — never pull WC/CTA chrome from #opResult */
    var docBody = d.getElementById('opDocBody');
    if (docBody && docBody.dataset && docBody.dataset.rawText && !looksLikeBidUiChrome(docBody.dataset.rawText)) {
      return docBody.dataset.rawText;
    }
    if (detail && detail.data) {
      var rawMd = detail.data.proposal_markdown || detail.data.scope_markdown ||
        detail.data.handbook_markdown || detail.data.recovery_plan || detail.data.analysis || '';
      if (rawMd && String(rawMd).trim().length > 40) return String(rawMd).trim();
    }
    // Prefer raw markdown the tool stashed on its output element (keeps headings/tables/lists)
    var out = detail.outputEl;
    if (out && out.dataset && out.dataset.rawText && !looksLikeBidUiChrome(out.dataset.rawText)) {
      return out.dataset.rawText;
    }
    if (docBody) {
      var contentNode = (docBody.querySelector && (docBody.querySelector('.ot-markdown-output') || docBody.querySelector('.ot-output-inner'))) || docBody;
      var mdDoc = serializeOutput(contentNode);
      if (mdDoc && !looksLikeBidUiChrome(mdDoc)) return mdDoc;
      var txtDoc = proposalOnlyFromDom();
      if (txtDoc) return txtDoc;
    }
    var node = detail.container;
    if (node) {
      // Reconstruct markdown from the rendered output (preserves tables/lists/headings)
      var contentNode2 = (node.querySelector && (node.querySelector('.ot-markdown-output') || node.querySelector('#opDocBody .ot-output-inner') || node.querySelector('#opDocBody'))) || null;
      if (contentNode2) {
        var md = serializeOutput(contentNode2);
        if (md) return md;
        var txt = (contentNode2.innerText || contentNode2.textContent || '').trim();
        if (txt && !looksLikeBidUiChrome(txt)) return txt;
      }
    }
    try { return JSON.stringify(detail.data, null, 2); } catch (e) { return ''; }
  }

  function buildTitle(slug, data, inputs) {
    var meta = toolMeta(slug);
    var name = meta.name;
    var now = new Date();
    var timeBit = now.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
    var dateBit = now.toISOString().slice(0, 10);
    // Standard across all tools: "Tool Name — YYYY-MM-DD · h:mm AM/PM"
    return name + ' — ' + dateBit + ' · ' + timeBit;
  }

  function snapshot(detail) {
    var slug = detail.slug;
    var data = detail.data || {};
    var inputs = collectInputs();
    var md = bodyMarkdown(detail);
    return {
      slug: slug,
      data: data,
      inputs: inputs,
      title: buildTitle(slug, data, inputs),
      payload: {
        title: buildTitle(slug, data, inputs),
        body_markdown: md,
        content: md,
        input_payload: inputs,
        metadata: { source: 'tool_page', kind: toolMeta(slug).kind, outputs: data, schema_version: 1 }
      }
    };
  }

  /* ── guest stash (mirrors opora-artifact-save.js keys so its auto-resume picks it up) ── */
  function stashPending(slug, payload) {
    var copy = Object.assign({}, payload);
    var md = copy.body_markdown || copy.content || '';
    if (md.length > 12000) { copy.body_markdown = md.slice(0, 12000); copy.content = copy.body_markdown; }
    try { sessionStorage.setItem('opora_pending_save_d4', JSON.stringify({ toolSlug: slug, payload: copy })); } catch (e) {}
    try {
      var data = { toolSlug: slug, payload: copy, ts: Date.now() };
      var json = JSON.stringify(data);
      if (json.length > 3800) {
        copy.body_markdown = (md).slice(0, 800); copy.content = copy.body_markdown;
        json = JSON.stringify({ toolSlug: slug, payload: copy, ts: Date.now() });
      }
      d.cookie = 'opora_pending_save=' + encodeURIComponent(json) +
        '; path=/; domain=.oporasupply.com; max-age=900; SameSite=Lax; Secure';
    } catch (e2) {}
  }

  /* Stage the full result server-side and drop a small token cookie so the
     dashboard can finalize the save after auth — no cookie-size limit and no
     dependency on this (possibly stale) tool page after redirect. */
  function stagePendingToken(slug, payload) {
    try {
      var api = ((w.OporaEdge && w.OporaEdge.WORKER_URL) || w.OPORA_WORKER_URL || 'https://api.oporasupply.com').replace(/\/$/, '');
      var md = (payload && (payload.body_markdown || payload.content)) || '';
      if (!md) return Promise.resolve(false);
      var body = {
        tool: slug,
        tool_slug: slug,
        title: (payload && payload.title) || '',
        body_markdown: md,
        content: md,
        input_payload: (payload && payload.input_payload) || {},
        metadata: (payload && payload.metadata) || {}
      };
      return fetch(api + '/api/artifacts/pending', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (j) {
        var token = j && (j.token || (j.data && j.data.token));
        if (token) {
          d.cookie = 'opora_pending_token=' + encodeURIComponent(token) +
            '; path=/; domain=.oporasupply.com; max-age=3600; SameSite=Lax; Secure';
          return true;
        }
        return false;
      }).catch(function () { return false; });
    } catch (e) { return Promise.resolve(false); }
  }

  function signInRedirect(intent, opts) {
    opts = opts || {};
    try {
      if (opts.returnToTool) {
        d.cookie = 'opora_post_save_dest=; path=/; domain=.oporasupply.com; max-age=0; Secure';
      } else {
        d.cookie = 'opora_post_save_dest=files; path=/; domain=.oporasupply.com; max-age=900; SameSite=Lax; Secure';
      }
    } catch (e0) {}
    if (w.OporaEdge && typeof w.OporaEdge.stashAuthReturn === 'function') w.OporaEdge.stashAuthReturn();
    else { try { sessionStorage.setItem('_opora_auth_return', w.location.href); } catch (e) {} }
    var intentKey = intent || 'sign-up';
    var url = (w.OporaEdge && typeof w.OporaEdge.dashboardAuthUrl === 'function')
      ? w.OporaEdge.dashboardAuthUrl(intentKey)
      : (intentKey === 'sign-up' || intentKey === 'signup'
        ? 'https://dashboard.oporasupply.com/?intent=sign-up'
        : 'https://dashboard.oporasupply.com/');
    w.location.href = url;
  }

  /* Stage only — keep user on the tool for in-place auth modal */
  function stageGuestSave(slug, payload) {
    stashPending(slug, payload);
    return stagePendingToken(slug, payload);
  }

  /* Guest save: stage server-side, then go authenticate. Redirect waits briefly
     for the token POST so the dashboard can claim it. */
  function guestSaveThenAuth(slug, payload, intent, opts) {
    opts = opts || {};
    stashPending(slug, payload);
    var done = false;
    function go() {
      if (done) return;
      done = true;
      signInRedirect(intent || 'sign-up', opts);
    }
    var p = stagePendingToken(slug, payload);
    // Redirect as soon as the token cookie is set; cap the wait so a slow/cold
    // worker + CORS preflight can still finish before we leave the page.
    setTimeout(go, 4000);
    if (p && typeof p.then === 'function') p.then(go, go);
    else go();
  }

  /* Same mechanism as SOW Save (opora-tool-scope.js openSaveModal):
     stage pending → OporaAuth.openModal({ inPlace: true, onAuthed }).
     Full-page dashboard redirect only if OporaAuth is missing. */
  function openGuestSaveInPlace(slug, payload, opts) {
    opts = opts || {};
    stageGuestSave(slug, payload);
    try {
      if (opts.returnToTool) {
        d.cookie = 'opora_post_save_dest=; path=/; domain=.oporasupply.com; max-age=0; Secure';
      }
    } catch (e0) {}
    function openNow() {
      if (w.OporaAuth && typeof w.OporaAuth.openModal === 'function' && !w.OporaAuth.__oporaStub) {
        w.OporaAuth.openModal({
          intent: opts.intent || 'sign-up',
          inPlace: true,
          title: opts.title || 'Save this result',
          tagline: opts.tagline || 'Create a free account to edit, duplicate, and access this result across devices.',
          onAuthed: typeof opts.onAuthed === 'function' ? opts.onAuthed : null
        });
        return true;
      }
      guestSaveThenAuth(slug, payload, opts.intent || 'sign-up', opts);
      return false;
    }
    /* Perf theme lazy-loads auth modal + Clerk — warm before paint so Save isn't stuck */
    try {
      var warm = warmAuthForSave();
      if (warm && typeof warm.then === 'function') {
        warm.then(openNow, openNow);
        return true;
      }
    } catch (e1) {}
    return openNow();
  }

  /* ── small DOM helpers ── */
  function el(tag, cls, attrs) {
    var n = d.createElement(tag);
    if (cls) n.className = cls;
    if (attrs) for (var k in attrs) { if (attrs.hasOwnProperty(k)) n.setAttribute(k, attrs[k]); }
    return n;
  }
  var ICON = {
    save: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><polyline points="20 6 9 17 4 12"/></svg>',
    share: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"/></svg>',
    download: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3"/></svg>',
    reset: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 2v6h6"/><path d="M3.5 8a9 9 0 1 0 2.1-3.4L3 8"/></svg>',
    more: '<svg viewBox="0 0 24 24" fill="currentColor"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></svg>',
    lock: '<svg class="opora-ab__lock" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
    print: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9V2h12v7M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2M6 14h12v8H6z"/></svg>',
    link: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1"/><path d="M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1"/></svg>',
    send: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>',
    flag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/></svg>',
    json: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M8 3H7a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2 2 2 0 0 1 2 2v5a2 2 0 0 0 2 2h1M16 3h1a2 2 0 0 1 2 2v5a2 2 0 0 0 2 2 2 2 0 0 0-2 2v5a2 2 0 0 1-2 2h-1"/></svg>',
    text: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 7V4h16v3M9 20h6M12 4v16"/></svg>'
  };

  function closeAllMenus(except) {
    var menus = d.querySelectorAll('.opora-ab__menu[data-open="true"]');
    for (var i = 0; i < menus.length; i++) { if (menus[i] !== except) menus[i].setAttribute('data-open', 'false'); }
  }
  d.addEventListener('click', function (ev) {
    if (!ev.target.closest || !ev.target.closest('.opora-ab__menu-wrap')) closeAllMenus(null);
  });

  function menuButton(label, iconKey, items) {
    var wrap = el('div', 'opora-ab__menu-wrap');
    var btn = el('button', 'opora-ab__btn', { type: 'button', 'aria-haspopup': 'true', 'aria-expanded': 'false' });
    btn.innerHTML = ICON[iconKey] + '<span class="opora-ab__label">' + label + '</span>';
    var menu = el('div', 'opora-ab__menu', { role: 'menu' });
    items.forEach(function (it) {
      if (it.sep) { menu.appendChild(el('div', 'opora-ab__menu-sep')); return; }
      if (it.heading) { var h = el('span', 'opora-ab__menu-label'); h.textContent = it.heading; menu.appendChild(h); return; }
      var mi;
      if (it.href) { mi = el('a', 'opora-ab__menu-item', { href: it.href, role: 'menuitem' }); }
      else { mi = el('button', 'opora-ab__menu-item', { type: 'button', role: 'menuitem' }); }
      mi.innerHTML = (it.icon ? ICON[it.icon] : '') + '<span>' + it.label + '</span>';
      if (it.onClick) mi.addEventListener('click', function (e) { e.preventDefault(); closeAllMenus(null); it.onClick(); });
      else if (it.href) mi.addEventListener('click', function () { closeAllMenus(null); });
      menu.appendChild(mi);
    });
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = menu.getAttribute('data-open') === 'true';
      closeAllMenus(menu);
      menu.setAttribute('data-open', open ? 'false' : 'true');
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
    wrap.appendChild(btn);
    wrap.appendChild(menu);
    return wrap;
  }

  /* ── exports (client-side, honest) ── */
  function copyText(text, okMsg) {
    try {
      navigator.clipboard.writeText(text).then(function () { toast(okMsg || 'Copied to clipboard'); },
        function () { toast('Copy failed', 'error'); });
    } catch (e) { toast('Copy failed', 'error'); }
  }
  function printResult() {
    try { w.print(); } catch (e) {}
  }

  /* ── handoff (cross-tool prefill) ── */
  function handoffUrl(target, carry, state) {
    var prefill = {};
    (carry || []).forEach(function (k) {
      if (state.inputs[k] != null) prefill[k] = state.inputs[k];
    });
    var qs = '';
    try { if (Object.keys(prefill).length) qs = '?prefill=' + encodeURIComponent(JSON.stringify(prefill)); } catch (e) {}
    return '/pages/' + target + qs;
  }

  /* ── shared floating dock (SOW + Edge AI document tools) ── */
  function ensureFloatDockHost(opts) {
    opts = opts || {};
    var mountId = opts.mountId || 'opora-ab-mount';
    var dockId = opts.dockId || 'opora-float-dock';
    var host = d.getElementById(mountId);
    if (host) {
      var dock0 = d.getElementById(dockId) || host.closest('.opora-float-dock, .sow-float-dock');
      if (dock0) dock0.hidden = false;
      return host;
    }
    var dock = d.getElementById(dockId);
    if (!dock) {
      dock = el('div', 'opora-float-dock', { id: dockId });
      d.body.appendChild(dock);
    }
    dock.hidden = false;
    host = el('div', 'opora-ab-mount', { id: mountId, 'aria-label': 'Document actions' });
    dock.appendChild(host);
    return host;
  }

  function hideLegacyExportClusters(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var rows = scope.querySelectorAll('.opora-export-btn, .calc-d4-export-row, .ot-export-bar');
    for (var i = 0; i < rows.length; i++) {
      var node = rows[i];
      var row = (node.classList && node.classList.contains('calc-d4-export-row'))
        ? node
        : (node.closest && (node.closest('.d4-export-row') || node.parentElement));
      if (row) {
        row.style.display = 'none';
        row.setAttribute('hidden', '');
      }
    }
    var legacySaves = scope.querySelectorAll('.opora-d4-save-bar, .ot-save-bar');
    for (var ls = 0; ls < legacySaves.length; ls++) {
      legacySaves[ls].style.display = 'none';
      legacySaves[ls].setAttribute('hidden', '');
    }
  }

  function defaultCopyText(detail) {
    var md = '';
    try { md = bodyMarkdown(detail || {}); } catch (e0) {}
    if (!md) {
      var body = d.getElementById('opDocBody') || d.getElementById('opResult');
      md = body ? ((body.innerText || body.textContent || '').trim()) : '';
    }
    if (!md) {
      toast('Nothing to copy yet — generate a result first.', 'error');
      return;
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(md).then(function () {
        toast('Copied to clipboard');
      }).catch(function () {
        fallbackCopyText(md);
      });
    } else {
      fallbackCopyText(md);
    }
  }

  function fallbackCopyText(text) {
    var ta = d.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:fixed;top:-999px;left:-999px;opacity:0;';
    d.body.appendChild(ta);
    ta.focus();
    ta.select();
    try {
      d.execCommand('copy');
      toast('Copied to clipboard');
    } catch (e) {
      toast('Copy failed — select the text manually.', 'error');
    }
    if (ta.parentNode) ta.parentNode.removeChild(ta);
  }

  function ensureJsPdf() {
    if (w.jspdf && w.jspdf.jsPDF) return Promise.resolve(w.jspdf.jsPDF);
    if (w.jsPDF) return Promise.resolve(w.jsPDF);
    var existing = d.getElementById('opora-jspdf-cdn');
    if (existing) {
      return new Promise(function (resolve, reject) {
        var n = 0;
        (function poll() {
          if (w.jspdf && w.jspdf.jsPDF) return resolve(w.jspdf.jsPDF);
          if (w.jsPDF) return resolve(w.jsPDF);
          if (++n > 80) return reject(new Error('jsPDF failed to load'));
          setTimeout(poll, 50);
        })();
      });
    }
    return new Promise(function (resolve, reject) {
      var s = d.createElement('script');
      s.id = 'opora-jspdf-cdn';
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
      s.onload = function () {
        if (w.jspdf && w.jspdf.jsPDF) resolve(w.jspdf.jsPDF);
        else if (w.jsPDF) resolve(w.jsPDF);
        else reject(new Error('jsPDF not available'));
      };
      s.onerror = function () { reject(new Error('jsPDF CDN error')); };
      d.head.appendChild(s);
    });
  }

  /* jsPDF standard fonts are Latin-1 only — any surviving multi-byte glyph
     prints as mojibake (e.g. bullets became "%â"). Map, then strip. */
  function pdfSafeText(s) {
    return String(s == null ? '' : s)
      .replace(/\\\$/g, '$')
      .replace(/[\u2013\u2014\u2212]/g, '-')
      .replace(/[\u2018\u2019]/g, "'")
      .replace(/[\u201C\u201D]/g, '"')
      .replace(/\u00A0/g, ' ')
      .replace(/\u2026/g, '...')
      .replace(/[\u2022\u25CF\u25CB\u25E6\u25AA\u25AB\u2023\u2043]/g, '-')
      .replace(/[\u2192\u21D2]/g, '->')
      .replace(/[\u2190\u21D0]/g, '<-')
      .replace(/[\u2713\u2714]/g, 'Yes')
      .replace(/[\u2717\u2718]/g, 'No')
      .replace(/[\u2019\u02BC]/g, "'")
      .replace(/[^\x00-\xFF]/g, '');
  }

  var PDF_BULLET_RE = /^([\u2022\u25CF\u25CB\u25E6\u25AA\u25AB\u2023\u2043]|[-*+])[ \t]+([\s\S]*)$/;

  function markdownToPdfPlain(md) {
    /* Heading markers are preserved — writePlainBlock renders the hierarchy. */
    return String(md || '')
      .replace(/\r\n/g, '\n')
      .replace(/\*\*([^*]+)\*\*/g, '$1')
      .replace(/\*([^*]+)\*/g, '$1')
      .replace(/__([^_]+)__/g, '$1')
      .replace(/_([^_]+)_/g, '$1')
      .replace(/`([^`]+)`/g, '$1')
      .replace(/^>\s?/gm, '')
      .replace(/^\|[-:\s|]+\|$/gm, '')
      .replace(/^\|/gm, '')
      .replace(/\|$/gm, '')
      .replace(/\|/g, '  |  ')
      /* Keep leading whitespace so nested list depth survives into the PDF writer */
      .replace(/^(\s*)[-*]\s+/gm, '$1• ')
      .replace(/^\d+\.\s+/gm, function (m) { return m; });
  }

  function parseMarkdownTables(md) {
    var lines = String(md || '').replace(/\r\n/g, '\n').split('\n');
    var blocks = [];
    var i = 0;
    function isTableRow(line) {
      var t = String(line || '').trim();
      return t.charAt(0) === '|' && t.indexOf('|', 1) !== -1;
    }
    function isSepRow(line) {
      return /^\|\s*:?-{3,}:?\s*(\|\s*:?-{3,}:?\s*)+\|?\s*$/.test(String(line || '').trim());
    }
    function splitCells(line) {
      var t = String(line || '').trim();
      if (t.charAt(0) === '|') t = t.slice(1);
      if (t.charAt(t.length - 1) === '|') t = t.slice(0, -1);
      return t.split('|').map(function (c) {
        return pdfSafeText(c.replace(/\*\*/g, '').replace(/`/g, '').trim());
      });
    }
    while (i < lines.length) {
      if (isTableRow(lines[i]) && i + 1 < lines.length && isSepRow(lines[i + 1])) {
        var headers = splitCells(lines[i]);
        i += 2;
        var rows = [];
        while (i < lines.length && isTableRow(lines[i]) && !isSepRow(lines[i])) {
          rows.push(splitCells(lines[i]));
          i += 1;
        }
        blocks.push({ type: 'table', headers: headers, rows: rows });
        continue;
      }
      var buf = [];
      while (i < lines.length && !(isTableRow(lines[i]) && i + 1 < lines.length && isSepRow(lines[i + 1]))) {
        buf.push(lines[i]);
        i += 1;
      }
      if (buf.length) blocks.push({ type: 'text', text: markdownToPdfPlain(buf.join('\n')) });
    }
    return blocks;
  }

  function warmAuthForSave() {
    try {
      var boot = w.OporaPerfBoot;
      if (boot && typeof boot.warmAuthForTools === 'function') {
        return boot.warmAuthForTools();
      }
      if (boot && typeof boot.ensureAuthModal === 'function') {
        return boot.ensureAuthModal().then(function () {
          if (w.OporaAuth && typeof w.OporaAuth.ensureClerkReady === 'function') {
            return w.OporaAuth.ensureClerkReady();
          }
        }).catch(function () { return null; });
      }
      if (w.OporaAuth && typeof w.OporaAuth.ensureClerkReady === 'function') {
        return w.OporaAuth.ensureClerkReady().catch(function () { return null; });
      }
    } catch (e0) {}
    return Promise.resolve(null);
  }

  function readBidPdfCoverMeta() {
    function val(id) {
      var el = d.getElementById(id);
      return el && el.value ? String(el.value).trim() : '';
    }
    return {
      company: val('opf_bd-company'),
      prospect: val('opf_bd-prospect'),
      facility: val('opf_bd-facility'),
      contact: val('opf_bd-contact'),
      city: val('opf_bd-city'),
      state: val('opf_bd-state')
    };
  }

  function sanitizeBidPdfBody(raw) {
    var t = String(raw || "");
    /* Contiguous web-only estimator: MARKET → PREVAILING → SUGGESTED + its price line only */
    t = t.replace(
      /MARKET\s+RANGE\s*\(BLS-ANCHORED\)[\s\S]{0,500}?SUGGESTED\s+RANGE[^\n]*(?:\r?\n[ \t]*\$[\d,][^\n]*)?/gi,
      ""
    );
    t = t.replace(/^.*MARKET\s+RANGE\s*\(BLS-ANCHORED\).*$/gim, "");
    t = t.replace(/^.*PREVAILING\s+WAGE.*$/gim, "");
    t = t.replace(/^.*SUGGESTED\s+RANGE.*$/gim, "");
    t = t.replace(/Market price range\s*\(BLS-anchored\)[\s\S]{0,400}?(?=\n\s*\n|\n#{1,3}\s|$)/gi, "");
    t = t.replace(/^.*Ask Opora about this.*$/gim, "");
    t = t.replace(/Ask Opora about this/gi, "");
    t = t.replace(/^.*Check this margin\s*[→\-].*Margin Sentinel.*$/gim, "");
    t = t.replace(/^.*Next:\s*check if this price holds.*$/gim, "");
    t = t.replace(/^BLS OEWS.*$/gim, "");
    t = t.replace(/^per month\s*$/gim, "");
    t = t.replace(/^\s*[—\-–]\s*$/gim, "");
    t = t.replace(/^\s*\$[\d,]+\s*[–\-—]\s*\$[\d,]+(?:\s*\/?\s*month)?\s*$/gim, "");
    t = t.replace(/PUBLIC CONTRACT COMPLIANCE NOTES[\s\S]{0,800}?(?=\n#{1,3}\s|\n[A-Z][A-Za-z].{12,}|$)/gi, "");
    t = t.replace(/\n{3,}/g, "\n\n").trim();
    return t;
  }

  function writeEdgeJsPdf(JsPDF, opts) {
    opts = opts || {};
    var title = pdfSafeText(opts.title || 'Opora document');
    var slug = opts.slug || 'document';
    var isBid = slug === 'bid-drafter' || looksLikeBidUiChrome(opts.body) ||
      /COMMERCIAL CLEANING PROPOSAL/i.test(String(opts.title || ''));
    var isMargin = slug === 'margin-sentinel';
    var rawBody = String(opts.body || '');
    /* Always sanitize bid-shaped bodies — even if slug is missing/wrong */
    if (isBid || looksLikeBidUiChrome(rawBody)) {
      isBid = true;
      rawBody = sanitizeBidPdfBody(rawBody);
    }
    var blocks = parseMarkdownTables(rawBody);
    var cover = opts.cover || (isBid ? readBidPdfCoverMeta() : null);
    var pdf = new JsPDF({ unit: 'pt', format: 'letter', orientation: 'portrait' });
    var pageW = pdf.internal.pageSize.getWidth();
    var pageH = pdf.internal.pageSize.getHeight();
    var marginL = isBid ? 44 : (isMargin ? 40 : 54);
    var marginR = isBid ? 44 : (isMargin ? 40 : 54);
    var marginT = isBid ? 48 : (isMargin ? 34 : 52);
    var marginB = isBid ? 44 : (isMargin ? 36 : 52);
    var contentW = pageW - marginL - marginR;
    /* Slightly tighter wrap band so Helvetica metrics never paint past the right margin */
    var wrapW = Math.max(40, contentW - 6);
    var y = marginT;
    var BRAND = [15, 122, 112];
    var BRAND_LIGHT = [236, 245, 244];
    var TEXT = [26, 24, 22];
    var MUTED = [92, 88, 84];
    var dateStr = new Date().toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
    var bodySize = isBid ? 9.5 : (isMargin ? 9.5 : 11);
    var lineHBase = isBid ? 12 : (isMargin ? 12 : 15);
    var paraGap = isBid ? 3 : (isMargin ? 5 : 8);
    var pageIndex = 1;
    var forcedPricingBreak = false;
    var sawTitle = false;
    var firstBodyLine = true;

    /**
     * Wrap with the SAME font/size used to draw. splitTextToSize alone can return
     * lines wider than maxW when the active Tf size was left over from the title/meta.
     */
    function wrapTextSafe(text, maxW, fontSize, fontStyle) {
      var size = fontSize == null ? bodySize : fontSize;
      var style = fontStyle || 'normal';
      var width = Math.max(40, maxW == null ? wrapW : maxW);
      pdf.setFont('helvetica', style);
      pdf.setFontSize(size);
      var lines = pdf.splitTextToSize(String(text == null ? '' : text), width);
      var out = [];
      for (var i = 0; i < lines.length; i++) {
        var ln = String(lines[i] || '');
        if (!ln) continue;
        if (pdf.getTextWidth(ln) <= width + 0.75) {
          out.push(ln);
          continue;
        }
        var words = ln.split(/(\s+)/);
        var cur = '';
        for (var wi = 0; wi < words.length; wi++) {
          var piece = words[wi];
          var trial = cur + piece;
          if (cur && pdf.getTextWidth(trial) > width) {
            out.push(cur.replace(/\s+$/g, ''));
            cur = /^\s+$/.test(piece) ? '' : piece.replace(/^\s+/g, '');
            /* Ultra-long token: hard-break by character */
            while (cur && pdf.getTextWidth(cur) > width) {
              var cut = cur.length;
              while (cut > 1 && pdf.getTextWidth(cur.slice(0, cut)) > width) cut--;
              out.push(cur.slice(0, cut));
              cur = cur.slice(cut);
            }
          } else {
            cur = trial;
          }
        }
        if (cur.replace(/\s+$/g, '')) out.push(cur.replace(/\s+$/g, ''));
      }
      return out.length ? out : [''];
    }

    function drawHeaderBand() {
      if (!isBid) {
        pdf.setFillColor(BRAND[0], BRAND[1], BRAND[2]);
        pdf.rect(0, 0, pageW, 4, 'F');
        return;
      }
      /* Running header: company · proposal left, date right, hairline — no thick teal stripe under metadata */
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8);
      pdf.setTextColor(100, 116, 139);
      var leftBits = [];
      if (cover && cover.company) leftBits.push(cover.company);
      leftBits.push('Commercial Cleaning Proposal');
      var left = pdfSafeText(leftBits.join('  ·  '));
      var right = dateStr;
      pdf.text(left, marginL, 26);
      pdf.text(right, pageW - marginR, 26, { align: 'right' });
      pdf.setDrawColor(203, 213, 225);
      pdf.setLineWidth(0.5);
      pdf.line(marginL, 32, pageW - marginR, 32);
      if (pageIndex === 1) {
        /* Soft brand accent only on cover page */
        pdf.setFillColor(BRAND[0], BRAND[1], BRAND[2]);
        pdf.rect(0, 0, pageW, 3, 'F');
      }
    }

    function newPage() {
      pdf.addPage();
      pageIndex += 1;
      y = marginT;
      drawHeaderBand();
    }

    function ensureSpace(h) {
      if (y + h > pageH - marginB) newPage();
    }

    function isPricingHeading(raw) {
      return /^\s*(?:#{1,6}\s*)?Pricing\s*&\s*Investment\s*:?\s*$/i.test(String(raw || '').trim()) ||
        /^\s*Pricing\s*&\s*Investment\s*$/i.test(String(raw || '').trim());
    }

    function forcePricingPageBreak() {
      if (!isBid || forcedPricingBreak) return;
      forcedPricingBreak = true;
      if (pageIndex === 1) newPage();
      else if (y > marginT + 8) newPage();
    }

    function isSectionLabel(raw) {
      var t = String(raw || '').trim();
      return /^(OPENING LINE|USE THESE DATA POINTS|OBJECTION HANDLERS|SOURCES|Analysis|Wage alerts|Industry Benchmark|Renegotiation Script|Target rate ask:)/i.test(t);
    }

    /* Section names the model emits without a markdown "#" (DOM/innerText path) */
    function isKnownSectionName(raw) {
      return /^(Executive Summary|Scope of Work|Consumables Provision|Cleaning Standards[^.]*|Pricing & Investment|Terms & Conditions|Exclusions|Why [A-Z].{0,60}|Next Steps|Client Acceptance|Quality Assurance[^.]*)\s*:?\s*$/i
        .test(String(raw || '').trim());
    }

    /* First line of a proposal is the document title even when "#" was lost */
    function looksLikeDocTitle(raw) {
      var t = String(raw || '').trim();
      if (!isBid || sawTitle || !firstBodyLine) return false;
      if (t.length > 80 || /[.!?,;:]$/.test(t)) return false;
      return /proposal|bid|cleaning services/i.test(t);
    }

    function drawHeading(textRaw, level) {
      var size, gapBefore, gapAfter, rule;
      if (level <= 1) {
        size = isBid ? 15 : 15;
        gapBefore = y > marginT + 2 ? 10 : 2;
        gapAfter = 8;
        rule = true;
      } else if (level === 2) {
        size = isBid ? 11.5 : 12.5;
        gapBefore = 10;
        gapAfter = 4;
        rule = false;
      } else {
        size = isBid ? 10 : 11;
        gapBefore = 7;
        gapAfter = 3;
        rule = false;
      }
      var txt = pdfSafeText(textRaw);
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(size);
      var lines = wrapTextSafe(txt, wrapW, size, 'bold');
      var headH = lines.length * (size + 3) + gapBefore + gapAfter + (rule ? 6 : 0);
      /* Never strand a heading at the foot of a page */
      ensureSpace(headH + lineHBase);
      y += gapBefore;
      pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
      lines.forEach(function (ln) {
        ensureSpace(size + 3);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(size);
        pdf.text(ln, marginL, y);
        y += size + 3;
      });
      if (rule) {
        y += 3;
        pdf.setDrawColor(203, 213, 225);
        pdf.setLineWidth(0.6);
        pdf.line(marginL, y, pageW - marginR, y);
        y += 3;
      }
      y += gapAfter;
      if (level <= 1) sawTitle = true;
    }

    function writeLabeledLine(raw) {
      var m = String(raw || '').match(/^(Objection|Response):\s*(.*)$/i);
      if (!m) return false;
      ensureSpace(lineHBase);
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(bodySize);
      pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
      var label = m[1].charAt(0).toUpperCase() + m[1].slice(1).toLowerCase() + ': ';
      var rest = pdfSafeText(m[2] || '');
      var labelW = pdf.getTextWidth(label);
      pdf.text(label, marginL, y);
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(bodySize);
      var wrapped = wrapTextSafe(rest, Math.max(40, wrapW - labelW), bodySize, 'normal');
      if (!wrapped.length) {
        y += lineHBase;
        return true;
      }
      pdf.text(wrapped[0], marginL + labelW, y);
      y += lineHBase;
      for (var wi = 1; wi < wrapped.length; wi++) {
        ensureSpace(lineHBase);
        pdf.text(wrapped[wi], marginL, y);
        y += lineHBase;
      }
      return true;
    }

    function writePlainBlock(text) {
      var lineH = lineHBase;
      var paras = String(text || '').split(/\n/);
      paras.forEach(function (para) {
        var rawFull = String(para || '').replace(/\t/g, '    ');
        var leadMatch = rawFull.match(/^( *)/);
        var lead = leadMatch ? leadMatch[1] : '';
        var stripped = rawFull.replace(/^\s+/, '');
        /* Match the list marker before sanitizing — pdfSafeText rewrites bullets to "-" */
        var bulletMatch = stripped.match(PDF_BULLET_RE);
        var raw = pdfSafeText(stripped);
        if (!raw.trim()) {
          y += paraGap;
          return;
        }
        var headingMatch = stripped.match(/^(#{1,6})\s+(.+?)\s*#*\s*$/);
        var headingText = headingMatch ? headingMatch[2] : null;
        var headingLevel = headingMatch ? headingMatch[1].length : 0;
        if (!headingMatch && isBid) {
          /* Recover hierarchy when markdown markers were lost upstream */
          if (looksLikeDocTitle(raw)) {
            headingText = raw;
            headingLevel = 1;
          } else if (isKnownSectionName(raw)) {
            headingText = raw.replace(/\s*:\s*$/, '');
            headingLevel = 2;
          }
        }
        if (headingText) {
          if (isBid && isPricingHeading(headingText)) forcePricingPageBreak();
          firstBodyLine = false;
          drawHeading(headingText, headingLevel);
          return;
        }
        firstBodyLine = false;
        if (isBid && isPricingHeading(raw)) {
          forcePricingPageBreak();
          drawHeading('Pricing & Investment', 2);
          return;
        }
        if (isMargin && writeLabeledLine(raw)) {
          y += 2;
          return;
        }
        var nestDepth = lead ? Math.min(3, Math.floor(lead.length / 2)) : 0;
        var numberedMatch = stripped.match(/^(\d+)\.[ \t]+([\s\S]*)$/);
        if (numberedMatch) {
          var numIndent = marginL + nestDepth * 14;
          var numLabel = pdfSafeText(numberedMatch[1] + '.');
          var numBody = pdfSafeText(numberedMatch[2] || '');
          pdf.setFont('helvetica', isBid && nestDepth === 0 ? 'bold' : 'normal');
          pdf.setFontSize(bodySize);
          var numW = pdf.getTextWidth(numLabel) + 5;
          var numTextX = numIndent + numW;
          var wrappedN = wrapTextSafe(numBody, Math.max(40, pageW - marginR - numTextX), bodySize, isBid && nestDepth === 0 ? 'bold' : 'normal');
          ensureSpace(lineH * Math.max(1, wrappedN.length) + 2);
          y += 2;
          pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
          pdf.text(numLabel, numIndent, y);
          pdf.text(wrappedN[0] || '', numTextX, y);
          y += lineH;
          pdf.setFont('helvetica', 'normal');
          for (var ni = 1; ni < wrappedN.length; ni++) {
            ensureSpace(lineH);
            pdf.text(wrappedN[ni], numTextX, y);
            y += lineH;
          }
          return;
        }
        if (bulletMatch) {
          var bulletIndent = marginL + (isBid ? 12 : 0) + nestDepth * 14;
          var textIndent = bulletIndent + 11;
          var body = pdfSafeText(bulletMatch[2] || '');
          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(bodySize);
          var wrappedB = wrapTextSafe(body, Math.max(40, pageW - marginR - textIndent), bodySize, 'normal');
          ensureSpace(lineH * Math.max(1, wrappedB.length));
          pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
          /* Vector bullet — glyph bullets are unavailable in the Latin-1 core fonts */
          var dotR = nestDepth > 0 ? 1.15 : 1.6;
          var dotY = y - bodySize * 0.28;
          pdf.setDrawColor(TEXT[0], TEXT[1], TEXT[2]);
          pdf.setFillColor(TEXT[0], TEXT[1], TEXT[2]);
          pdf.setLineWidth(0.6);
          pdf.circle(bulletIndent + dotR, dotY, dotR, nestDepth > 0 ? 'S' : 'F');
          if (wrappedB.length) {
            pdf.text(wrappedB[0], textIndent, y);
            y += lineH;
            for (var bi = 1; bi < wrappedB.length; bi++) {
              ensureSpace(lineH);
              pdf.text(wrappedB[bi], textIndent, y);
              y += lineH;
            }
          } else {
            y += lineH;
          }
          return;
        }
        var bold = isMargin && isSectionLabel(raw);
        var drawSize = bold && isMargin ? 10 : bodySize;
        var lines = wrapTextSafe(raw, wrapW, drawSize, bold ? 'bold' : 'normal');
        if (bold) y += 2;
        lines.forEach(function (ln) {
          ensureSpace(lineH);
          pdf.setFont('helvetica', bold ? 'bold' : 'normal');
          pdf.setFontSize(drawSize);
          pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
          pdf.text(ln, marginL, y);
          y += lineH;
        });
        if (bold) y += 2;
      });
    }

    function isMoneyCell(s) {
      return /^\$?\s*-?[\d,]+(\.\d{2})?%?$/.test(String(s || '').replace(/\s/g, '')) ||
        /^\$/.test(String(s || '').trim());
    }

    function drawMdTable(block) {
      var headers = block.headers || [];
      var rows = block.rows || [];
      if (!headers.length) return;
      /* Pricing tables belong with Pricing & Investment on page 2 */
      if (isBid && !forcedPricingBreak && /service\s*frequency|price\s*per\s*month|annual\s*total/i.test((headers || []).join(' '))) {
        forcePricingPageBreak();
      }
      var colCount = headers.length;
      rows.forEach(function (r) { if (r.length > colCount) colCount = r.length; });
      var colW = contentW / colCount;
      var pad = isMargin ? 5 : 6;
      var headerH = isMargin ? 18 : 22;
      var cellLh = isMargin ? 10 : 11;

      function drawHeader() {
        ensureSpace(headerH + 24);
        pdf.setFillColor(BRAND[0], BRAND[1], BRAND[2]);
        pdf.rect(marginL, y, contentW, headerH, 'F');
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(isMargin ? 7 : 8);
        pdf.setTextColor(255, 255, 255);
        for (var c = 0; c < colCount; c++) {
          var htxt = pdfSafeText(headers[c] || '');
          var hLines = pdf.splitTextToSize(htxt, colW - pad * 2).slice(0, 2);
          pdf.text(hLines, marginL + c * colW + pad, y + (isMargin ? 12 : 14));
        }
        y += headerH;
      }

      drawHeader();
      rows.forEach(function (row, rowIdx) {
        var cellLines = [];
        var rowH = isMargin ? 16 : 20;
        for (var c2 = 0; c2 < colCount; c2++) {
          var cell = pdfSafeText(row[c2] || '');
          var wrapped = pdf.splitTextToSize(cell, colW - pad * 2);
          if (isMargin) wrapped = wrapped.slice(0, 3);
          cellLines.push(wrapped);
          rowH = Math.max(rowH, wrapped.length * cellLh + pad * 2);
        }
        if (y + rowH > pageH - marginB) {
          newPage();
          drawHeader();
        }
        if (rowIdx % 2 === 0) {
          pdf.setFillColor(BRAND_LIGHT[0], BRAND_LIGHT[1], BRAND_LIGHT[2]);
          pdf.rect(marginL, y, contentW, rowH, 'F');
        }
        pdf.setDrawColor(210, 218, 226);
        pdf.setLineWidth(0.5);
        pdf.rect(marginL, y, contentW, rowH, 'S');
        var isValueRow = isMargin && rowIdx === 0;
        pdf.setFont('helvetica', isValueRow ? 'bold' : 'normal');
        pdf.setFontSize(isValueRow ? 10 : (isMargin ? 8.5 : 9));
        pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
        for (var c3 = 0; c3 < colCount; c3++) {
          var x = marginL + c3 * colW + pad;
          var alignRight = !isMargin && isMoneyCell(row[c3] || '');
          var lines = cellLines[c3];
          var cy = y + pad + (isMargin ? 8 : 9);
          if (alignRight) {
            pdf.text(lines, marginL + (c3 + 1) * colW - pad, cy, { align: 'right' });
          } else {
            pdf.text(lines, x, cy);
          }
          if (c3 > 0) {
            pdf.setDrawColor(210, 218, 226);
            pdf.line(marginL + c3 * colW, y, marginL + c3 * colW, y + rowH);
          }
        }
        y += rowH;
      });
      y += isMargin ? 8 : 12;
    }

    drawHeaderBand();

    if (isBid) {
      /* Band bleeds past the text block so cover copy still starts at marginL,
         flush with the body text below it. */
      var coverPad = 12;
      var coverX = Math.max(8, marginL - coverPad);
      var coverW = Math.min(pageW - coverX * 2, contentW + coverPad * 2);
      pdf.setFillColor(245, 247, 249);
      pdf.roundedRect(coverX, y, coverW, 54, 4, 4, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(10);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      pdf.text('COMMERCIAL CLEANING PROPOSAL', marginL, y + 16);
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(13);
      pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
      var coverTitle = pdfSafeText(
        (cover && cover.prospect)
          ? ('Prepared for ' + cover.prospect)
          : title
      );
      var coverLines = pdf.splitTextToSize(coverTitle, contentW);
      pdf.text(coverLines[0] || coverTitle, marginL, y + 32);
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8.5);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var subBits = [];
      if (cover && cover.company) subBits.push('From ' + cover.company);
      if (cover && cover.facility) subBits.push(cover.facility);
      if (cover && (cover.city || cover.state)) subBits.push([cover.city, cover.state].filter(Boolean).join(', '));
      subBits.push(dateStr);
      pdf.text(pdfSafeText(subBits.join('  ·  ')), marginL, y + 44);
      y += 64;
    } else {
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(isMargin ? 14 : 16);
      pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
      var titleLines = wrapTextSafe(title, wrapW, isMargin ? 14 : 16, 'bold');
      titleLines.forEach(function (ln) {
        ensureSpace(isMargin ? 16 : 20);
        pdf.text(ln, marginL, y);
        y += isMargin ? 16 : 20;
      });

      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(isMargin ? 8.5 : 9);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      var meta = 'Generated ' + new Date().toLocaleString() + '  ·  oporasupply.com';
      ensureSpace(12);
      pdf.text(meta, marginL, y);
      y += isMargin ? 10 : 12;
      pdf.setDrawColor(226, 232, 240);
      pdf.setLineWidth(0.6);
      pdf.line(marginL, y, pageW - marginR, y);
      y += isMargin ? 12 : 18;
    }

    blocks.forEach(function (block) {
      if (block.type === 'table') drawMdTable(block);
      else writePlainBlock(block.text || '');
    });

    var bodyHasAcceptance = /Client\s+Acceptance/i.test(rawBody);
    if (isBid && !bodyHasAcceptance) {
      /* Keep signature on page 2 when possible — avoid orphan page-3 acceptance */
      var sigBlockH = 78;
      if (y + sigBlockH > pageH - marginB) {
        /* If we are already on page 2+, only add a page when truly out of room */
        newPage();
      }
      y += 6;
      pdf.setDrawColor(226, 232, 240);
      pdf.setLineWidth(0.6);
      pdf.line(marginL, y, pageW - marginR, y);
      y += 16;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(10);
      pdf.setTextColor(TEXT[0], TEXT[1], TEXT[2]);
      pdf.text('Client Acceptance', marginL, y);
      y += 13;
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(9);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      pdf.text('Signature confirms acceptance of scope, pricing, and terms in this proposal.', marginL, y);
      y += 22;
      pdf.setDrawColor(26, 24, 22);
      pdf.setLineWidth(0.7);
      pdf.line(marginL, y, marginL + 220, y);
      pdf.line(marginL + 250, y, pageW - marginR, y);
      pdf.setFontSize(8);
      pdf.setTextColor(148, 163, 184);
      pdf.text('Client Signature / Name', marginL, y + 11);
      pdf.text('Date', marginL + 250, y + 11);
    }

    var total = pdf.internal.getNumberOfPages();
    for (var p = 1; p <= total; p++) {
      pdf.setPage(p);
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8);
      pdf.setTextColor(148, 163, 184);
      var footLeft = isBid
        ? pdfSafeText(((cover && cover.company) ? cover.company + '  ·  ' : '') + 'Confidential proposal')
        : 'Opora Supply';
      pdf.text(footLeft, marginL, pageH - 28);
      pdf.text('Page ' + p + ' of ' + total, pageW - marginR, pageH - 28, { align: 'right' });
    }

    var safeSlug = String(slug).replace(/[^a-zA-Z0-9_-]+/g, '-').replace(/^-|-$/g, '') || 'opora';
    var nameBit = isBid && cover && cover.prospect
      ? cover.prospect
      : title;
    var safeTitle = String(nameBit).replace(/[^a-zA-Z0-9_\-\s]/g, '').trim().replace(/\s+/g, '-').slice(0, 40) || 'document';
    var filename = safeSlug + '-' + safeTitle + '-' + fileStamp() + '.pdf';
    if (!savePdfFile(pdf, filename)) {
      throw new Error('Browser blocked the PDF download');
    }
    return true;
  }

  function savePdfFile(pdf, filename) {
    try {
      var blob = pdf.output('blob');
      if (!blob) throw new Error('empty blob');
      var url = URL.createObjectURL(blob);
      var a = d.createElement('a');
      a.href = url;
      a.download = filename || 'opora-document.pdf';
      a.rel = 'noopener';
      a.style.display = 'none';
      d.body.appendChild(a);
      a.click();
      setTimeout(function () {
        try { URL.revokeObjectURL(url); } catch (e0) {}
        if (a.parentNode) a.parentNode.removeChild(a);
      }, 2500);
      return true;
    } catch (e1) {
      try {
        pdf.save(filename || 'opora-document.pdf');
        return true;
      } catch (e2) {
        return false;
      }
    }
  }

  /* ── Margin Sentinel: boardroom PDF ─────────────────────────────────
     A dedicated, single-page export driven by the structured result data
     (never DOM scraping). marginSentinelPdfModel() is a pure function so it
     can be unit-tested without jsPDF. writeMarginSentinelPdf() draws it. */

  function marginSentinelPdfModel(data, loc) {
    data = data || {};
    loc = loc || {};
    function num(v) { return (v == null || v === '' || isNaN(Number(v))) ? null : Number(v); }
    function money(v, dec) { var x = num(v); return x == null ? null : ('$' + x.toFixed(dec == null ? 4 : dec)); }
    function pctStr(v) { var x = num(v); return x == null ? null : ((x > 0 ? '+' : '') + x.toFixed(1) + '%'); }
    function commas(v) { var x = num(v); return x == null ? null : Number(x).toLocaleString('en-US'); }
    function stripUrls(s) {
      return String(s == null ? '' : s)
        .replace(/\[[^\]]*?https?:\/\/[^\]]*?\]/gi, '')   /* [Title, https://…] */
        .replace(/\(https?:\/\/[^)]*\)/gi, '')            /* (https://…) */
        .replace(/https?:\/\/[^\s)\]]+/gi, '')            /* bare URLs */
        .replace(/\[([^\]\n]+)\]/g, '$1')                 /* leftover [text] */
        .replace(/\s{2,}/g, ' ')
        .replace(/\s+([.,;:])/g, '$1')
        .replace(/[\s·\-–—]+$/g, '')
        .trim();
    }

    var verdictMeta = {
      underbid:            { label: 'Underbid',         tone: 'red' },
      overbid:             { label: 'Above Market',      tone: 'amber' },
      market:              { label: 'Market Rate',       tone: 'green' },
      distorted:           { label: 'Scope Distortion',  tone: 'red' },
      insufficient_data:   { label: 'Insufficient Data', tone: 'gray' },
      service_initializing:{ label: 'Data Loading',      tone: 'gray' }
    };
    var vm = verdictMeta[data.verdict] || { label: (data.verdict || 'Margin Check'), tone: 'gray' };

    var stateCode = String(data.state || data.state_code || loc.state || '')
      .trim().toUpperCase().replace(/[^A-Z]/g, '').slice(0, 2);
    var city = String(data.city || loc.city || '').trim();
    var metro = String(data.metro || loc.metro || '').trim();
    var place = '';
    if (city) place = city + (stateCode ? (', ' + stateCode) : '');
    else if (metro) place = metro + (stateCode ? (', ' + stateCode) : '');
    else if (stateCode) place = stateCode;
    var subtitle = vm.label + ' Evaluation' + (place ? (' \u00B7 ' + place) : '');

    var bls = data.bls_wage_benchmark || {};
    var lc = data.labor_cost_implied || {};
    var issa = data.issa_production_band || { low: 2500, high: 3500 };
    var marginPct = num(data.gross_margin_pct);
    var monthly = data.bid_per_sqft_monthly != null ? data.bid_per_sqft_monthly : data.bid_per_sqft;

    var cards = [
      {
        label: 'GROSS MARGIN',
        value: marginPct == null ? '\u2014' : (marginPct.toFixed(1) + '%'),
        sub: '',
        tone: vm.tone,
        accent: true
      },
      {
        label: 'IMPLIED LABOR',
        value: lc.hourly_rate != null ? (money(lc.hourly_rate, 2) + '/hr') : '\u2014',
        sub: bls.hourly_median != null ? ('BLS ' + (stateCode ? stateCode + ' ' : '') + money(bls.hourly_median, 2) + '/hr') : ''
      },
      {
        label: 'PRODUCTION',
        value: data.production_sqft_per_hr != null ? (commas(data.production_sqft_per_hr) + ' sf/hr') : '\u2014',
        sub: 'ISSA ' + commas(issa.low) + '\u2013' + commas(issa.high)
      },
      {
        label: 'PRICE / SQ FT',
        value: monthly != null ? (money(monthly, 4) + '/mo') : '\u2014',
        sub: data.bid_per_sqft != null ? (money(data.bid_per_sqft, 4) + ' / visit') : ''
      }
    ];

    /* Analysis: 3 labeled callouts synthesized from structured numbers.
       Falls back to cleaned alert text when the structured pieces are absent. */
    var bullets = [];
    if (lc.hourly_rate != null && bls.hourly_median != null) {
      var deltaStr = pctStr(data.labor_rate_delta_from_bls_pct);
      bullets.push({
        label: 'Labor Rate',
        text: 'implied labor of ' + money(lc.hourly_rate, 2) + '/hr vs the ' +
          (stateCode ? stateCode + ' ' : '') + 'BLS median of ' + money(bls.hourly_median, 2) + '/hr' +
          (deltaStr ? (' (' + deltaStr + ')') : '') + '.'
      });
    }
    if (data.production_sqft_per_hr != null) {
      var prod = Number(data.production_sqft_per_hr);
      var band = prod > Number(issa.high) ? 'above' : (prod < Number(issa.low) ? 'below' : 'within');
      bullets.push({
        label: 'Production Speed',
        text: commas(prod) + ' sq ft/hr is ' + band + ' the ISSA office band (' +
          commas(issa.low) + '\u2013' + commas(issa.high) + ' sq ft/hr).'
      });
    }
    var mb = data.metro_benchmark_per_sqft;
    if (data.bid_per_sqft != null && mb && mb.median != null) {
      var bidV = Number(data.bid_per_sqft);
      var med = Number(mb.median);
      var variance = med ? ((bidV - med) / med * 100) : null;
      var dir = variance == null ? '' : (variance < 0
        ? (Math.abs(variance).toFixed(1) + '% below')
        : (variance.toFixed(1) + '% above'));
      bullets.push({
        label: 'Pricing Variance',
        text: money(bidV, 4) + '/sq ft per visit' +
          (monthly != null ? (' (' + money(monthly, 4) + '/mo)') : '') +
          (dir ? (' is ' + dir + ' the ' + money(med, 4) + ' median') : '') + '.'
      });
    }
    if (!bullets.length && Array.isArray(data.alerts)) {
      data.alerts.slice(0, 3).forEach(function (a) {
        var t = stripUrls(a);
        if (t) bullets.push({ label: '', text: t });
      });
    }

    var benchmark = null;
    if (mb && (mb.low != null || mb.high != null)) {
      benchmark = {
        low: money(mb.low, 4),
        high: money(mb.high, 4),
        median: mb.median != null ? money(mb.median, 4) : null,
        lowVal: num(mb.low),
        highVal: num(mb.high),
        medianVal: num(mb.median),
        markerVal: num(data.bid_per_sqft),
        markerLabel: data.bid_per_sqft != null ? (money(data.bid_per_sqft, 4) + '/visit') : null
      };
    }

    var rs = (data.renegotiation_script && typeof data.renegotiation_script === 'object')
      ? data.renegotiation_script : {};
    var opening = rs.opening_line ? stripUrls(rs.opening_line) : '';
    var objections = [];
    if (Array.isArray(rs.objection_handlers)) {
      rs.objection_handlers.forEach(function (oh) {
        var q = stripUrls(oh && oh.objection);
        var r = stripUrls(oh && oh.response);
        if (q || r) objections.push({ objection: q, response: r });
      });
    }
    var targetRate = null;
    if (rs.target_rate_ask) {
      var tr = String(rs.target_rate_ask).trim();
      /* Pretty-print bare integers: "$1513/month" → "$1,513 / month" */
      tr = tr.replace(/\$?\s*(\d{4,})/, function (mm, digits) {
        return '$' + Number(digits).toLocaleString('en-US');
      }).replace(/\s*\/\s*/g, ' / ').replace(/\/mo\b/i, '/ month').replace(/\/month/i, '/ month');
      targetRate = tr;
    }

    var citations = Array.isArray(data.citations) ? data.citations : [];
    function findUrl(re) {
      for (var i = 0; i < citations.length; i++) {
        var u = citations[i] && citations[i].url;
        if (u && re.test(String(u))) return String(u);
      }
      return '';
    }
    var sources = [
      { label: 'U.S. BLS OEWS SOC 37-2011' + (stateCode ? (' (' + stateCode + ')') : ''), url: findUrl(/bls\.gov/i) },
      { label: 'ISSA 447 / 612 Production Benchmarks', url: findUrl(/fennec|issa/i) },
      { label: 'BSCAI Industry Standards', url: findUrl(/bscai/i) }
    ];
    var footer = 'Data Sources: ' + sources.map(function (s) { return s.label; }).join('  \u00B7  ');

    return {
      title: 'Margin Sentinel Audit',
      subtitle: subtitle,
      verdictLabel: vm.label,
      tone: vm.tone,
      cards: cards,
      bullets: bullets,
      benchmark: benchmark,
      opening: opening,
      objections: objections,
      targetRate: targetRate,
      sources: sources,
      footer: footer
    };
  }

  function readMarginLocation() {
    function v(id) { var el = d.getElementById(id); return el && el.value ? String(el.value).trim() : ''; }
    return { state: v('opf_state'), city: v('opf_city'), metro: v('opf_metro') };
  }

  var MS_TONE_RGB = {
    green: [46, 125, 82],
    amber: [176, 137, 44],
    red:   [176, 92, 82],
    gray:  [122, 118, 110]
  };

  function writeCustomerRecoveryPdf(JsPDF, opts) {
    opts = opts || {};
    var data = opts.data || {};
    var wbl = data.win_back_likelihood || {};
    var rec = data.recommendation || {};
    var math = rec.financial_math || {};
    var stake = (typeof w.OporaCrStakeFrom === 'function')
      ? w.OporaCrStakeFrom(data)
      : null;
    var opResEl = d.getElementById('opResult');
    if (!stake && opResEl && opResEl._oporaCrStake) stake = opResEl._oporaCrStake;
    function field(id) {
      var el = d.getElementById(id);
      return el && el.value != null ? String(el.value).trim() : '';
    }
    function numOr(v, fallback) {
      var n = Number(v);
      return isFinite(n) ? n : fallback;
    }
    var vs = data.value_at_stake || {};
    var monthly = stake ? stake.monthly : (vs.monthly != null ? Number(vs.monthly) : numOr(field('opf_cr-value') || field('opf_cr-value-convo').replace(/[$,\s]/g, ''), 0));
    var months = stake ? stake.months : (vs.months != null ? Number(vs.months) : numOr(field('opf_cr-months'), 0));
    if (!(monthly > 0)) monthly = 0;
    if (!(months >= 0)) months = 0;
    var historical = stake ? stake.historical : (vs.historical_realized != null ? Number(vs.historical_realized) : Math.round(monthly * months));
    var arr = stake ? stake.arr : (vs.arr_lost != null ? Number(vs.arr_lost) : Math.round(monthly * 12));
    var projected3y = stake ? stake.projected3y : (vs.projected_3yr != null ? Number(vs.projected_3yr) : Math.round(monthly * 36));
    var owner = stake ? stake.owner : (field('opf_cr-company') || field('opf_cr-company-convo') || 'the owner');

    function money(n) {
      if (n == null || isNaN(n)) return '-';
      return '$' + Math.round(Number(n)).toLocaleString('en-US');
    }
    function fillPh(text) {
      return String(text == null ? '' : text)
        .replace(/\bdifferentlv\b/gi, 'differently')
        .replace(/\[(?:CUSTOMER[_\s-]?NAME|Customer Name)\]/gi, 'the customer')
        .replace(/\[(?:OWNER[_\s-]?NAME|Owner Name)\]/gi, owner);
    }
    function clip(s, max) {
      s = String(s || '').replace(/\s+/g, ' ').trim();
      if (s.length <= max) return s;
      return s.slice(0, max - 1).replace(/\s+\S*$/, '') + '...';
    }

    var pdf = new JsPDF({ unit: 'pt', format: 'letter', orientation: 'portrait' });
    var pageW = pdf.internal.pageSize.getWidth();
    var pageH = pdf.internal.pageSize.getHeight();
    var mL = 36, mR = 36, mT = 30, mB = 38;
    var cW = pageW - mL - mR;
    var y = mT;
    var INK = [31, 41, 55];
    var SLATE = [71, 85, 105];
    var MUTED = [100, 116, 139];
    var BRAND = [15, 122, 112];
    var CARD_BG = [248, 250, 252];
    var CARD_BD = [226, 232, 240];
    var toneLabel = { apologetic: 'Apologetic', 'value-positioning': 'Value Re-anchor', 'offer-based': 'Rebound Check-in' };

    function safe(s) { return pdfSafeText(fillPh(s)); }
    function setInk() { pdf.setTextColor(INK[0], INK[1], INK[2]); }
    function setSlate() { pdf.setTextColor(SLATE[0], SLATE[1], SLATE[2]); }
    function setMuted() { pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]); }
    var LINE_LEAD = 1.25;
    function lh(size) { return size * LINE_LEAD; }
    function pdfDotJoin(parts) {
      return parts.filter(function (p) { return p != null && String(p).trim() !== ''; }).join(' \u00b7 ');
    }
    function crPdfListItem(text) {
      var s = String(text == null ? '' : text).trim();
      s = s.replace(/^\d+[.)]\s+/, '');
      var m = s.match(PDF_BULLET_RE);
      if (m) s = String(m[2] || '').trim();
      return '- ' + s;
    }

    function flattenPdfCell(text) {
      return String(text == null ? '' : text)
        .replace(/\r\n/g, '\n')
        .replace(/\.\s*\n+\s*(?=[a-z])/g, '. ')
        .replace(/\n+/g, ' ')
        .replace(/\s{2,}/g, ' ')
        .trim();
    }

    function wrapClip(text, width, maxLines) {
      var lines = pdf.splitTextToSize(safe(flattenPdfCell(text)), width);
      if (lines.length > maxLines) {
        lines = lines.slice(0, maxLines);
        var last = String(lines[maxLines - 1] || '');
        if (last.length > 6 && last.slice(-3) !== '...') {
          lines[maxLines - 1] = last.replace(/\s+\S{0,12}$/, '') + '...';
        }
      }
      return lines;
    }

    function sectionLabel(text) {
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(8);
      setSlate();
      pdf.text(String(text).toUpperCase(), mL, y);
      y += lh(8) * 0.5;
      pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
      pdf.setLineWidth(0.6);
      pdf.line(mL, y, pageW - mR, y);
      y += lh(8);
    }

    var now = new Date();
    var dateStr = now.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    var timeStr = now.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });

    pdf.setFillColor(BRAND[0], BRAND[1], BRAND[2]);
    pdf.rect(0, 0, pageW, 3, 'F');

    y = 28;
    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(15);
    setInk();
    pdf.text(safe(opts.title || 'Customer Recovery'), mL, y);
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(8);
    setMuted();
    pdf.text(dateStr + '  ·  ' + timeStr + '  ·  oporasupply.com', pageW - mR, y - 1, { align: 'right' });
    y += 12;
    pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
    pdf.setLineWidth(0.7);
    pdf.line(mL, y, pageW - mR, y);
    y += 12;

    var pct = wbl.percent != null ? String(wbl.percent) + '%' : '-';
    var pctN = Number(wbl.percent);
    var risk = isNaN(pctN) ? 'mid' : (pctN <= 15 ? 'high' : pctN <= 30 ? 'mid' : 'ok');
    var riskLabel = risk === 'high' ? 'High risk' : risk === 'mid' ? 'Uphill' : 'Workable';
    var accent = risk === 'high' ? [181, 115, 107] : risk === 'mid' ? [201, 162, 75] : [63, 181, 168];
    var cards = [
      { label: 'WIN-BACK ODDS', value: pct, sub: rec.action ? String(rec.action).toUpperCase() + '  ·  ' + riskLabel : riskLabel, accent: true },
      { label: 'ARR LOST', value: money(arr), sub: money(monthly) + '/mo x 12' },
      { label: 'TENURE', value: (months || '-') + (months === 1 ? ' mo' : ' mos'), sub: 'Earned ' + money(historical) }
    ];
    (function drawCards() {
      var gap = 8, n = 3, cardH = 52;
      var cardW = (cW - gap * (n - 1)) / n;
      cards.forEach(function (card, i) {
        var x = mL + i * (cardW + gap);
        pdf.setFillColor(CARD_BG[0], CARD_BG[1], CARD_BG[2]);
        pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
        pdf.setLineWidth(0.7);
        pdf.roundedRect(x, y, cardW, cardH, 4, 4, 'FD');
        if (card.accent) {
          pdf.setFillColor(accent[0], accent[1], accent[2]);
          pdf.rect(x, y + 1, 3.5, cardH - 2, 'F');
        }
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.4);
        setSlate();
        pdf.text(card.label, x + 10, y + 13);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(14);
        if (card.accent) pdf.setTextColor(accent[0], accent[1], accent[2]);
        else setInk();
        pdf.text(safe(card.value), x + 10, y + 32);
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(7);
        setMuted();
        pdf.text(safe(card.sub), x + 10, y + 44);
      });
      y += cardH + 10;
    })();

    if (wbl.reasoning) {
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8.5);
      setInk();
      var reasonLines = wrapClip(wbl.reasoning, cW, 3);
      reasonLines.forEach(function (ln) { pdf.text(ln, mL, y); y += lh(8.5); });
      y += 4;
    }

    sectionLabel('Account value (stated math)');
    var finRows = [
      ['Historical realized', money(historical), months + ' mo x ' + money(monthly) + '/mo'],
      ['ARR lost', money(arr), money(monthly) + ' x 12'],
      ['3-year planning window', money(projected3y), money(monthly) + ' x 36']
    ];
    var colW = [168, 90, cW - 258];
    var finRowH = lh(8.5) + 8;
    finRows.forEach(function (row, i) {
      if (i % 2 === 0) {
        pdf.setFillColor(248, 250, 252);
        pdf.rect(mL, y - 10, cW, finRowH, 'F');
      }
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8.5);
      setInk();
      pdf.text(row[0], mL + 4, y);
      pdf.setFont('helvetica', 'bold');
      pdf.text(row[1], mL + colW[0] + 4, y);
      pdf.setFont('helvetica', 'normal');
      setMuted();
      pdf.text(safe(row[2]), mL + colW[0] + colW[1] + 4, y);
      y += finRowH;
    });
    y += 2;
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(7.2);
    setMuted();
    var note = 'Not remaining LTV. Historical is already earned. ARR is the annual run-rate you no longer bill. 3-year value is a planning window, not a forecast.';
    wrapClip(note, cW, 2).forEach(function (ln) { pdf.text(ln, mL, y); y += lh(7.2); });
    y += 8;

    if (data.situation_diagnosis) {
      sectionLabel('Situation diagnosis');
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8.5);
      setInk();
      wrapClip(data.situation_diagnosis, cW, 4).forEach(function (ln) { pdf.text(ln, mL, y); y += lh(8.5); });
      y += 8;
    }

    var playbook = data.recommended_playbook || [];
    if (playbook.length) {
      sectionLabel('Recovery playbook');
      var cStep = 28, cWhen = 92, cAct = cW - cStep - cWhen;
      var pbHeadH = lh(7) + 8;
      pdf.setFillColor(241, 245, 249);
      pdf.rect(mL, y - 10, cW, pbHeadH, 'F');
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(7);
      setSlate();
      pdf.text('#', mL + 6, y);
      pdf.text('WHEN', mL + cStep + 4, y);
      pdf.text('ACTION', mL + cStep + cWhen + 4, y);
      y += pbHeadH;
      playbook.forEach(function (step, i) {
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(8);
        var actionLines = wrapClip(step.action || '', cAct - 8, 3);
        var whenLines = wrapClip(step.timeline || '', cWhen - 8, 2);
        var rowH = Math.max(lh(8) + 8, Math.max(actionLines.length * lh(8), whenLines.length * lh(7.5)) + 8);
        if (i % 2 === 0) {
          pdf.setFillColor(248, 250, 252);
          pdf.rect(mL, y - 10, cW, rowH, 'F');
        }
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(8);
        setInk();
        pdf.text(String(step.step_number || i + 1), mL + 8, y);
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(7.5);
        setSlate();
        pdf.text(whenLines[0] || '', mL + cStep + 4, y);
        if (whenLines[1]) pdf.text(whenLines[1], mL + cStep + 4, y + lh(7.5));
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(8);
        setInk();
        actionLines.forEach(function (ln, li) { pdf.text(ln, mL + cStep + cWhen + 4, y + li * lh(8)); });
        y += rowH;
      });
      y += 4;
    }

    if (math.cost_of_recovery_attempt) {
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(7.5);
      setMuted();
      wrapClip('Recovery cost (est.): ' + math.cost_of_recovery_attempt, cW, 2).forEach(function (ln) {
        pdf.text(ln, mL, y); y += lh(7.5);
      });
    }

    if (rec.action || rec.rationale) {
      y += 4;
      var verdict = String(rec.action || 'evaluate').toUpperCase();
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(9);
      setInk();
      pdf.text(safe(verdict), mL, y);
      y += lh(9);
      if (rec.rationale) {
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(8.5);
        setInk();
        wrapClip(rec.rationale, cW, 4).forEach(function (ln) { pdf.text(ln, mL, y); y += lh(8.5); });
      }
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8);
      setInk();
      var evalMath = pdfDotJoin([
        'Historical ' + money(historical),
        'ARR lost ' + money(arr),
        '3-year value ' + money(projected3y)
      ]);
      wrapClip(evalMath, cW, 2).forEach(function (ln) { pdf.text(ln, mL, y); y += lh(8); });
      y += 6;
    }

    /* Page 2 — execution toolkit. Always a second page; never dump sequence bodies. */
    pdf.addPage();
    pdf.setFillColor(BRAND[0], BRAND[1], BRAND[2]);
    pdf.rect(0, 0, pageW, 3, 'F');
    y = 28;
    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(13);
    setInk();
    pdf.text('Execution toolkit', mL, y);
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(8);
    setMuted();
    pdf.text(pdfDotJoin(['Copy-ready emails', 'exit survey', 'prevention']), pageW - mR, y - 1, { align: 'right' });
    y += 12;
    pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
    pdf.setLineWidth(0.7);
    pdf.line(mL, y, pageW - mR, y);
    y += 12;

    var tabDrafts = data.custom_email_drafts || [];
    var drafts = tabDrafts.slice();
    if (!drafts.length && data.winback_sequence && data.winback_sequence.length) {
      drafts = data.winback_sequence.map(function (e) {
        return { tone: e.send_on || 'Sequence', subject: e.subject, body: e.body };
      });
    }
    if (drafts.length) {
      sectionLabel(tabDrafts.length ? 'Email drafts' : 'Win-back email drafts');
      var maxDrafts = Math.min(3, drafts.length);
      var emailMaxLines = 6;
      for (var di = 0; di < maxDrafts; di++) {
        var draft = drafts[di];
        var label = toneLabel[draft.tone] || draft.tone || ('Draft ' + (di + 1));
        var subj = clip(draft.subject || '', 90);
        var bodyLines = wrapClip(draft.body || '(No body returned — regenerate.)', cW - 16, emailMaxLines);
        var boxPad = 10;
        var boxH = lh(8) + lh(8) + bodyLines.length * lh(8) + boxPad + 8;
        pdf.setFillColor(255, 255, 255);
        pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
        pdf.setLineWidth(0.8);
        pdf.roundedRect(mL, y, cW, boxH, 4, 4, 'FD');
        pdf.setFillColor(BRAND[0], BRAND[1], BRAND[2]);
        pdf.rect(mL, y + 1, 3, boxH - 2, 'F');
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(8);
        pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
        pdf.text(safe(String(label).toUpperCase()), mL + 12, y + lh(8) + 2);
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(8);
        setInk();
        pdf.text('Subject: ' + safe(subj), mL + 12, y + lh(8) + lh(8) + 2);
        pdf.setFontSize(8);
        var by = y + lh(8) + lh(8) + lh(8) + 2;
        bodyLines.forEach(function (ln) { pdf.text(ln, mL + 12, by); by += lh(8); });
        y += boxH + 8;
      }
    }

    var survey = data.exit_survey_questions || [];
    var prevent = data.prevention_playbook_for_next_time || [];
    if (survey.length || prevent.length) {
      y += 2;
      var colGap = 14;
      var half = (cW - colGap) / 2;
      var colY0 = y;
      var leftX = mL;
      var rightX = mL + half + colGap;

      function colHead(x, title) {
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(8);
        setSlate();
        pdf.text(String(title).toUpperCase(), x, y);
        y += lh(8) * 0.5;
        pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
        pdf.setLineWidth(0.6);
        pdf.line(x, y, x + half, y);
        y += lh(8);
      }

      var yLeft = colY0;
      y = yLeft;
      if (survey.length) {
        colHead(leftX, 'Exit survey questions');
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(8);
        setInk();
        survey.slice(0, 7).forEach(function (q, i) {
          var lines = wrapClip((i + 1) + '. ' + q, half, 2);
          lines.forEach(function (ln) { pdf.text(ln, leftX, y); y += lh(8); });
          y += 3;
        });
        yLeft = y;
      }

      var yRight = colY0;
      y = yRight;
      if (prevent.length) {
        colHead(rightX, 'How to prevent this next time');
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(8);
        setInk();
        prevent.slice(0, 6).forEach(function (p) {
          var lines = wrapClip(crPdfListItem(p), half, 3);
          lines.forEach(function (ln) { pdf.text(ln, rightX, y); y += lh(8); });
          y += 3;
        });
        yRight = y;
      }
      y = Math.max(yLeft, yRight);
    }

    var nPages = pdf.internal.getNumberOfPages();
    for (var pi = 1; pi <= nPages; pi++) {
      pdf.setPage(pi);
      pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
      pdf.setLineWidth(0.5);
      pdf.line(mL, pageH - 28, pageW - mR, pageH - 28);
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8);
      pdf.setTextColor(SLATE[0], SLATE[1], SLATE[2]);
      pdf.text('Opora Supply', mL, pageH - 16);
      pdf.text('Page ' + pi + ' of ' + nPages, pageW - mR, pageH - 16, { align: 'right' });
    }

    var safeTitle = String(opts.title || 'Customer Recovery')
      .replace(/[^a-zA-Z0-9_\-\s]/g, '').trim().replace(/\s+/g, '-').slice(0, 40) || 'customer-recovery';
    var filename = 'customer-recovery-' + safeTitle + '-' + fileStamp() + '.pdf';
    if (!savePdfFile(pdf, filename)) {
      throw new Error('Browser blocked the PDF download');
    }
    return true;
  }

  function writeMarginSentinelPdf(JsPDF, opts) {
    opts = opts || {};
    var model = marginSentinelPdfModel(opts.data || {}, opts.loc || {});
    var pdf = new JsPDF({ unit: 'pt', format: 'letter', orientation: 'portrait' });
    var pageW = pdf.internal.pageSize.getWidth();
    var pageH = pdf.internal.pageSize.getHeight();
    var mL = 40, mR = 40, mT = 40;
    var cW = pageW - mL - mR;
    var y = mT;

    var INK = [26, 24, 22];
    var MUTED = [112, 108, 104];
    var FAINT = [140, 136, 132];
    var BRAND = [15, 122, 112];
    var CARD_BG = [248, 249, 250];
    var CARD_BD = [226, 229, 233];
    var tone = MS_TONE_RGB[model.tone] || MS_TONE_RGB.gray;

    function safe(s) { return pdfSafeText(s); }
    function setInk() { pdf.setTextColor(INK[0], INK[1], INK[2]); }
    function setMuted() { pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]); }

    var dateStr = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

    /* Top brand accent */
    pdf.setFillColor(BRAND[0], BRAND[1], BRAND[2]);
    pdf.rect(0, 0, pageW, 3, 'F');

    /* Header */
    y = 48;
    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(16);
    setInk();
    pdf.text(safe(model.title), mL, y);
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(8.5);
    setMuted();
    pdf.text('Generated: ' + dateStr, pageW - mR, y - 1, { align: 'right' });
    y += 15;
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(9.5);
    setMuted();
    pdf.text(safe(model.subtitle), mL, y);
    y += 8;
    pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
    pdf.setLineWidth(0.8);
    pdf.line(mL, y, pageW - mR, y);
    y += 16;

    /* KPI cards */
    (function drawCards() {
      var gap = 10, n = model.cards.length || 4;
      var cardW = (cW - gap * (n - 1)) / n;
      var cardH = 62;
      model.cards.forEach(function (card, i) {
        var x = mL + i * (cardW + gap);
        pdf.setFillColor(CARD_BG[0], CARD_BG[1], CARD_BG[2]);
        pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
        pdf.setLineWidth(0.8);
        pdf.roundedRect(x, y, cardW, cardH, 5, 5, 'FD');
        if (card.accent) {
          /* status badge dot keyed to verdict tone */
          pdf.setFillColor(tone[0], tone[1], tone[2]);
          pdf.circle(x + cardW - 11, y + 12, 3, 'F');
        }
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.4);
        pdf.setTextColor(FAINT[0], FAINT[1], FAINT[2]);
        pdf.text(safe(card.label), x + 9, y + 15);
        var vstr = safe(card.value);
        var vsize = 14.5;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(vsize);
        while (pdf.getTextWidth(vstr) > cardW - 16 && vsize > 8.5) { vsize -= 0.5; pdf.setFontSize(vsize); }
        if (card.accent) pdf.setTextColor(tone[0], tone[1], tone[2]);
        else setInk();
        pdf.text(vstr, x + 9, y + 38);
        if (card.sub) {
          pdf.setFont('helvetica', 'normal');
          var ssize = 6.9;
          pdf.setFontSize(ssize);
          pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
          var sstr = safe(card.sub);
          while (pdf.getTextWidth(sstr) > cardW - 16 && ssize > 5) { ssize -= 0.3; pdf.setFontSize(ssize); }
          pdf.text(sstr, x + 9, y + 52);
        }
      });
      y += cardH + 16;
    })();

    function sectionLabel(text) {
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(8.5);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      pdf.text(String(text).toUpperCase(), mL, y);
      y += 5;
      pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
      pdf.setLineWidth(0.6);
      pdf.line(mL, y, pageW - mR, y);
      y += 13;
    }

    function drawBullet(lead, body) {
      var textX = mL + 12;
      var avail = pageW - mR - textX;
      var leadStr = lead ? (safe(lead) + ':  ') : '';
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(9.5);
      var leadW = leadStr ? pdf.getTextWidth(leadStr) : 0;
      var firstAvail = Math.max(70, avail - leadW);
      pdf.setFont('helvetica', 'normal');
      var words = safe(body).split(/\s+/);
      var lines = [], cur = '';
      words.forEach(function (word) {
        var test = cur ? (cur + ' ' + word) : word;
        var limit = lines.length === 0 ? firstAvail : avail;
        if (pdf.getTextWidth(test) > limit && cur) { lines.push(cur); cur = word; }
        else cur = test;
      });
      if (cur) lines.push(cur);
      pdf.setFillColor(BRAND[0], BRAND[1], BRAND[2]);
      pdf.circle(mL + 3, y - 2.8, 1.5, 'F');
      setInk();
      if (leadStr) {
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(9.5);
        pdf.text(leadStr, textX, y);
      }
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(9.5);
      pdf.text(lines[0] || '', textX + leadW, y);
      y += 12.5;
      for (var i = 1; i < lines.length; i++) {
        pdf.text(lines[i], textX, y);
        y += 12.5;
      }
      y += 3;
    }

    /* Analysis */
    if (model.bullets.length) {
      sectionLabel('Audit Analysis');
      model.bullets.slice(0, 3).forEach(function (b) { drawBullet(b.label, b.text); });
      y += 4;
    }

    /* Market benchmark bar */
    if (model.benchmark && model.benchmark.lowVal != null && model.benchmark.highVal != null &&
        model.benchmark.highVal > model.benchmark.lowVal) {
      sectionLabel('Market Benchmark ($/sq ft per visit)');
      var bm = model.benchmark;
      var barX = mL + 48;
      var barW = cW - 96;
      var barY = y + 16;
      var barH = 9;
      var span = bm.highVal - bm.lowVal;
      function frac(val) {
        if (val == null) return null;
        var f = (val - bm.lowVal) / span;
        return f < 0 ? 0 : (f > 1 ? 1 : f);
      }
      var medFrac = bm.medianVal != null ? frac(bm.medianVal) : 0.5;
      /* Base track (fallback if any fill is dropped) */
      pdf.setFillColor(236, 238, 240);
      pdf.roundedRect(barX, barY, barW, barH, 3, 3, 'F');
      /* Simulated gradient: red (underbid) → green (healthy near median) → amber (above market) */
      var C0 = [176, 92, 82], C1 = [123, 160, 91], C2 = [201, 162, 75];
      var steps = Math.max(40, Math.round(barW));
      for (var s = 0; s < steps; s++) {
        var t = s / (steps - 1);
        var r, g, bb;
        if (t <= medFrac && medFrac > 0) {
          var u = t / medFrac;
          r = C0[0] + (C1[0] - C0[0]) * u; g = C0[1] + (C1[1] - C0[1]) * u; bb = C0[2] + (C1[2] - C0[2]) * u;
        } else {
          var u2 = medFrac < 1 ? (t - medFrac) / (1 - medFrac) : 0;
          r = C1[0] + (C2[0] - C1[0]) * u2; g = C1[1] + (C2[1] - C1[1]) * u2; bb = C1[2] + (C2[2] - C1[2]) * u2;
        }
        pdf.setFillColor(Math.round(r), Math.round(g), Math.round(bb));
        pdf.rect(barX + (s / steps) * barW, barY, (barW / steps) + 0.6, barH, 'F');
      }
      /* Median tick + label */
      var medX = barX + medFrac * barW;
      if (bm.medianVal != null) {
        pdf.setDrawColor(255, 255, 255);
        pdf.setLineWidth(1.2);
        pdf.line(medX, barY - 1, medX, barY + barH + 1);
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(6.8);
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        pdf.text('Median ' + bm.median, medX, barY + barH + 12, { align: 'center' });
      }
      /* Low / High end labels */
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(7.6);
      pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
      pdf.text(safe(bm.low), barX - 7, barY + barH / 2 + 2.6, { align: 'right' });
      pdf.text(safe(bm.high), barX + barW + 7, barY + barH / 2 + 2.6, { align: 'left' });
      /* Bid marker: pill above + pointer + dot on bar */
      if (bm.markerVal != null && bm.markerLabel) {
        var mFrac = frac(bm.markerVal);
        var mx = barX + mFrac * barW;
        var mLabel = safe(bm.markerLabel);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(7.6);
        var pw = pdf.getTextWidth(mLabel) + 12;
        var px = Math.min(Math.max(mx - pw / 2, barX - 30), pageW - mR - pw);
        var py = barY - 17;
        pdf.setFillColor(INK[0], INK[1], INK[2]);
        pdf.roundedRect(px, py, pw, 13, 3, 3, 'F');
        pdf.setTextColor(255, 255, 255);
        pdf.text(mLabel, px + 6, py + 9);
        pdf.setDrawColor(INK[0], INK[1], INK[2]);
        pdf.setLineWidth(1.1);
        pdf.line(mx, py + 13, mx, barY);
        pdf.setFillColor(INK[0], INK[1], INK[2]);
        pdf.circle(mx, barY + barH / 2, 2.5, 'F');
        pdf.setFillColor(255, 255, 255);
        pdf.circle(mx, barY + barH / 2, 1.1, 'F');
      }
      y = barY + barH + 22;
    }

    /* Renegotiation talking points & objections */
    if (model.opening || model.objections.length || model.targetRate) {
      sectionLabel('Renegotiation Talking Points & Objections');
      if (model.opening) {
        pdf.setFont('helvetica', 'italic');
        pdf.setFontSize(8.8);
        pdf.setTextColor(70, 66, 62);
        var oLines = pdf.splitTextToSize('\u201C' + safe(model.opening) + '\u201D', cW - 4).slice(0, 3);
        oLines.forEach(function (ln) { pdf.text(ln, mL, y); y += 11.5; });
        y += 7;
      }
      model.objections.slice(0, 2).forEach(function (o) {
        var innerX = mL + 14;
        var innerW = cW - 26;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(9);
        var qLines = pdf.splitTextToSize('\u201C' + safe(o.objection) + '\u201D', innerW);
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(9);
        var rLines = pdf.splitTextToSize(safe(o.response), innerW);
        var cardH = 12 + qLines.length * 11 + 6 + 9 + rLines.length * 11 + 10;
        pdf.setFillColor(250, 250, 251);
        pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
        pdf.setLineWidth(0.7);
        pdf.roundedRect(mL, y, cW, cardH, 4, 4, 'FD');
        pdf.setFillColor(BRAND[0], BRAND[1], BRAND[2]);
        pdf.rect(mL, y + 1, 3, cardH - 2, 'F');
        var cy = y + 14;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(9);
        setInk();
        qLines.forEach(function (ln) { pdf.text(ln, innerX, cy); cy += 11; });
        cy += 5;
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(6.8);
        pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
        pdf.text('RESPONSE', innerX, cy);
        cy += 9;
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(9);
        pdf.setTextColor(66, 62, 58);
        rLines.forEach(function (ln) { pdf.text(ln, innerX, cy); cy += 11; });
        y += cardH + 8;
      });
      if (model.targetRate) {
        var trH = 21;
        pdf.setFillColor(236, 245, 244);
        pdf.setDrawColor(BRAND[0], BRAND[1], BRAND[2]);
        pdf.setLineWidth(0.7);
        pdf.roundedRect(mL, y, cW, trH, 4, 4, 'FD');
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(9.5);
        pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
        var trLabel = 'Recommended Target Rate:  ';
        pdf.text(trLabel, mL + 12, y + 14);
        var lblW = pdf.getTextWidth(trLabel);
        setInk();
        pdf.text(safe(model.targetRate), mL + 12 + lblW, y + 14);
        y += trH + 6;
      }
    }

    /* Discreet single-line source footer (names hyperlinked in the digital PDF) */
    var footerY = pageH - 40;
    pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
    pdf.setLineWidth(0.6);
    pdf.line(mL, footerY - 11, pageW - mR, footerY - 11);
    var fsize = 7;
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(fsize);
    var prefix = 'Data Sources: ';
    function sourcesWidth(sz) {
      pdf.setFontSize(sz);
      var wtot = pdf.getTextWidth(prefix);
      model.sources.forEach(function (s, idx) {
        if (idx > 0) wtot += pdf.getTextWidth('  \u00B7  ');
        wtot += pdf.getTextWidth(safe(s.label));
      });
      return wtot;
    }
    while (sourcesWidth(fsize) > cW && fsize > 5.4) { fsize -= 0.2; }
    pdf.setFontSize(fsize);
    var fx = mL;
    pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
    pdf.text(prefix, fx, footerY);
    fx += pdf.getTextWidth(prefix);
    model.sources.forEach(function (s, idx) {
      if (idx > 0) {
        pdf.setTextColor(FAINT[0], FAINT[1], FAINT[2]);
        var sep = '  \u00B7  ';
        pdf.text(sep, fx, footerY);
        fx += pdf.getTextWidth(sep);
      }
      var name = safe(s.label);
      if (s.url) {
        pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
        if (typeof pdf.textWithLink === 'function') pdf.textWithLink(name, fx, footerY, { url: s.url });
        else pdf.text(name, fx, footerY);
      } else {
        pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
        pdf.text(name, fx, footerY);
      }
      fx += pdf.getTextWidth(name);
    });

    /* Brand page footer */
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(8);
    pdf.setTextColor(148, 163, 184);
    pdf.text('Opora Supply', mL, pageH - 22);
    pdf.text('Page 1 of 1', pageW - mR, pageH - 22, { align: 'right' });

    var safeTitle = String(opts.title || model.title)
      .replace(/[^a-zA-Z0-9_\-\s]/g, '').trim().replace(/\s+/g, '-').slice(0, 40) || 'margin-sentinel';
    var filename = 'margin-sentinel-' + safeTitle + '-' + fileStamp() + '.pdf';
    if (!savePdfFile(pdf, filename)) {
      throw new Error('Browser blocked the PDF download');
    }
    return true;
  }

  /**
   * Lost Bid Autopsy — executive briefing (usually 2 pages).
   * Page 1: title + hero + Financial/SOW | Rewritten schedules (full card text, no ellipsis).
   * Page 2+: overflow schedule cards (if any) + Competitor counter-play (+ worksheet).
   */
  function writeLostBidAutopsyPdf(JsPDF, opts) {
    opts = opts || {};
    var data = opts.data || {};
    var o = data.win_probability_original != null ? Number(data.win_probability_original) : 0;
    var r = data.win_probability_revised != null ? Number(data.win_probability_revised) : 0;
    var pf = data.primary_failure || {};
    var pm = data.pricing_math || {};
    var sb = data.sow_boundary || {};
    var ca = data.competitor_analysis || null;

    var pdf = new JsPDF({ unit: 'pt', format: 'letter', orientation: 'portrait' });
    var pageW = pdf.internal.pageSize.getWidth();
    var pageH = pdf.internal.pageSize.getHeight();
    var mL = 36, mR = 36, mB = 44, mT = 36;
    var cW = pageW - mL - mR;
    var y = mT;
    var INK = [30, 41, 59];       /* slate-800 */
    var MUTED = [100, 116, 139];  /* slate-500 */
    var FAINT = [148, 163, 184];  /* slate-400 */
    var BRAND = [15, 118, 110];   /* teal-700 */
    var BRAND_SOFT = [204, 251, 241]; /* teal-100 */
    var DOWN = [185, 28, 28];     /* red-700 — root cause */
    var DOWN_SOFT = [181, 115, 107];
    var UP = [21, 128, 61];       /* green-700 */
    var CARD_BG = [248, 250, 252];
    var CARD_BD = [226, 232, 240];
    var ROW_ALT = [241, 245, 249];
    var WHITE = [255, 255, 255];

    function safe(s) { return pdfSafeText(s); }
    function setInk() { pdf.setTextColor(INK[0], INK[1], INK[2]); }
    function setMuted() { pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]); }
    function lh(size) { return size * 1.35; }
    function wrapClip(text, maxW, maxLines) {
      pdf.setFont('helvetica', 'normal');
      var lines = pdf.splitTextToSize(safe(text), Math.max(40, maxW));
      if (maxLines && lines.length > maxLines) {
        lines = lines.slice(0, maxLines);
        var last = lines[lines.length - 1] || '';
        if (last.length > 3) lines[lines.length - 1] = last.replace(/\s+\S*$/, '') + '\u2026';
      }
      return lines;
    }
    function formatBurden(pmx) {
      if (!pmx) return '\u2014';
      if (pmx.burden_band === 'cash_unburdened' || /cash\s*\/?\s*unburdened|NON-COMPLIANT\s*\(\s*Cash/i.test(String(pmx.burden_label || pmx.burden_audit || ''))) {
        return pmx.burden_label || 'NON-COMPLIANT \u00b7 Cash / Unburdened';
      }
      if (pmx.burden_band === 'ic_1099_misclass' || /1099|misclassification/i.test(String(pmx.burden_label || pmx.burden_audit || ''))) {
        return pmx.burden_label || 'NON-COMPLIANT \u00b7 1099 Worker Misclassification';
      }
      if (pmx.burden_band === 'tsa_sida_breach' || /TSA|SIDA|1542/i.test(String(pmx.burden_label || pmx.burden_audit || ''))) {
        return pmx.burden_label || 'FATAL \u00b7 TSA SIDA Clearance Non-Compliance';
      }
      if (pmx.burden_band === 'prevailing_wage_review' || /prevailing\s+wage|REVIEW REQUIRED/i.test(String(pmx.burden_label || pmx.burden_audit || ''))) {
        return pmx.burden_label || 'REVIEW REQUIRED \u00b7 Public Prevailing Wage Floor';
      }
      if (pmx.burden_stated_pct != null && pmx.burden_band !== 'prevailing_wage_review') {
        var suf = pmx.burden_band === 'compliant' ? ' \u00b7 Compliant'
          : (pmx.burden_band === 'under' ? ' \u00b7 Under-burdened' : '');
        return pmx.burden_stated_pct + '%' + suf;
      }
      if (pmx.burden_label) return String(pmx.burden_label);
      return '\u2014';
    }
    function drawPageChrome() {
      pdf.setFillColor(BRAND[0], BRAND[1], BRAND[2]);
      pdf.rect(0, 0, pageW, 4, 'F');
    }
    function drawFooter() {
      var pages = pdf.internal.getNumberOfPages();
      var p;
      for (p = 1; p <= pages; p++) {
        pdf.setPage(p);
        pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
        pdf.setLineWidth(0.6);
        pdf.line(mL, pageH - 28, pageW - mR, pageH - 28);
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(8);
        setMuted();
        pdf.text('Opora Supply  \u00b7  Lost Bid Autopsy', mL, pageH - 16);
        pdf.text('Page ' + p + ' of ' + pages, pageW - mR, pageH - 16, { align: 'right' });
      }
    }
    function ensureSpace(need) {
      if (y + need < pageH - mB) return false;
      pdf.addPage();
      drawPageChrome();
      y = mT + 8;
      return true;
    }
    function roundedCard(x, yy, w, h, fill) {
      pdf.setFillColor(fill[0], fill[1], fill[2]);
      pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
      pdf.setLineWidth(0.8);
      pdf.roundedRect(x, yy, w, h, 8, 8, 'FD');
    }

    var dateStr = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    drawPageChrome();

    /* Title row */
    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(18);
    setInk();
    pdf.text('Lost Bid Autopsy', mL, y + 2);
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(9);
    setMuted();
    pdf.text('Generated ' + dateStr, pageW - mR, y + 2, { align: 'right' });
    y += 22;

    /* ── Hero: odds left · root cause fills right (no empty gutter) ── */
    var heroSum = String(pf.description || data.analysis || '').trim();
    var basis = String(data.win_probability_basis || '').trim();
    var leftColW = Math.floor(cW * 0.40);
    var rightColX = mL + leftColW + 16;
    var rightColW = cW - leftColW - 34;

    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(10.5);
    var rcPreview = pf.category
      ? wrapClip(String(pf.category), rightColW, 3)
      : [];
    /* Measure body with the font size we will draw */
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(10);
    var sumLines = heroSum ? wrapClip(heroSum, cW - 36, 4) : [];
    pdf.setFont('helvetica', 'italic');
    pdf.setFontSize(8.5);
    var basisLines = basis ? wrapClip(basis, cW - 36, 2) : [];

    var oddsBlockH = 40; /* % line + WIN ODDS under */
    var rcBlockH = pf.category ? (14 + rcPreview.length * lh(10.5)) : 0;
    var topRowH = Math.max(oddsBlockH, rcBlockH);
    var heroH = 18 + topRowH + 10 +
      sumLines.length * lh(10) +
      (basisLines.length ? 6 + basisLines.length * lh(8.5) : 0) + 16;
    ensureSpace(heroH + 8);
    roundedCard(mL, y, cW, heroH, CARD_BG);
    var hx = mL + 18;
    var hy = y + 28;

    /* Odds: 35% -> 55%  (ASCII arrow — Helvetica has no U+2192) */
    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(24);
    pdf.setTextColor(DOWN_SOFT[0], DOWN_SOFT[1], DOWN_SOFT[2]);
    var oStr = String(o) + '%';
    pdf.text(oStr, hx, hy);
    var oW = pdf.getTextWidth(oStr);

    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(14);
    pdf.setTextColor(FAINT[0], FAINT[1], FAINT[2]);
    var arrowStr = '->';
    pdf.text(arrowStr, hx + oW + 7, hy - 1);
    var arrowW = pdf.getTextWidth(arrowStr);

    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(24);
    pdf.setTextColor(UP[0], UP[1], UP[2]);
    var rStr = String(r) + '%';
    pdf.text(rStr, hx + oW + 7 + arrowW + 7, hy);

    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(7.5);
    pdf.setTextColor(FAINT[0], FAINT[1], FAINT[2]);
    pdf.text('WIN ODDS', hx, hy + 14);

    /* Root cause — right column fills the gutter the user circled */
    if (pf.category) {
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(7.5);
      pdf.setTextColor(DOWN[0], DOWN[1], DOWN[2]);
      pdf.text('ROOT CAUSE', rightColX, hy - 12);
      pdf.setFontSize(10.5);
      pdf.setTextColor(DOWN[0], DOWN[1], DOWN[2]);
      rcPreview.forEach(function (ln, i) {
        pdf.text(ln, rightColX, hy + 2 + i * lh(10.5));
      });
    }

    var bodyY = y + 18 + topRowH + 8;
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(10);
    setInk();
    sumLines.forEach(function (ln) {
      pdf.text(ln, hx, bodyY);
      bodyY += lh(10);
    });
    if (basisLines.length) {
      bodyY += 3;
      pdf.setFont('helvetica', 'italic');
      pdf.setFontSize(8.5);
      setMuted();
      basisLines.forEach(function (ln) {
        pdf.text(ln, hx, bodyY);
        bodyY += lh(8.5);
      });
    }
    y += heroH + 16;

    /* ── Two column cards ── */
    var gap = 14;
    var colW = (cW - gap) / 2;
    var leftX = mL;
    var rightX = mL + colW + gap;
    var pad = 14;

    var deltaPct = (!isNaN(o) && !isNaN(r))
      ? ((r - o > 0 ? '+' : '') + (r - o) + '%')
      : '\u2014';
    var scaffoldRows = [
      ['Effective rate', (pm.effective_rate != null && !isNaN(Number(pm.effective_rate)))
        ? ('$' + Number(pm.effective_rate).toFixed(2) + '/hr')
        : (pm.loaded_crew_note || '\u2014')],
      ['Statutory load', formatBurden(pm)],
      ['Production rate', pm.production_sqft_hr != null
        ? (Number(pm.production_sqft_hr).toLocaleString() + ' sq ft/hr')
        : (pm.production_note || '\u2014')],
      ['Win odds delta', deltaPct]
    ];

    var baseItems = (sb.included_in_base && sb.included_in_base.length)
      ? sb.included_in_base
      : (sb.routine_scope ? [sb.routine_scope] : ['Nightly / daily routine janitorial']);
    var billItems = (sb.separated_billback && sb.separated_billback.length)
      ? sb.separated_billback
      : (sb.periodic_carveouts || []);
    billItems = (billItems || []).filter(function (x) {
      var t = String(x || '');
      return t.length > 0 && t.length <= 180 && !/routine base janitorial covers only/i.test(t);
    });
    if (!billItems.length) billItems = ['Periodic / restorative work billed per occurrence'];

    var rwList = Array.isArray(data.rewrites) ? data.rewrites.slice(0, 3) : [];
    /* Remaining page-1 budget after hero — pack dual grid here; never orphan blank page */
    var page1Floor = pageH - mB;
    var remainAfterHero = Math.max(160, page1Floor - y - 8);

    /* Full schedule bodies — never ellipsis-clip mid-sentence (spill to page 2 instead) */
    function measureRewriteBlockFull(rw, maxW) {
      var body = String(rw.suggested || rw.original || '');
      var bodyLines = wrapClip(body, maxW - 20, 0);
      return 12 + 14 + bodyLines.length * lh(8.5) + 14;
    }
    function measureRightBodyFor(list) {
      var h = 22;
      if (!list.length) return h + 40;
      list.forEach(function (rw) { h += measureRewriteBlockFull(rw, colW - pad * 2) + 10; });
      return h + pad;
    }

    /* Trim SOW lists if left column would exceed page-1 budget */
    var baseCap = 4;
    var billCap = 4;
    function measureLeftBodyCapped(bCap, bilCap) {
      var h = 0;
      h += 22;
      h += 18;
      var splitPreview = (colW - pad * 2) * 0.38;
      var valWPreview = (colW - pad * 2) - splitPreview - 16;
      var tableBodyH = 16;
      scaffoldRows.forEach(function (row) {
        var vLines = wrapClip(String(row[1]), valWPreview, 3);
        tableBodyH += Math.max(18, vLines.length * 11 + 6);
      });
      h += tableBodyH + 8;
      h += 16;
      if (pm.verdict) {
        var vl = wrapClip(String(pm.verdict), colW - pad * 2 - 12, 3);
        h += 4 + vl.length * lh(8.5) + 12;
      }
      h += 16;
      h += 14;
      baseItems.slice(0, bCap).forEach(function (item) {
        h += wrapClip(String(item), colW - pad * 2 - 12, 2).length * lh(8.5) + 4;
      });
      h += 14;
      billItems.slice(0, bilCap).forEach(function (item) {
        h += wrapClip(String(item), colW - pad * 2 - 12, 2).length * lh(8.5) + 4;
      });
      return h + pad;
    }

    var leftInner = measureLeftBodyCapped(baseCap, billCap);
    while ((leftInner > remainAfterHero) && (baseCap > 2 || billCap > 2)) {
      if (baseCap > 2) baseCap -= 1;
      else if (billCap > 2) billCap -= 1;
      else break;
      leftInner = measureLeftBodyCapped(baseCap, billCap);
    }

    /* Pack whole schedule cards onto page 1; overflow (never truncated) goes to page 2 */
    var page1Rewrites = [];
    var overflowRewrites = [];
    var packedRight = 22 + pad;
    rwList.forEach(function (rw) {
      var cardH = measureRewriteBlockFull(rw, colW - pad * 2) + 10;
      var nextH = packedRight + cardH;
      if (nextH <= remainAfterHero) {
        page1Rewrites.push(rw);
        packedRight = nextH;
      } else {
        overflowRewrites.push(rw);
      }
    });
    /* Oversized first card: spill all schedules rather than ellipsis-clip */
    if (!page1Rewrites.length && rwList.length) {
      overflowRewrites = rwList.slice();
    }

    var rightInner = measureRightBodyFor(page1Rewrites);
    var colH = Math.min(remainAfterHero, Math.max(leftInner, rightInner, 160));

    /* Only new-page if residual space is unusable (< 140pt) — never leave hero alone on page 1 */
    if (remainAfterHero < 140) {
      pdf.addPage();
      drawPageChrome();
      y = mT + 8;
      remainAfterHero = pageH - mB - y;
      colH = Math.min(remainAfterHero, Math.max(leftInner, rightInner, 160));
    }

    var colTop = y;
    roundedCard(leftX, colTop, colW, colH, WHITE);
    roundedCard(rightX, colTop, colW, colH, WHITE);

    /* Left column content */
    var yL = colTop + pad + 4;
    var xL = leftX + pad;
    var innerLW = colW - pad * 2;

    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(8);
    pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
    pdf.text('FINANCIAL & SOW AUDIT', xL, yL);
    yL += 6;
    pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
    pdf.setLineWidth(0.6);
    pdf.line(xL, yL, xL + innerLW, yL);
    yL += 14;

    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(10);
    setInk();
    pdf.text('Pricing scaffold', xL, yL);
    yL += 10;

    var splitX = xL + innerLW * 0.38;
    var valColW = innerLW - (splitX - xL) - 14;
    var rowHeights = scaffoldRows.map(function (row) {
      var vLines = wrapClip(String(row[1]), valColW, 3);
      return Math.max(18, vLines.length * 11 + 6);
    });
    var tableH = 16;
    rowHeights.forEach(function (rh) { tableH += rh; });
    pdf.setFillColor(CARD_BG[0], CARD_BG[1], CARD_BG[2]);
    pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
    pdf.roundedRect(xL, yL, innerLW, tableH, 5, 5, 'FD');
    var ty = yL + 11;
    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(7);
    pdf.setTextColor(FAINT[0], FAINT[1], FAINT[2]);
    pdf.text('METRIC', xL + 8, ty);
    pdf.text('VALUE', splitX + 8, ty);
    ty += 5;
    pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
    pdf.line(xL + 4, ty, xL + innerLW - 4, ty);
    ty += 10;
    scaffoldRows.forEach(function (row, idx) {
      var rh = rowHeights[idx];
      var rowTop = ty - 10;
      if (idx % 2 === 1) {
        pdf.setFillColor(ROW_ALT[0], ROW_ALT[1], ROW_ALT[2]);
        pdf.rect(xL + 2, rowTop, innerLW - 4, rh - 1, 'F');
      }
      pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
      pdf.setLineWidth(0.5);
      pdf.line(splitX, rowTop, splitX, rowTop + rh - 1);
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8.5);
      setInk();
      pdf.text(safe(row[0]), xL + 8, ty);
      pdf.setFont('helvetica', 'bold');
      var valLines = wrapClip(String(row[1]), valColW, 3);
      valLines.forEach(function (ln, li) {
        pdf.text(ln, splitX + 8, ty + li * 11);
      });
      ty += rh;
    });
    /* Clear air between scaffold table and Verdict */
    yL = yL + tableH + 18;

    if (pm.verdict) {
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(8.5);
      setInk();
      pdf.text('Verdict:', xL, yL);
      var vLead = pdf.getTextWidth('Verdict: ');
      pdf.setFont('helvetica', 'normal');
      var vLines = wrapClip(String(pm.verdict), Math.max(40, innerLW - vLead), 4);
      vLines.forEach(function (ln, i) {
        pdf.text(ln, xL + (i === 0 ? vLead : 0), yL + i * lh(8.5));
      });
      yL += Math.max(1, vLines.length) * lh(8.5) + 14;
    }

    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(10);
    setInk();
    pdf.text('SOW boundary', xL, yL);
    yL += 12;

    function drawList(label, items) {
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(8);
      setMuted();
      pdf.text(label, xL, yL);
      yL += 11;
      items.slice(0, 5).forEach(function (item) {
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(8.5);
        setInk();
        pdf.text('\u2022', xL, yL);
        var lines = wrapClip(String(item), innerLW - 12, 3);
        lines.forEach(function (ln, i) {
          pdf.text(ln, xL + 10, yL + i * lh(8.5));
        });
        yL += Math.max(1, lines.length) * lh(8.5) + 3;
      });
      yL += 4;
    }
    drawList('Included in base', baseItems.slice(0, baseCap));
    drawList('Separated as bill-back / excluded', billItems.slice(0, billCap));

    /* Right column — contract schedule cards (page-1 only; no full-text dump) */
    var yR = colTop + pad + 4;
    var xR = rightX + pad;
    var innerRW = colW - pad * 2;

    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(8);
    pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
    pdf.text('REWRITTEN CONTRACT SCHEDULES', xR, yR);
    yR += 6;
    pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
    pdf.setLineWidth(0.6);
    pdf.line(xR, yR, xR + innerRW, yR);
    yR += 12;

    function drawRewriteCard(x, yy, w, rw, floorY) {
      var title = String(rw.section || 'Rewrite');
      var body = String(rw.suggested || rw.original || '');
      var textPad = 14;
      var textW = Math.max(40, w - textPad - 10);
      /* Full body — no maxLines / ellipsis */
      var bodyLines = wrapClip(body, textW, 0);
      var blockH = 14 + 14 + bodyLines.length * lh(8.5) + 14;
      /* Keep card intact: skip (caller spills) rather than truncate */
      if (floorY != null && yy + blockH > floorY) return yy;
      pdf.setFillColor(248, 250, 252);
      pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
      pdf.setLineWidth(0.6);
      pdf.roundedRect(x, yy, w, blockH, 5, 5, 'FD');
      pdf.setFillColor(BRAND[0], BRAND[1], BRAND[2]);
      pdf.rect(x, yy + 4, 3.5, blockH - 8, 'F');
      var cy = yy + 15;
      var tx = x + textPad;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(9.5);
      setInk();
      pdf.text(safe(title), tx, cy);
      cy += 13;
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8.5);
      setInk();
      bodyLines.forEach(function (ln) {
        pdf.text(ln, tx, cy);
        cy += lh(8.5);
      });
      return yy + blockH + 8;
    }

    if (page1Rewrites.length) {
      page1Rewrites.forEach(function (rw) {
        yR = drawRewriteCard(xR, yR, innerRW, rw, colTop + colH - 4);
      });
    } else if (overflowRewrites.length) {
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8.5);
      setMuted();
      pdf.text('Full contract schedules continue on the next page.', xR, yR);
    } else if (!rwList.length) {
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8.5);
      setMuted();
      pdf.text('Carve bill-back lines with paste-ready dollars and exclusions.', xR, yR);
    }

    /* Page 2+: overflow schedule cards (full text) then competitor / worksheet */
    var worksheet = Array.isArray(data.pre_bid_worksheet) ? data.pre_bid_worksheet
      : (Array.isArray(data.next_bid_worksheet) ? data.next_bid_worksheet : []);
    var hasCompetitor = !!(ca && ca.company_name && !/^unknown/i.test(String(ca.company_name)));
    var hasWorksheet = worksheet.length > 0;
    var hasOverflowSchedules = overflowRewrites.length > 0;

    if (hasOverflowSchedules || hasCompetitor || hasWorksheet) {
      pdf.addPage();
      drawPageChrome();
      y = mT + 8;
    }

    if (hasOverflowSchedules) {
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(8);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      pdf.text('REWRITTEN CONTRACT SCHEDULES' + (page1Rewrites.length ? '  \u00b7  CONTINUED' : ''), mL, y);
      y += 6;
      pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
      pdf.setLineWidth(0.6);
      pdf.line(mL, y, pageW - mR, y);
      y += 12;
      overflowRewrites.forEach(function (rw) {
        var need = measureRewriteBlockFull(rw, cW) + 12;
        ensureSpace(need);
        y = drawRewriteCard(mL, y, cW, rw, pageH - mB);
      });
      y += 8;
    }

    if (hasCompetitor) {
      var diffsFw = (ca.how_to_differentiate && ca.how_to_differentiate.length)
        ? ca.how_to_differentiate
        : (ca.likely_strengths || []);
      var stratLines = ca.likely_pricing_strategy ? wrapClip(ca.likely_pricing_strategy, cW - 32, 4) : [];
      var diffBlocks = diffsFw.slice(0, 4).map(function (item) {
        return wrapClip(String(item), (cW - 48) / 2, 3);
      });
      var stripH = 28 + stratLines.length * lh(9) + 10;
      /* two-column tactics */
      var half = Math.ceil(diffBlocks.length / 2);
      var leftH = 0, rightH = 0;
      diffBlocks.forEach(function (ls, i) {
        var bh = ls.length * lh(8.5) + 8;
        if (i < half) leftH += bh; else rightH += bh;
      });
      stripH += Math.max(leftH, rightH) + 16;
      ensureSpace(stripH + 8);
      roundedCard(mL, y, cW, stripH, CARD_BG);
      var sy = y + 18;
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(8);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      pdf.text('COMPETITOR COUNTER-PLAY  \u00b7  ' + safe(ca.company_name).toUpperCase(), mL + 14, sy);
      sy += 14;
      if (stratLines.length) {
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(9);
        setInk();
        stratLines.forEach(function (ln) { pdf.text(ln, mL + 14, sy); sy += lh(9); });
        sy += 6;
      }
      var colMid = mL + cW / 2;
      var yLeft = sy;
      var yRight = sy;
      diffBlocks.forEach(function (ls, i) {
        var useLeft = i < half;
        var bx = useLeft ? (mL + 14) : (colMid + 6);
        var by = useLeft ? yLeft : yRight;
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(8.5);
        setInk();
        pdf.text('\u2022', bx, by);
        ls.forEach(function (ln, li) {
          pdf.text(ln, bx + 12, by + li * lh(8.5));
        });
        var step = Math.max(1, ls.length) * lh(8.5) + 8;
        if (useLeft) yLeft += step; else yRight += step;
      });
      y += stripH + 14;
    }

    if (hasWorksheet) {
      ensureSpace(80);
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(8);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      pdf.text('NEXT-BID WORKSHEET', mL, y);
      y += 8;
      pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
      pdf.line(mL, y, pageW - mR, y);
      y += 12;
      worksheet.slice(0, 8).forEach(function (item) {
        var label = typeof item === 'string' ? item : (item.item || item.check || item.title || '');
        var why = typeof item === 'object' ? (item.why_it_matters || item.why || '') : '';
        var lines = wrapClip(label + (why ? ' \u2014 ' + why : ''), cW - 20, 3);
        var need = lines.length * lh(8.5) + 8;
        ensureSpace(need + 4);
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(8.5);
        setInk();
        pdf.text('\u2022', mL, y);
        lines.forEach(function (ln, i) {
          pdf.text(ln, mL + 12, y + i * lh(8.5));
        });
        y += need;
      });
    }

    drawFooter();

    var safeTitle = String(opts.title || 'lost-bid-autopsy')
      .replace(/[^a-zA-Z0-9_\-\s]/g, '').trim().replace(/\s+/g, '-').slice(0, 40) || 'lost-bid-autopsy';
    var filename = 'lost-bid-autopsy-' + safeTitle + '-' + fileStamp() + '.pdf';
    if (!savePdfFile(pdf, filename)) {
      throw new Error('Browser blocked the PDF download');
    }
    return true;
  }

  function writeHireRightPdf(JsPDF, opts) {
    opts = opts || {};
    var data = opts.data || {};
    var meta = hireRightMeta(data);
    var ca = data.compensation_analysis || {};
    var cr = data.classification_recommendation || {};
    var qs = Array.isArray(data.interview_questions) ? data.interview_questions : [];
    var flags = Array.isArray(data.red_flags_to_avoid) ? data.red_flags_to_avoid : [];

    var pdf = new JsPDF({ unit: 'pt', format: 'letter', orientation: 'portrait' });
    var pageW = pdf.internal.pageSize.getWidth();
    var pageH = pdf.internal.pageSize.getHeight();
    var mL = 40, mR = 40, mB = 42;
    var cW = pageW - mL - mR;
    var y = 36;
    var INK = [26, 24, 22];
    var MUTED = [112, 108, 104];
    var FAINT = [140, 136, 132];
    var BRAND = [15, 122, 112];
    var WARN = [156, 88, 48];
    var CARD_BG = [248, 249, 250];
    var CARD_BD = [226, 229, 233];
    var WARN_BG = [255, 248, 240];
    var WARN_BD = [232, 208, 184];

    function safe(s) { return pdfSafeText(s); }
    function setInk() { pdf.setTextColor(INK[0], INK[1], INK[2]); }
    function setMuted() { pdf.setTextColor(MUTED[0], MUTED[1], MUTED[2]); }
    function lh(size) { return size * 1.28; }
    function wrapClip(text, maxW, maxLines) {
      pdf.setFont('helvetica', 'normal');
      var lines = pdf.splitTextToSize(safe(text), Math.max(40, maxW));
      if (maxLines && lines.length > maxLines) {
        lines = lines.slice(0, maxLines);
        var last = lines[lines.length - 1] || '';
        if (last.length > 3) lines[lines.length - 1] = last.replace(/\s+\S*$/, '') + '\u2026';
      }
      return lines;
    }
    function ensureSpace(need) {
      if (y + need < pageH - mB) return;
      pdf.addPage();
      pdf.setFillColor(BRAND[0], BRAND[1], BRAND[2]);
      pdf.rect(0, 0, pageW, 3, 'F');
      y = 36;
    }
    function footerOnPage(pageNum, total) {
      var fy = pageH - 24;
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8);
      setMuted();
      pdf.text('Opora Supply', mL, fy);
      pdf.text('Page ' + pageNum + ' of ' + total, pageW - mR, fy, { align: 'right' });
    }
    function sectionKicker(label) {
      ensureSpace(28);
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(8);
      pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
      pdf.text(String(label).toUpperCase(), mL, y);
      y += 4;
      pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
      pdf.setLineWidth(0.6);
      pdf.line(mL, y, pageW - mR, y);
      y += 12;
    }
    function mdPlainBlocks(md) {
      var raw = String(md || '').replace(/\r\n/g, '\n').trim();
      if (!raw) return [];
      var blocks = [];
      var cur = { heading: '', paras: [], bullets: [] };
      function flush() {
        if (cur.heading || cur.paras.length || cur.bullets.length) {
          blocks.push(cur);
          cur = { heading: '', paras: [], bullets: [] };
        }
      }
      raw.split('\n').forEach(function (line) {
        var t = line.trim();
        if (!t) {
          if (cur.paras.length || cur.bullets.length) flush();
          return;
        }
        var hm = t.match(/^#{1,4}\s+(.+)$/);
        if (hm) {
          flush();
          cur.heading = hm[1].replace(/\*+/g, '').trim();
          return;
        }
        var bm = t.match(/^[-*•]\s+(.+)$/) || t.match(/^\d+[.)]\s+(.+)$/);
        if (bm) {
          cur.bullets.push(bm[1].replace(/\*\*/g, '').trim());
          return;
        }
        cur.paras.push(t.replace(/\*\*/g, '').replace(/\*/g, ''));
      });
      flush();
      return blocks;
    }
    function drawMdBlocks(blocks, maxBulletsPer) {
      maxBulletsPer = maxBulletsPer || 8;
      (blocks || []).forEach(function (b) {
        if (b.heading) {
          ensureSpace(22);
          pdf.setFont('helvetica', 'bold');
          pdf.setFontSize(10.5);
          setInk();
          pdf.text(safe(b.heading), mL, y);
          y += lh(10.5) + 2;
        }
        (b.paras || []).forEach(function (p) {
          var lines = wrapClip(p, cW, 8);
          ensureSpace(lines.length * lh(9) + 6);
          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(9);
          setInk();
          lines.forEach(function (ln) { pdf.text(ln, mL, y); y += lh(9); });
          y += 4;
        });
        (b.bullets || []).slice(0, maxBulletsPer).forEach(function (bu) {
          var lines = wrapClip(bu, cW - 14, 4);
          ensureSpace(lines.length * lh(9) + 4);
          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(9);
          setInk();
          pdf.text('\u2022', mL, y);
          lines.forEach(function (ln, i) {
            pdf.text(ln, mL + 12, y + i * lh(9));
          });
          y += Math.max(1, lines.length) * lh(9) + 2;
        });
        y += 4;
      });
    }

    var dateStr = new Date().toLocaleDateString('en-US', {
      year: 'numeric', month: 'long', day: 'numeric'
    });
    var locBits = [];
    if (meta.metro) locBits.push(meta.metro);
    if (meta.state && (!meta.metro || meta.metro.indexOf(meta.state) < 0)) locBits.push(meta.state);
    var locLine = locBits.join(', ');

    /* ── Page 1 header ── */
    pdf.setFillColor(BRAND[0], BRAND[1], BRAND[2]);
    pdf.rect(0, 0, pageW, 3, 'F');

    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(15);
    setInk();
    var h1 = 'Hiring & Compensation Brief: ' + meta.role;
    var h1Lines = wrapClip(h1, cW, 2);
    h1Lines.forEach(function (ln) { pdf.text(ln, mL, y); y += lh(15); });
    y += 2;
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(9.5);
    setMuted();
    var sub = 'Prepared for ' + meta.company +
      (locLine ? (' \u00b7 ' + locLine) : '') +
      ' \u00b7 Generated ' + dateStr;
    wrapClip(sub, cW, 2).forEach(function (ln) { pdf.text(ln, mL, y); y += lh(9.5); });
    y += 6;
    pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
    pdf.setLineWidth(0.8);
    pdf.line(mL, y, pageW - mR, y);
    y += 14;

    /* ── Top grid: Compensation | Legal ── */
    var gap = 16;
    var colW = (cW - gap) / 2;
    var leftX = mL;
    var rightX = mL + colW + gap;
    var cardPad = 12;
    var cardInnerW = colW - cardPad * 2;

    function measureCompCard() {
      var h = cardPad + 14;
      h += 16; // base
      if (ca.loaded_low != null || ca.loaded_high != null) h += 16;
      if (ca.ot_low != null || ca.ot_high != null) h += 16;
      if (ca.burden_pct != null || ca.loaded_breakdown) {
        /* Statutory stack footnote — allow full wrap (was clipped at 4 lines) */
        h += wrapClip(ca.loaded_breakdown || ('Statutory burden +' + ca.burden_pct + '%'), cardInnerW, 12).length * (7.5 * 1.25) + 10;
      }
      if (ca.reasoning) h += wrapClip(ca.reasoning, cardInnerW, 3).length * lh(8) + 6;
      return Math.max(h + cardPad, 118);
    }
    function measureLegalCard() {
      var h = cardPad + 14;
      var verdict = cr.w2_or_1099 || 'W-2 strongly recommended';
      h += 18;
      if (cr.reasoning) h += wrapClip(cr.reasoning, cardInnerW, 4).length * lh(8) + 6;
      var risk = String(cr.state_specific_risks || '').trim();
      if (risk) h += wrapClip(risk, cardInnerW - 8, 6).length * lh(8) + 28;
      else if (meta.state === 'FL') {
        h += wrapClip(
          'Florida E-Verify (SB 1718 / §448.095) is mandatory for private employers with 25+ employees. Failure risks $1,000/day penalties via DEO.',
          cardInnerW - 8, 5
        ).length * lh(8) + 28;
      }
      return Math.max(h + cardPad, 118);
    }

    var leftH = measureCompCard();
    var rightH = measureLegalCard();
    var gridH = Math.max(leftH, rightH);
    ensureSpace(gridH + 12);

    /* Left card — compensation */
    pdf.setFillColor(CARD_BG[0], CARD_BG[1], CARD_BG[2]);
    pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
    pdf.setLineWidth(0.8);
    pdf.roundedRect(leftX, y, colW, gridH, 5, 5, 'FD');
    var cy = y + cardPad + 10;
    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(8);
    pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
    pdf.text('WAGE & BURDEN MATRIX', leftX + cardPad, cy);
    cy += 14;
    function wageRow(label, value) {
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8.5);
      setMuted();
      pdf.text(label, leftX + cardPad, cy);
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(9.5);
      setInk();
      pdf.text(safe(value), leftX + colW - cardPad, cy, { align: 'right' });
      cy += 15;
    }
    wageRow('Base rate', hireMoneyBand(ca.range_low, ca.range_high, 0) + '/hr');
    if (ca.loaded_low != null || ca.loaded_high != null) {
      var loadLbl = 'Loaded' + (ca.burden_pct != null ? (' (+' + ca.burden_pct + '%)') : '');
      wageRow(loadLbl, hireMoneyBand(ca.loaded_low, ca.loaded_high, 0) + '/hr');
    }
    if (ca.ot_low != null || ca.ot_high != null) {
      wageRow('FLSA OT (1.5\u00d7)', hireMoneyBand(ca.ot_low, ca.ot_high, 2) + '/hr');
    }
    if (ca.loaded_breakdown) {
      cy += 2;
      pdf.setFont('helvetica', 'normal');
      /* ~0.75rem / line-height 1.25 — full statutory stack, no ellipsis clip */
      pdf.setFontSize(7.5);
      setMuted();
      wrapClip(ca.loaded_breakdown, cardInnerW, 12).forEach(function (ln) {
        pdf.text(ln, leftX + cardPad, cy);
        cy += 7.5 * 1.25;
      });
    }

    /* Right card — classification / E-Verify */
    pdf.setFillColor(CARD_BG[0], CARD_BG[1], CARD_BG[2]);
    pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
    pdf.roundedRect(rightX, y, colW, gridH, 5, 5, 'FD');
    var ry = y + cardPad + 10;
    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(8);
    pdf.setTextColor(BRAND[0], BRAND[1], BRAND[2]);
    pdf.text('CLASSIFICATION & LEGAL', rightX + cardPad, ry);
    ry += 14;
    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(12);
    setInk();
    pdf.text(safe(cr.w2_or_1099 || 'W-2 strongly recommended'), rightX + cardPad, ry);
    ry += 14;
    if (cr.reasoning) {
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8);
      setInk();
      wrapClip(cr.reasoning, cardInnerW, 4).forEach(function (ln) {
        pdf.text(ln, rightX + cardPad, ry);
        ry += lh(8);
      });
      ry += 6;
    }
    var riskTxt = String(cr.state_specific_risks || '').trim();
    if (!riskTxt && meta.state === 'FL') {
      riskTxt = 'Florida E-Verify (SB 1718 / Fla. Stat. \u00a7448.095) is MANDATORY for private employers with 25+ employees. Failure to enroll/use E-Verify risks $1,000/day penalties via Florida DEO.';
    }
    if (ca.ny_spread_of_hours_note && !/146-1\.6|spread of hours/i.test(riskTxt)) {
      riskTxt = (riskTxt ? riskTxt + ' ' : '') + String(ca.ny_spread_of_hours_note).trim();
    }
    var alertSrc = Array.isArray(data.alert_box_items) && data.alert_box_items.length
      ? data.alert_box_items
      : (Array.isArray(data.statutory_alerts) ? data.statutory_alerts : []);
    alertSrc.forEach(function (a) {
      var t = String(a || '').trim();
      if (!t || /Standard federal FLSA\s+(compliance|overtime)/i.test(t) || /verify local wage orders/i.test(t)) return;
      if (t && riskTxt.indexOf(t) < 0) riskTxt = (riskTxt ? riskTxt + ' ' : '') + t;
    });
    if (riskTxt) {
      var riskLines = wrapClip(riskTxt, cardInnerW - 10, 6);
      var boxH = riskLines.length * lh(8) + 16;
      if (ry + boxH < y + gridH - 8) {
        pdf.setFillColor(WARN_BG[0], WARN_BG[1], WARN_BG[2]);
        pdf.setDrawColor(WARN_BD[0], WARN_BD[1], WARN_BD[2]);
        pdf.roundedRect(rightX + cardPad - 2, ry - 8, cardInnerW + 4, boxH, 3, 3, 'FD');
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(7);
        pdf.setTextColor(WARN[0], WARN[1], WARN[2]);
        pdf.text('STATUTORY WARNING', rightX + cardPad + 4, ry);
        ry += 11;
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(7.5);
        setInk();
        riskLines.forEach(function (ln) {
          pdf.text(ln, rightX + cardPad + 4, ry);
          ry += lh(7.5);
        });
      }
    }

    y += gridH + 16;

    /* ── Job description ── */
    sectionKicker('Job description');
    var jdBlocks = mdPlainBlocks(data.job_description_markdown);
    if (jdBlocks.length) {
      drawMdBlocks(jdBlocks, 8);
    } else {
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(9);
      setMuted();
      pdf.text('No job description returned.', mL, y);
      y += 14;
    }

    /* Force page 2 for operational kit */
    pdf.addPage();
    pdf.setFillColor(BRAND[0], BRAND[1], BRAND[2]);
    pdf.rect(0, 0, pageW, 3, 'F');
    y = 36;

    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(14);
    setInk();
    pdf.text('Field Operational Kit', mL, y);
    y += 6;
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(9);
    setMuted();
    pdf.text(safe(meta.role + ' \u00b7 ' + meta.company), mL, y + 10);
    y += 22;
    pdf.setDrawColor(CARD_BD[0], CARD_BD[1], CARD_BD[2]);
    pdf.setLineWidth(0.8);
    pdf.line(mL, y, pageW - mR, y);
    y += 14;

    /* Interview */
    sectionKicker('Vetting & interview guide');
    if (qs.length) {
      qs.slice(0, 5).forEach(function (q, i) {
        var qLines = wrapClip((i + 1) + '. ' + (q.question || 'Question'), cW, 3);
        var whyLines = q.why_we_ask ? wrapClip('Why we ask: ' + q.why_we_ask, cW - 10, 3) : [];
        var listenLines = q.what_to_listen_for ? wrapClip('Listen for: ' + q.what_to_listen_for, cW - 10, 3) : [];
        var need = qLines.length * lh(9.5) + whyLines.length * lh(8) + listenLines.length * lh(8) + 14;
        ensureSpace(need);
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(9.5);
        setInk();
        qLines.forEach(function (ln) { pdf.text(ln, mL, y); y += lh(9.5); });
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(8);
        setMuted();
        whyLines.forEach(function (ln) { pdf.text(ln, mL + 10, y); y += lh(8); });
        listenLines.forEach(function (ln) { pdf.text(ln, mL + 10, y); y += lh(8); });
        y += 8;
      });
    } else {
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(9);
      setMuted();
      pdf.text('No interview prompts returned.', mL, y);
      y += 14;
    }

    /* 30/60/90 */
    sectionKicker('30 / 60 / 90 day milestones');
    var planBlocks = mdPlainBlocks(data.onboarding_plan_markdown);
    if (planBlocks.length) {
      drawMdBlocks(planBlocks, 6);
    } else {
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(9);
      setMuted();
      pdf.text('No onboarding plan returned.', mL, y);
      y += 14;
    }

    /* Red flags */
    sectionKicker('Disqualification triggers');
    if (flags.length) {
      flags.slice(0, 10).forEach(function (f) {
        var lines = wrapClip(String(f), cW - 14, 3);
        ensureSpace(lines.length * lh(9) + 4);
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(9);
        setInk();
        pdf.text('\u2022', mL, y);
        lines.forEach(function (ln, i) { pdf.text(ln, mL + 12, y + i * lh(9)); });
        y += Math.max(1, lines.length) * lh(9) + 3;
      });
    } else {
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(9);
      setMuted();
      pdf.text('No red flags returned.', mL, y);
    }

    var totalPages = pdf.internal.getNumberOfPages();
    for (var pi = 1; pi <= totalPages; pi++) {
      pdf.setPage(pi);
      footerOnPage(pi, totalPages);
    }

    var safeRole = String(meta.role || 'hire-right')
      .replace(/[^a-zA-Z0-9_\-\s]/g, '').trim().replace(/\s+/g, '-').slice(0, 36) || 'hire-right';
    var filename = 'hire-right-' + safeRole + '-' + fileStamp() + '.pdf';
    if (!savePdfFile(pdf, filename)) {
      throw new Error('Browser blocked the PDF download');
    }
    return true;
  }

  var _lastEdgeDetail = null;

  function pageToolSlug() {
    if (_lastEdgeDetail && _lastEdgeDetail.slug) return _lastEdgeDetail.slug;
    var meta = d.querySelector('meta[name="opora:tool-slug"]');
    if (meta && meta.content) return meta.content;
    var hidden = d.getElementById('_d4_tool_slug');
    if (hidden && hidden.value) return hidden.value;
    try {
      var m = (w.location.pathname || '').match(/\/pages\/([a-z0-9-]+)/i);
      if (m) return m[1];
    } catch (e) {}
    return '';
  }

  function defaultDownloadPdf(detail) {
    detail = detail || _lastEdgeDetail || {};
    if (!detail.outputEl) detail.outputEl = d.getElementById('opResult') || d.getElementById('opDocBody');
    if (!detail.slug) detail.slug = pageToolSlug();
    var state = snapshot(detail);
    var body = (state.payload && (state.payload.body_markdown || state.payload.content)) || '';
    if (detail.slug === 'bid-drafter') {
      if (detail.data && detail.data.proposal_markdown) {
        body = String(detail.data.proposal_markdown).trim();
      } else if (looksLikeBidUiChrome(body) || !String(body).trim()) {
        body = proposalOnlyFromDom() || body;
      }
      body = sanitizeBidPdfBody(body);
    }
    if (detail.slug === 'customer-recovery' && detail.data && typeof detail.data === 'object') {
      toast('Downloading PDF…');
      return ensureJsPdf().then(function (JsPDF) {
        try {
          var crMd = (typeof w.OporaCustomerRecoveryToMarkdown === 'function')
            ? w.OporaCustomerRecoveryToMarkdown(detail.data)
            : (state.payload && state.payload.body_markdown) || body;
          writeCustomerRecoveryPdf(JsPDF, {
            title: state.title || toolMeta(state.slug).name || 'Customer Recovery',
            data: detail.data,
            markdown: crMd
          });
        } catch (eCr) {
          writeEdgeJsPdf(JsPDF, {
            title: state.title || toolMeta(state.slug).name || 'Customer Recovery',
            slug: 'customer-recovery',
            body: (typeof w.OporaCustomerRecoveryToMarkdown === 'function')
              ? w.OporaCustomerRecoveryToMarkdown(detail.data)
              : String(body || '')
          });
        }
        try {
          if (typeof w.gtag === 'function') {
            w.gtag('event', 'edge_pdf_download', { tool: 'customer-recovery', engine: 'jspdf' });
          }
        } catch (eG) {}
        toast('PDF downloaded');
        return true;
      }).catch(function (err) {
        toast((err && err.message) || 'PDF download failed. Please try again.', 'error');
        return false;
      });
    }
    if (detail.slug === 'margin-sentinel' && detail.data && typeof detail.data === 'object') {
      /* Boardroom single-page export, drawn from structured result data */
      toast('Downloading PDF…');
      return ensureJsPdf().then(function (JsPDF) {
        try {
          writeMarginSentinelPdf(JsPDF, {
            title: state.title || toolMeta(state.slug).name || 'Margin Sentinel',
            data: detail.data,
            loc: readMarginLocation()
          });
        } catch (eMs) {
          /* Never leave the user without a PDF — fall back to the markdown renderer */
          writeEdgeJsPdf(JsPDF, {
            title: state.title || toolMeta(state.slug).name || 'Margin Sentinel',
            slug: 'margin-sentinel',
            body: marginSentinelToMarkdown(detail.data)
          });
        }
        try {
          if (typeof w.gtag === 'function') {
            w.gtag('event', 'edge_pdf_download', { tool: 'margin-sentinel', engine: 'jspdf' });
          }
        } catch (eG) {}
        toast('PDF downloaded');
        return true;
      }).catch(function (err) {
        toast((err && err.message) || 'PDF download failed. Please try again.', 'error');
        return false;
      });
    }
    if (detail.slug === 'lost-bid-autopsy' && detail.data && typeof detail.data === 'object') {
      toast('Downloading PDF…');
      return ensureJsPdf().then(function (JsPDF) {
        try {
          writeLostBidAutopsyPdf(JsPDF, {
            title: state.title || toolMeta(state.slug).name || 'Lost Bid Autopsy',
            data: detail.data
          });
        } catch (eLba) {
          writeEdgeJsPdf(JsPDF, {
            title: state.title || toolMeta(state.slug).name || 'Lost Bid Autopsy',
            slug: 'lost-bid-autopsy',
            body: lostBidAutopsyToMarkdown(detail.data)
          });
        }
        try {
          if (typeof w.gtag === 'function') {
            w.gtag('event', 'edge_pdf_download', { tool: 'lost-bid-autopsy', engine: 'jspdf' });
          }
        } catch (eG) {}
        toast('PDF downloaded');
        return true;
      }).catch(function (err) {
        toast((err && err.message) || 'PDF download failed. Please try again.', 'error');
        return false;
      });
    }
    if (detail.slug === 'hire-right') {
      var hirePkg = resolveHireRightData(detail);
      if (hirePkg && typeof hirePkg === 'object') {
        toast('Downloading PDF…');
        return ensureJsPdf().then(function (JsPDF) {
          try {
            writeHireRightPdf(JsPDF, {
              title: state.title || toolMeta(state.slug).name || 'Hire Right',
              data: hirePkg
            });
          } catch (eHr) {
            writeEdgeJsPdf(JsPDF, {
              title: state.title || toolMeta(state.slug).name || 'Hire Right',
              slug: 'hire-right',
              body: hireRightToMarkdown(hirePkg)
            });
          }
          try {
            if (typeof w.gtag === 'function') {
              w.gtag('event', 'edge_pdf_download', { tool: 'hire-right', engine: 'jspdf' });
            }
          } catch (eG2) {}
          toast('PDF downloaded');
          return true;
        }).catch(function (err) {
          toast((err && err.message) || 'PDF download failed. Please try again.', 'error');
          return false;
        });
      }
    }
    if (!String(body).trim()) {
      body = proposalOnlyFromDom();
    }
    if (!String(body).trim()) {
      toast('Generate a result first, then download PDF.', 'error');
      return Promise.resolve(false);
    }
    toast('Downloading PDF…');
    return ensureJsPdf().then(function (JsPDF) {
      writeEdgeJsPdf(JsPDF, {
        title: state.title || toolMeta(state.slug).name || 'Opora document',
        slug: state.slug || 'document',
        body: body,
        cover: (state.slug === 'bid-drafter') ? readBidPdfCoverMeta() : null
      });
      try {
        if (typeof w.gtag === 'function') {
          w.gtag('event', 'edge_pdf_download', { tool: state.slug || 'edge', engine: 'jspdf' });
        }
      } catch (eG) {}
      toast('PDF downloaded');
      return true;
    }).catch(function (err) {
      toast((err && err.message) || 'PDF download failed. Please try again.', 'error');
      return false;
    });
  }

  function rebindLegacyPdfButtons(detail) {
    var scope = (detail && detail.outputEl) || d.getElementById('opResult') || d;
    if (!scope || !scope.querySelectorAll) return;
    var btns = scope.querySelectorAll('.opora-export-btn[data-export="PDF"], [data-export="PDF"], button[data-calc-pdf], .ot-xbtn[data-x="pdf"]');
    for (var i = 0; i < btns.length; i++) {
      (function (btn) {
        if (btn.getAttribute('data-opora-jspdf') === '1') return;
        btn.setAttribute('data-opora-jspdf', '1');
        btn.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
          defaultDownloadPdf(detail);
        }, true);
      })(btns[i]);
    }
  }

  function installEdgeExportGuards() {
    if (d.documentElement.getAttribute('data-opora-edge-export-guard') === '1') return;
    d.documentElement.setAttribute('data-opora-edge-export-guard', '1');

    function patchPrintApis() {
      if (!w.OporaTools) w.OporaTools = {};
      w.OporaTools._printBidPDF = function () {
        defaultDownloadPdf(_lastEdgeDetail || { slug: 'bid-drafter', outputEl: d.getElementById('opResult') });
      };
      w.OporaTools.printPage = function () {
        defaultDownloadPdf(_lastEdgeDetail || { outputEl: d.getElementById('opResult') });
      };
    }
    patchPrintApis();
    setTimeout(patchPrintApis, 400);
    setTimeout(patchPrintApis, 1500);

    /* Capture-phase: steal any Download/Export PDF click away from print dialogs */
    d.addEventListener('click', function (ev) {
      var el = ev.target && ev.target.closest && ev.target.closest('button, a, [role="button"]');
      if (!el) return;
      /* SOW keeps its own jsPDF path */
      if (el.id === 'sow-dock-pdf' || (el.closest && el.closest('#sow-float-dock, #sow-export-actions'))) return;

      var label = (el.textContent || el.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim().toLowerCase();
      var isPdf =
        el.id === 'opora-dock-pdf' ||
        el.getAttribute('data-export') === 'PDF' ||
        el.getAttribute('data-x') === 'pdf' ||
        el.hasAttribute('data-calc-pdf') ||
        label === 'download pdf' ||
        label === 'export pdf' ||
        /(^|\s)download pdf(\s|$)/.test(label) ||
        /(^|\s)export pdf(\s|$)/.test(label);
      if (!isPdf) return;

      var slug = pageToolSlug();
      var onEdge = !!(EDGE_DOCK_SLUGS[slug] || EDGE_PDF_SLUGS[slug] || d.querySelector('.d4-wrap--edge-wc'));
      if (!onEdge) return;
      if (slug === 'scope-of-work-generator') return;

      ev.preventDefault();
      ev.stopPropagation();
      if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
      defaultDownloadPdf(_lastEdgeDetail || { slug: slug, outputEl: d.getElementById('opResult') });
    }, true);

    /* Warm jsPDF so first click downloads immediately */
    ensureJsPdf().catch(function () {});
  }

  function defaultSaveDraft(detail) {
    var state = snapshot(detail || {});
    if (!w.OporaSave || typeof w.OporaSave.save !== 'function') {
      toast('Save is unavailable right now.', 'error');
      return Promise.resolve(false);
    }
    return w.OporaSave.save(state.slug, state.payload).then(function () {
      toast('Saved to your library');
      return true;
    }).catch(function (err) {
      if (err && err.status === 402) toast('You’ve hit your plan limit. Upgrade to save more.', 'error');
      else toast((err && err.message) || 'Save failed — please try again.', 'error');
      return false;
    });
  }

  /**
   * Floating action dock — SOW quality bar chrome for any document tool.
   * adapters: { copyAsText, saveDraft, openGuestSaveModal, downloadPDF,
   *   downloadPDFSignedIn, downloadPDFGuest, slug, detail, showPdf }
   */
  function mountDock(adapters) {
    adapters = adapters || {};
    var slug = adapters.slug || (adapters.detail && adapters.detail.slug) || '';
    var isSow = slug === 'scope-of-work-generator' || adapters.sow === true;
    var host = isSow
      ? (d.getElementById('sow-ab-mount') || ensureFloatDockHost({ mountId: 'sow-ab-mount', dockId: 'sow-float-dock' }))
      : ensureFloatDockHost({ mountId: adapters.mountId || 'opora-ab-mount', dockId: adapters.dockId || 'opora-float-dock' });
    if (!host) return null;

    var prior = host.querySelector('.opora-ab');
    if (prior) prior.parentNode.removeChild(prior);

    if (isSow) {
      var legacy = d.getElementById('sow-export-actions');
      if (legacy) {
        legacy.hidden = true;
        legacy.style.display = 'none';
      }
      var sowDock = d.getElementById('sow-float-dock');
      if (sowDock) sowDock.hidden = false;
    }

    var resultScope = (adapters.detail && adapters.detail.outputEl)
      || d.getElementById('opResult')
      || d.body;
    hideLegacyExportClusters(resultScope);
    var panel = resultScope.closest ? (resultScope.closest('.d4-result-panel') || resultScope.parentNode) : resultScope;
    if (panel && panel !== resultScope) hideLegacyExportClusters(panel);

    var meta = toolMeta(slug);
    var showPdf = adapters.showPdf != null ? !!adapters.showPdf : toolAllowsPdf(slug, meta);
    var bar = el('div', 'opora-ab opora-ab--header opora-ab--dock', { role: 'group', 'aria-label': 'Document actions' });

    var status = el('span', 'opora-ab__status');
    status.id = isSow ? 'sow-dock-status' : 'opora-dock-status';
    bar.appendChild(status);

    bar.appendChild(el('span', 'opora-ab__divider', { 'aria-hidden': 'true' }));

    var copyBtn = el('button', 'opora-ab__btn opora-ab__btn--ghost', { type: 'button' });
    copyBtn.innerHTML = ICON.text + '<span class="opora-ab__label">Copy Text</span>';
    copyBtn.title = isSow ? 'Copy SOW text for Word / email' : 'Copy result text for Word / email';
    copyBtn.addEventListener('click', function () {
      if (typeof adapters.copyAsText === 'function') adapters.copyAsText();
      else if (isSow && w.OporaScopeGen && typeof w.OporaScopeGen.copyAsText === 'function') w.OporaScopeGen.copyAsText();
      else defaultCopyText(adapters.detail || { slug: slug });
    });
    bar.appendChild(copyBtn);

    var saveBtn = el('button', 'opora-ab__btn opora-ab__btn--ghost', {
      type: 'button',
      id: isSow ? 'sow-dock-save' : 'opora-dock-save'
    });
    bar.appendChild(saveBtn);

    var pdfBtn = null;
    if (showPdf) {
      bar.appendChild(el('span', 'opora-ab__divider', { 'aria-hidden': 'true' }));
      pdfBtn = el('button', 'opora-ab__btn opora-ab__btn--primary', {
        type: 'button',
        id: isSow ? 'sow-dock-pdf' : 'opora-dock-pdf'
      });
      pdfBtn.innerHTML = ICON.download + '<span class="opora-ab__label">Download PDF</span>';
      bar.appendChild(pdfBtn);
    }

    function paintAuth() {
      var inAccount = isSignedIn();
      status.innerHTML = ICON.check + '<span class="opora-ab__label">Draft Auto-saved</span>';
      saveBtn.className = 'opora-ab__btn opora-ab__btn--ghost';
      saveBtn.disabled = false;
      saveBtn.innerHTML = ICON.save + '<span class="opora-ab__label">Save to Library</span>';
      saveBtn.title = isSow
        ? 'Save this SOW to your Opora library'
        : 'Save this result to your Opora library';
      if (inAccount) {
        status.title = 'Saved in this browser. Use Save to Library for cloud backup across devices.';
        if (pdfBtn) pdfBtn.title = isSow ? 'Download Scope of Work as PDF' : 'Download as PDF';
      } else {
        status.title = 'Saved automatically in this browser. Save to Library keeps it across devices.';
        if (pdfBtn) pdfBtn.title = 'Download PDF — optional email backup';
      }
    }
    paintAuth();

    function runLibrarySave() {
      var saveFn = typeof adapters.saveDraft === 'function'
        ? adapters.saveDraft
        : (isSow && w.OporaScopeGen && w.OporaScopeGen.saveDraft)
          ? w.OporaScopeGen.saveDraft
          : function () { return defaultSaveDraft(adapters.detail || { slug: slug }); };
      if (typeof saveFn !== 'function') return;
      saveBtn.disabled = true;
      saveBtn.innerHTML = ICON.save + '<span class="opora-ab__label">Saving…</span>';
      Promise.resolve(saveFn()).then(function (ok) {
        if (ok === false) {
          saveBtn.disabled = false;
          paintAuth();
          return;
        }
        saveBtn.innerHTML = ICON.check + '<span class="opora-ab__label">Saved to Library</span>';
        status.innerHTML = ICON.check + '<span class="opora-ab__label">Cloud Synced</span>';
        status.title = 'Saved to your Opora library';
        setTimeout(function () {
          saveBtn.disabled = false;
          saveBtn.innerHTML = ICON.save + '<span class="opora-ab__label">Save to Library</span>';
        }, 2800);
      }).catch(function () {
        saveBtn.disabled = false;
        paintAuth();
      });
    }

    saveBtn.addEventListener('click', function () {
      if (!isSignedIn()) {
        if (typeof adapters.openGuestSaveModal === 'function') {
          adapters.openGuestSaveModal();
          return;
        }
        if (isSow && w.OporaScopeGen && typeof w.OporaScopeGen.openSaveModal === 'function') {
          w.OporaScopeGen.openSaveModal();
          return;
        }
        var state = snapshot(adapters.detail || { slug: slug });
        openGuestSaveInPlace(state.slug, state.payload, {
          returnToTool: true,
          title: 'Save this result',
          tagline: 'Create a free account to edit, duplicate, and access this result across devices.',
          onAuthed: function () { runLibrarySave(); }
        });
        return;
      }
      runLibrarySave();
    });

    if (pdfBtn) {
      pdfBtn.addEventListener('click', function () {
        if (isSignedIn()) {
          if (typeof adapters.downloadPDFSignedIn === 'function') adapters.downloadPDFSignedIn();
          else if (isSow && w.OporaScopeGen && typeof w.OporaScopeGen.downloadPDF === 'function') w.OporaScopeGen.downloadPDF();
          else if (typeof adapters.downloadPDF === 'function') adapters.downloadPDF();
          else defaultDownloadPdf(adapters.detail || { slug: slug });
          return;
        }
        if (typeof adapters.downloadPDFGuest === 'function') adapters.downloadPDFGuest();
        else if (typeof adapters.downloadPDF === 'function') adapters.downloadPDF();
        else if (isSow && w.OporaScopeGen && typeof w.OporaScopeGen.downloadPDFAndConvert === 'function') {
          w.OporaScopeGen.downloadPDFAndConvert();
        } else if (isSow && w.OporaScopeGen && typeof w.OporaScopeGen.downloadPDF === 'function') {
          w.OporaScopeGen.downloadPDF();
        } else {
          defaultDownloadPdf(adapters.detail || { slug: slug });
        }
      });
    }

    host.appendChild(bar);
    d.addEventListener('clerk:loaded', paintAuth);
    w.addEventListener('opora:signed-in', paintAuth);
    w.addEventListener('opora:signed-out', paintAuth);
    return bar;
  }

  /* ── SOW floating dock — thin wrapper around mountDock ── */
  function mountSow(adapters) {
    adapters = adapters || {};
    adapters.sow = true;
    adapters.slug = adapters.slug || 'scope-of-work-generator';
    adapters.showPdf = true;
    return mountDock(adapters);
  }

  function injectWcBand(outputEl, slug) {
    if (!outputEl) return;
    var scope = (outputEl.closest && outputEl.closest('.d4-result-panel')) || outputEl;
    if (scope.querySelector && scope.querySelector('.opora-edge-wc-band, .d4-sow-wc-band')) return;
    var meta = toolMeta(slug);
    var ph = meta.primaryHandoff;
    if (!meta.soWhat && !meta.trust && !ph) return;
    var band = el('div', 'opora-edge-wc-band d4-sow-wc-band');
    band.style.padding = '0 22px 22px';
    if (meta.soWhat) {
      var sw = el('div', 'calc-d4-so-what');
      sw.textContent = meta.soWhat;
      band.appendChild(sw);
    }
    if (meta.trust) {
      var tr = el('p', 'calc-d4-trust');
      tr.textContent = meta.trust;
      band.appendChild(tr);
    }
    if (ph && (ph.href || ph.to)) {
      var wrap = el('div', 'calc-d4-primary-handoff');
      if (slug === 'hire-right') wrap.setAttribute('data-hire-handoffs', '');
      if (ph.hint) {
        var hint = el('p', 'calc-d4-primary-hint');
        hint.textContent = ph.hint;
        wrap.appendChild(hint);
      }
      var a = el('a', 'calc-d4-primary-cta', { href: ph.href || ('/pages/' + ph.to) });
      if (slug === 'hire-right') a.setAttribute('data-hire-handoff', '1099');
      a.textContent = ph.label || 'Continue →';
      wrap.appendChild(a);
      if (ph.secondary && (ph.secondary.href || ph.secondary.to)) {
        var sec = el('a', 'calc-d4-primary-secondary', {
          href: ph.secondary.href || ('/pages/' + ph.secondary.to)
        });
        if (slug === 'hire-right') sec.setAttribute('data-hire-handoff', 'bill-rate');
        sec.textContent = ph.secondary.label || 'Continue →';
        wrap.appendChild(sec);
      }
      band.appendChild(wrap);
    }
    outputEl.appendChild(band);
  }

  function bindDockVisibility(outputEl) {
    if (!outputEl || outputEl.getAttribute('data-opora-dock-vis') === '1') return;
    outputEl.setAttribute('data-opora-dock-vis', '1');
    function sync() {
      var dock = d.getElementById('opora-float-dock');
      if (!dock) return;
      var visible = !outputEl.hasAttribute('hidden') && outputEl.classList.contains('d4-visible');
      if (!visible) {
        visible = !outputEl.hasAttribute('hidden') && ((outputEl.textContent || '').trim().length > 40);
      }
      dock.hidden = !visible;
    }
    var obs = new MutationObserver(sync);
    obs.observe(outputEl, { attributes: true, attributeFilter: ['hidden', 'class'] });
    sync();
  }

  /* ── Edge dock on render (SOW uses mountSow from scope JS) ── */
  function mountEdgeDock(detail) {
    detail = detail || {};
    var slug = detail.slug || '';
    if (!slug || slug === 'scope-of-work-generator') return;
    if (!isEdgeDockSlug(slug)) return;
    var outputEl = detail.outputEl || d.getElementById('opResult');
    if (!outputEl) return;

    _lastEdgeDetail = detail;
    installEdgeExportGuards();

    /* Persist hire package on the result node so PDF still works after remounts */
    if (slug === 'hire-right' && detail.data && typeof detail.data === 'object' && outputEl) {
      try {
        outputEl._oporaHireData = detail.data;
        var docBodyHr = d.getElementById('opDocBody');
        if (docBodyHr) docBodyHr._oporaHireData = detail.data;
      } catch (eStore) {}
    }

    hideLegacyExportClusters(outputEl);
    var saveScope = (outputEl.closest && outputEl.closest('.d4-result-panel')) || outputEl.parentNode || outputEl;
    hideLegacyExportClusters(saveScope);
    injectWcBand(outputEl, slug);
    bindDockVisibility(outputEl);
    /* Prefetch Clerk so guest Save doesn't sit on "Loading sign-in…" */
    warmAuthForSave();
    rebindLegacyPdfButtons(detail);

    var preview = d.getElementById('d4PreviewZone');
    if (preview) preview.style.display = 'none';

    /* Same adapter contract as SOW mountSow — Copy / Save / Download PDF */
    mountDock({
      slug: slug,
      detail: detail,
      showPdf: toolAllowsPdf(slug, toolMeta(slug)),
      copyAsText: function () { defaultCopyText(detail); },
      saveDraft: function () { return defaultSaveDraft(detail); },
      downloadPDFSignedIn: function () { return defaultDownloadPdf(detail); },
      downloadPDFGuest: function () { return defaultDownloadPdf(detail); },
      downloadPDF: function () { return defaultDownloadPdf(detail); }
    });
  }

  /* ── legacy inline Edge bar (flag + allowlist) — kept for non-dock contexts ── */
  function mount(detail) {
    if (!flagOn()) return;
    var slugHint = (detail && detail.slug) || '';
    if (!isPilotSlug(slugHint)) return;
    /* Prefer floating dock chrome for document Edge tools */
    if (isEdgeDockSlug(slugHint) && slugHint !== 'scope-of-work-generator') {
      try { mountEdgeDock(detail); } catch (eDock) {}
      return;
    }
    var outputEl = detail.outputEl || d.getElementById('opResult');
    if (!outputEl) return;

    var state = snapshot(detail);
    var meta = toolMeta(state.slug);
    if (!isPilotSlug(state.slug)) return;

    // remove any prior bar for this render
    var prior = outputEl.querySelector('.opora-ab');
    if (prior) prior.parentNode.removeChild(prior);

    // hide legacy export rows (edge tools: .opora-export-btn; calculators: .calc-d4-export-row)
    var legacyBtn = outputEl.querySelector('.opora-export-btn');
    if (legacyBtn) {
      var row = legacyBtn.closest('div');
      if (row) row.style.display = 'none';
    }
    var calcRow = outputEl.querySelector('.calc-d4-export-row');
    if (calcRow) calcRow.style.display = 'none';

    // hide the legacy "Save to library / sign in free" bar — redundant with this
    // action bar's Save, and it hardcodes "sign in free" even when signed in.
    // Search the surrounding result panel since it's injected as a sibling.
    var saveScope = (outputEl.closest && outputEl.closest('.d4-result-panel')) || outputEl.parentNode || outputEl;
    if (saveScope && saveScope.querySelectorAll) {
      var legacySaves = saveScope.querySelectorAll('.opora-d4-save-bar, .ot-save-bar');
      for (var ls = 0; ls < legacySaves.length; ls++) legacySaves[ls].style.display = 'none';
    }

    var bar = el('div', 'opora-ab', { role: 'group', 'aria-label': 'Result actions' });

    /* Save (primary) — delegates to OporaSave */
    var saveBtn = el('button', 'opora-ab__btn opora-ab__btn--primary', { type: 'button' });
    var savedId = null;
    function paintSaveIdle() {
      saveBtn.innerHTML = ICON.save + '<span class="opora-ab__label">Save</span>';
      saveBtn.disabled = false;
    }
    paintSaveIdle();
    function runClassicSave() {
      if (!w.OporaSave || typeof w.OporaSave.save !== 'function') { toast('Save is unavailable right now.', 'error'); return; }
      saveBtn.disabled = true;
      saveBtn.innerHTML = ICON.save + '<span class="opora-ab__label">Saving…</span>';
      w.OporaSave.save(state.slug, state.payload).then(function (res) {
        savedId = (res && (res.id || (res.data && res.data.id))) || 'saved';
        saveBtn.className = 'opora-ab__btn opora-ab__btn--saved';
        saveBtn.innerHTML = ICON.check + '<span class="opora-ab__label">Saved</span>';
        toast('Saved to your library');
      }).catch(function (err) {
        saveBtn.disabled = false;
        paintSaveIdle();
        if (err && err.status === 402) { toast('You’ve hit your plan limit. Upgrade to save more.', 'error'); }
        else { toast((err && err.message) || 'Save failed — please try again.', 'error'); }
      });
    }

    saveBtn.addEventListener('click', function () {
      if (savedId) return;
      if (!isSignedIn()) {
        saveBtn.innerHTML = ICON.save + '<span class="opora-ab__label">Opening sign-in…</span>';
        openGuestSaveInPlace(state.slug, state.payload, {
          returnToTool: true,
          title: 'Save this result',
          tagline: 'Create a free account to edit, duplicate, and access this result across devices.',
          onAuthed: function () {
            paintSaveIdle();
            runClassicSave();
          }
        });
        return;
      }
      runClassicSave();
    });
    bar.appendChild(saveBtn);

    /* Share */
    var shareBtn = el('button', 'opora-ab__btn', { type: 'button' });
    function paintShare() {
      if (isSignedIn()) {
        shareBtn.className = 'opora-ab__btn';
        shareBtn.innerHTML = ICON.share + '<span class="opora-ab__label">Share</span>';
      } else {
        shareBtn.className = 'opora-ab__btn opora-ab__btn--locked';
        shareBtn.innerHTML = ICON.lock + '<span class="opora-ab__label">Share</span>';
      }
    }
    paintShare();
    shareBtn.addEventListener('click', function () {
      if (!isSignedIn()) {
        openGuestSaveInPlace(state.slug, state.payload, {
          returnToTool: true,
          title: 'Save this result',
          tagline: 'Create a free account to edit, duplicate, and access this result across devices.'
        });
        return;
      }
      if (!savedId) { toast('Save first, then share the link.'); return; }
      copyText(w.location.href, 'Link copied — paste it to share');
    });
    bar.appendChild(shareBtn);

    /* Export */
    var exportItems = [
      { label: 'Print / Save as PDF', icon: 'print', onClick: printResult },
      { label: 'Copy as text', icon: 'text', onClick: function () { copyText(state.payload.body_markdown, 'Result copied as text'); } },
      { label: 'Copy as JSON', icon: 'json', onClick: function () { copyText(JSON.stringify(state.data, null, 2), 'Result copied as JSON'); } }
    ];
    var exportWrap;
    if (isSignedIn()) {
      exportWrap = menuButton('Export', 'download', exportItems);
    } else {
      exportWrap = el('div', 'opora-ab__menu-wrap');
      var exBtn = el('button', 'opora-ab__btn opora-ab__btn--locked', { type: 'button' });
      exBtn.innerHTML = ICON.lock + '<span class="opora-ab__label">Export</span>';
      exBtn.addEventListener('click', function () {
        openGuestSaveInPlace(state.slug, state.payload, {
          returnToTool: true,
          title: 'Save this result',
          tagline: 'Create a free account to edit, duplicate, and access this result across devices.'
        });
      });
      exportWrap.appendChild(exBtn);
    }
    bar.appendChild(exportWrap);

    /* Reset */
    var resetBtn = el('button', 'opora-ab__btn', { type: 'button' });
    resetBtn.innerHTML = ICON.reset + '<span class="opora-ab__label">Reset</span>';
    resetBtn.addEventListener('click', function () {
      if (!w.confirm('Clear this result and start over?')) return;
      var nodes = d.querySelectorAll('[id^="opf_"]');
      for (var i = 0; i < nodes.length; i++) {
        var el2 = nodes[i];
        if (el2.id === 'opf_' || el2.name === '_tool_slug') continue;
        if (el2.type === 'checkbox' || el2.type === 'radio') el2.checked = false;
        else if (el2.tagName === 'SELECT') el2.selectedIndex = 0;
        else el2.value = '';
      }
      var convo = d.getElementById('opConvoInput'); if (convo) convo.value = '';
      var result = d.getElementById('opResult');
      if (result) { result.setAttribute('hidden', ''); result.classList.remove('on', 'd4-visible'); }
      var preview = d.getElementById('d4PreviewZone'); if (preview) preview.style.display = '';
      var dockHide = d.getElementById('opora-float-dock'); if (dockHide) dockHide.hidden = true;
      var first = d.querySelector('[id^="opf_"]'); if (first && first.focus) first.focus();
    });
    bar.appendChild(resetBtn);

    bar.appendChild(el('div', 'opora-ab__spacer'));

    /* Send to pipeline — §6/§4.2 opt-in deal creation (replaces Ask Opora auto-create) */
    function sendToPipeline() {
      if (!isSignedIn()) {
        openGuestSaveInPlace(state.slug, state.payload, {
          returnToTool: true,
          title: 'Save this result',
          tagline: 'Create a free account to edit, duplicate, and access this result across devices.'
        });
        return;
      }
      var edge = w.OporaEdge;
      if (!edge || typeof edge.fetchApi !== 'function') { toast('Pipeline is unavailable right now.', 'error'); return; }
      var title = (state.payload && (state.payload.title || state.payload.name)) || ((meta.name || 'Tool') + ' result');
      var preview = (state.payload && state.payload.body_markdown ? String(state.payload.body_markdown) : '').slice(0, 2000);
      var payload = { name: String(title).slice(0, 200), stage: 'prospect', notes: preview };
      if (savedId && savedId !== 'saved') {
        if (state.slug === 'bid-drafter') payload.bid_artifact_id = savedId;
        else if (state.slug === 'rfp-decoder') payload.rfp_artifact_id = savedId;
      }
      toast('Adding to pipeline…');
      edge.fetchApi('/api/pipeline/create', { method: 'POST', body: JSON.stringify(payload) })
        .then(function (r) { return r && r.ok ? r.json() : Promise.reject(r); })
        .then(function () { toast('Added to your pipeline'); })
        .catch(function () { toast('Could not add to pipeline — please try again.', 'error'); });
    }

    /* More */
    var moreItems = [
      { label: 'Print', icon: 'print', onClick: printResult },
      { label: 'Copy link to this tool', icon: 'link', onClick: function () { copyText(w.location.href, 'Link copied'); } }
    ];
    var handoffs = meta.handoffs || [];
    if (handoffs.length) {
      moreItems.push({ sep: true });
      moreItems.push({ heading: 'Send to another tool' });
      handoffs.forEach(function (h) {
        moreItems.push({ label: h.label, icon: 'send', href: handoffUrl(h.to, h.carry, state) });
      });
    }
    moreItems.push({ sep: true });
    moreItems.push({ label: 'Send to pipeline', icon: 'send', onClick: sendToPipeline });
    moreItems.push({ sep: true });
    moreItems.push({ label: 'Report an issue', icon: 'flag', href: 'mailto:support@oporasupply.com?subject=' +
      encodeURIComponent('Issue with ' + meta.name) });
    bar.appendChild(menuButton('More', 'more', moreItems));

    // place the bar right after the document body, before any (now-hidden) legacy row
    var docBody = outputEl.querySelector('#opDocBody');
    if (docBody && docBody.parentNode === outputEl) {
      if (docBody.nextSibling) outputEl.insertBefore(bar, docBody.nextSibling);
      else outputEl.appendChild(bar);
    } else {
      outputEl.appendChild(bar);
    }

    // keep lock affordances in sync if auth resolves after mount
    function resync() { paintShare(); }
    d.addEventListener('clerk:loaded', resync);
    w.addEventListener('opora:signed-in', resync);
  }

  d.addEventListener('opora:tool-rendered', function (ev) {
    try {
      var detail = ev.detail || {};
      var slug = detail.slug || '';
      if (isEdgeDockSlug(slug) && slug !== 'scope-of-work-generator') {
        mountEdgeDock(detail);
        return;
      }
      mount(detail);
    } catch (e) { /* never break the tool */ }
  });

  /* Install export guards immediately on Edge tool pages (before first result) */
  try {
    var bootSlug = pageToolSlug();
    if (EDGE_DOCK_SLUGS[bootSlug] || EDGE_PDF_SLUGS[bootSlug] || d.querySelector('.d4-wrap--edge-wc')) {
      installEdgeExportGuards();
    }
  } catch (eBoot) {}

  w.OporaActionBar = {
    mount: mount,
    mountDock: mountDock,
    mountSow: mountSow,
    mountEdgeDock: mountEdgeDock,
    downloadPDF: defaultDownloadPdf,
    copyAsText: defaultCopyText,
    saveDraft: defaultSaveDraft,
    guestSaveThenAuth: guestSaveThenAuth,
    openGuestSaveInPlace: openGuestSaveInPlace,
    stageGuestSave: stageGuestSave,
    isSignedIn: isSignedIn,
    getLeadEmail: getLeadEmail,
    rememberLeadEmail: rememberLeadEmail,
    flagOn: flagOn,
    isPilotSlug: isPilotSlug,
    isEdgeDockSlug: isEdgeDockSlug,
    serializeOutput: serializeOutput,
    rfpDecoderToMarkdown: rfpDecoderToMarkdown,
    marginSentinelToMarkdown: marginSentinelToMarkdown,
    lostBidAutopsyToMarkdown: lostBidAutopsyToMarkdown,
    hireRightToMarkdown: hireRightToMarkdown,
    marginSentinelPdfModel: marginSentinelPdfModel,
    htmlToMd: htmlToMd
  };

})(window, document);
